import importDataController from './importData.controller';

export default angular
  .module('st.Import', ['st.Core', 'angular-cache'])
  .controller('importDataController', importDataController)
  .service(
    'importService',
    ($window, $http, $rootScope, CacheFactory, dataService, uiService, IMPORT) => {
      let cache;
      if (!CacheFactory.get(IMPORT.CACHE.NAME)) {
        cache = CacheFactory(IMPORT.CACHE.NAME, IMPORT.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || IMPORT.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        createImport: (params) =>
          dataService.apiRequest(null, null, true, null, $http.post, IMPORT.API.CREATE, {
            params
          }),
        readImport: (params) =>
          dataService.apiRequest(null, null, true, null, $http.get, IMPORT.API.READ, {
            params
          }),
        deleteImport: (params) =>
          dataService.apiRequest(null, null, true, null, $http.delete, IMPORT.API.DELETE, {
            params
          }),
        revertImport: (params) =>
          dataService.apiRequest(null, null, true, null, $http.post, IMPORT.API.REVERT, {
            params
          }),
        downloadUrl: (params) => {
          dataService
            .apiRequest(null, null, true, null, $http.get, IMPORT.API.DOWNLOAD_URL, {
              params
            })
            .then((res) => {
              if (res && res.status) {
                uiService.toast({
                  text: {
                    p1: 'Initializing',
                    p2: 'import',
                    p3: 'download'
                  },
                  progress: true
                });
                $window.location.href = res.url;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Failed to',
                    p2: 'retrieve',
                    p3: 'import URL'
                  },
                  warn: true
                });
              }
            });
        },
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getAvailable'),
            params?.ignoreCache === true,
            null,
            $http.get,
            IMPORT.API.AVAILABLE,
            { params }
          )
      };
    }
  )
  .constant('IMPORT', {
    API: {
      CREATE: '/api/v1/import/create/',
      READ: '/api/v1/import/read/',
      DELETE: '/api/v1/import/delete/',
      REVERT: '/api/v1/import/revert/',
      UPLOAD: '/api/v1/import/upload/',
      DOWNLOAD_URL: '/api/v1/import/download-url/',
      AVAILABLE: '/api/v1/imports/available/'
    },
    LIMITS: {
      MULTIPLE: false,
      ALLOWED_MIME: 'text/csv',
      ALLOWED_EXTENSIONS: '.csv'
    },
    MERGE_FIELDS: {
      TICKET: [
        {
          name: 'Deal - Basic information - Title',
          key: 'name',
          type: 'string',
          required: true,
          weight: 1
        },
        {
          name: 'Deal - Basic information - Owner',
          key: 'idOwner',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Basic information - Stage',
          key: 'idStage',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Basic information - Value',
          key: 'values.onceOff',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Basic information - Expected close date',
          key: 'values.onceOffDueDate',
          type: 'date',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Basic information - Summary notes',
          key: 'description',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Basic information - Date deal won',
          key: 'wonTimeStamp',
          type: 'date',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Basic information - Date deal lost',
          key: 'lostTimeStamp',
          type: 'date',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Basic information - Date deal paused',
          key: 'frozenTimeStamp',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Basic information - Deal date created',
          key: 'timeStamp',
          type: 'date',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Asset finance - Lender',
          key: 'assetFinance.asset.lender',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Asset finance - Equipment make and model',
          key: 'assetFinance.asset.equipmentMakeAndModel',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Asset finance - Equipment value',
          key: 'assetFinance.asset.equipmentValue',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Asset finance - Build year',
          key: 'assetFinance.asset.buildYear',
          type: 'date',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Asset finance - Equipment conditions',
          key: 'assetFinance.asset.equipmentCondition',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Asset finance - Finance amount',
          key: 'assetFinance.finance.financeAmount',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Asset finance - Account number',
          key: 'assetFinance.finance.accountNumber',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Asset finance - Interest rate',
          key: 'assetFinance.finance.interestRate',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Asset finance - Ballon amount',
          key: 'assetFinance.finance.balloonAmount',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Asset finance - Broker margin',
          key: 'assetFinance.finance.brokerMargin',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Asset finance - Finance term',
          key: 'assetFinance.finance.financeTeam',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Asset finance - Application fees',
          key: 'assetFinance.finance.applicationFees',
          type: 'currency',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Insurance - Insurer name',
          key: 'insurance.insurerName',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Insurance - Cover amount',
          key: 'insurance.coverAmount',
          type: 'number',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Insurance - Policy number',
          key: 'insurance.policyNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Insurance - Product type',
          key: 'insurance.productType',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Insurance - Premium start date',
          key: 'insurance.premiumStartDate',
          type: 'date',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Insurance - Premium end date',
          key: 'insurance.premiumEndDate',
          type: 'date',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Insurance - Premium amount in super',
          key: 'insurance.premiumAmountInSuper',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Insurance - Premium amount out super',
          key: 'insurance.premiumAmountOutSuper',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Insurance - Premium frequency',
          key: 'insurance.premiumFrequency',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Insurance - Policy notes',
          key: 'insurance.policyNotes',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Home loan security - Address 1',
          key: 'loan.dealLoanSecuritySplit1.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Home loan security - Value 1',
          key: 'loan.dealLoanSecuritySplit1.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Home loan security - Security type 1',
          key: 'loan.dealLoanSecuritySplit1.securityType',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Home loan security - Transaction type 1',
          key: 'loan.dealLoanSecuritySplit1.transactionType',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Home loan security - Ownership type 1',
          key: 'loan.dealLoanSecuritySplit1.ownershipType',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Home loan security - Address 2',
          key: 'loan.dealLoanSecuritySplit2.address.formatted',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Home loan security - Value 2',
          key: 'loan.dealLoanSecuritySplit2.value',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Home loan security - Security type 2',
          key: 'loan.dealLoanSecuritySplit2.securityType',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Home loan security - Transaction type 2',
          key: 'loan.dealLoanSecuritySplit2.transactionType',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Home loan security - Ownership type 2',
          key: 'loan.dealLoanSecuritySplit2.ownershipType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Home loan security - Address 3',
          key: 'loan.dealLoanSecuritySplit3.address.formatted',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Home loan security - Value 3',
          key: 'loan.dealLoanSecuritySplit3.value',
          type: 'currency',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Home loan security - Security type 3',
          key: 'loan.dealLoanSecuritySplit3.securityType',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Home loan security - Transaction type 3',
          key: 'loan.dealLoanSecuritySplit3.transactionType',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Home loan security - Ownership type 3',
          key: 'loan.dealLoanSecuritySplit3.ownershipType',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Home loan split - Lender',
          key: 'loan.details.lender',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Home loan split - Lender other name',
          key: 'loan.details.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Home loan split - Application number',
          key: 'loan.details.loanApplicationNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Home loan split - Term',
          key: 'loan.details.term',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Home loan split - LVR',
          key: 'loan.details.lvr',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Home loan split - LMI capitalised',
          key: 'loan.details.lmiCapitalised',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Home loan split - LMI',
          key: 'loan.details.lmi',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Home loan split - Offset',
          key: 'loan.details.offset',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Home loan split - Net banking',
          key: 'loan.details.netBanking',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Home loan split - Credit card',
          key: 'loan.details.creditCard',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Home loan split - Credit card limit',
          key: 'loan.details.creditCardLimit',
          type: 'currency',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Home loan split - Amount 1',
          key: 'loan.details.dealLoanDetailsSplit1.amount',
          type: 'currency',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Home loan split - Product 1',
          key: 'loan.details.dealLoanDetailsSplit1.product',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Home loan split - Interest rate 1',
          key: 'loan.details.dealLoanDetailsSplit1.interestRate',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Home loan split - Loan purpose 1',
          key: 'loan.details.dealLoanDetailsSplit1.loanType',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Home loan split - Interest rate type 1',
          key: 'loan.details.dealLoanDetailsSplit1.interestRateType',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Home loan split - Fixed years 1',
          key: 'loan.details.dealLoanDetailsSplit1.fixedYears',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Home loan split - Repayment type 1',
          key: 'loan.details.dealLoanDetailsSplit1.repaymentType',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Home loan split - I/O years 1',
          key: 'loan.details.dealLoanDetailsSplit1.ioYears',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Home loan split - Line of credit 1',
          key: 'loan.details.dealLoanDetailsSplit1.lineOfCredit',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Home loan split - Amount 2',
          key: 'loan.details.dealLoanDetailsSplit2.amount',
          type: 'currency',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Home loan split - Product 2',
          key: 'loan.details.dealLoanDetailsSplit2.product',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Home loan split - Interest rate 2',
          key: 'loan.details.dealLoanDetailsSplit2.interestRate',
          type: 'number',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Home loan split - Loan purpose 2',
          key: 'loan.details.dealLoanDetailsSplit2.loanType',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Home loan split - Interest rate type 2',
          key: 'loan.details.dealLoanDetailsSplit2.interestRateType',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Home loan split - Fixed years 2',
          key: 'loan.details.dealLoanDetailsSplit2.fixedYears',
          type: 'string',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Home loan split - Repayment type 2',
          key: 'loan.details.dealLoanDetailsSplit2.repaymentType',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Home loan split - I/O years 2',
          key: 'loan.details.dealLoanDetailsSplit2.ioYears',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Home loan split - Line of credit 2',
          key: 'loan.details.dealLoanDetailsSplit2.lineOfCredit',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Home loan split - Amount 3',
          key: 'loan.details.dealLoanDetailsSplit3.amount',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Home loan split - Product 3',
          key: 'loan.details.dealLoanDetailsSplit3.product',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Home loan split - Interest rate 3',
          key: 'loan.details.dealLoanDetailsSplit3.interestRate',
          type: 'number',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Home loan split - Loan purpose 3',
          key: 'loan.details.dealLoanDetailsSplit3.loanType',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Home loan split - Interest rate type 3',
          key: 'loan.details.dealLoanDetailsSplit3.interestRateType',
          type: 'string',
          required: false,
          weight: 34
        },
        {
          name: 'Deal - Home loan split - Fixed years 3',
          key: 'loan.details.dealLoanDetailsSplit3.fixedYears',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Deal - Home loan split - Repayment type 3',
          key: 'loan.details.dealLoanDetailsSplit3.repaymentType',
          type: 'string',
          required: false,
          weight: 36
        },
        {
          name: 'Deal - Home loan split - I/O years 3',
          key: 'loan.details.dealLoanDetailsSplit3.ioYears',
          type: 'string',
          required: false,
          weight: 37
        },
        {
          name: 'Deal - Home loan split - Line of credit 3',
          key: 'loan.details.dealLoanDetailsSplit3.lineOfCredit',
          type: 'string',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Home loan fees - Valuation fee',
          key: 'loan.fees.valuation',
          type: 'currency',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Home loan fees - Solicitor fee',
          key: 'loan.fees.solicitor',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Home loan fees - Settlement fee',
          key: 'loan.fees.settlement',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Home loan fees - Package Annual fee',
          key: 'loan.fees.package',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Home loan fees - Package Monthly fee',
          key: 'loan.fees.packageMonthly',
          type: 'currency',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Home loan fees - Rate Lock fee',
          key: 'loan.fees.rate',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Home loan fees - Other fee',
          key: 'loan.fees.other',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Home loan fees - Application fee',
          key: 'loan.fees.application',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Expenses household 1 - Contacts',
          key: 'expenses.household1.idContacts',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Expenses household 1 - Food & supermarket',
          key: 'expenses.household1.householdExpenses1.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Expenses household 1 - Food & supermarket frequency',
          key: 'expenses.household1.householdExpenses1.frequency',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Expenses household 1 - Coffees, lunches takeaway',
          key: 'expenses.household1.householdExpenses2.value',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Expenses household 1 - Coffees, lunches takeaway frequency',
          key: 'expenses.household1.householdExpenses2.frequency',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Expenses household 1 - Entertainment',
          key: 'expenses.household1.householdExpenses3.value',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Expenses household 1 - Entertainment frequency',
          key: 'expenses.household1.householdExpenses3.frequency',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Expenses household 1 - Domestic holidays',
          key: 'expenses.household1.householdExpenses4.value',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Expenses household 1 - Domestic holidays frequency',
          key: 'expenses.household1.householdExpenses4.frequency',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Expenses household 1 - Gym fees, sport, other health & wellness',
          key: 'expenses.household1.householdExpenses5.value',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Expenses household 1 - Gym fees, sport, other health & wellness frequency',
          key: 'expenses.household1.householdExpenses5.frequency',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Expenses household 1 - Cigarettes & alcohol',
          key: 'expenses.household1.householdExpenses6.value',
          type: 'currency',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Expenses household 1 - Cigarettes & alcohol frequency',
          key: 'expenses.household1.householdExpenses6.frequency',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Expenses household 1 - Clothing, shoes & accessories',
          key: 'expenses.household1.householdExpenses7.value',
          type: 'currency',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Expenses household 1 - Clothing, shoes & accessories frequency',
          key: 'expenses.household1.householdExpenses7.frequency',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Expenses household 1 - Hairdressing & grooming',
          key: 'expenses.household1.householdExpenses8.value',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Expenses household 1 - Hairdressing & grooming frequency',
          key: 'expenses.household1.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Expenses household 1 - Phone, Internet & pay TV',
          key: 'expenses.household1.householdExpenses9.value',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Expenses household 1 - Phone, Internet & pay TV frequency',
          key: 'expenses.household1.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Expenses household 1 - Media streaming & subscription services',
          key: 'expenses.household1.householdExpenses10.value',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Expenses household 1 - Media streaming & subscription services frequency',
          key: 'expenses.household1.householdExpenses10.frequency',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Expenses household 1 - Gifts & celebrations',
          key: 'expenses.household1.householdExpenses11.value',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Expenses household 1 - Gifts & celebrations frequency',
          key: 'expenses.household1.householdExpenses11.frequency',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Expenses household 1 - Other discretionary expenses',
          key: 'expenses.household1.householdExpenses12.value',
          type: 'currency',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Expenses household 1 - Other discretionary expenses frequency',
          key: 'expenses.household1.householdExpenses12.frequency',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Expenses household 1 - Recreational vehicle running costs',
          key: 'expenses.household1.householdExpenses13.value',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Expenses household 1 - Recreational vehicle running costs frequency',
          key: 'expenses.household1.householdExpenses13.frequency',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Expenses household 1 - Pets',
          key: 'expenses.household1.householdExpenses14.value',
          type: 'currency',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Expenses household 1 - Pets frequency',
          key: 'expenses.household1.householdExpenses14.frequency',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Expenses household 1 - Public education costs',
          key: 'expenses.household1.householdExpenses15.value',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Expenses household 1 - Public education costs frequency',
          key: 'expenses.household1.householdExpenses15.frequency',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Expenses household 1 - Private education costs',
          key: 'expenses.household1.householdExpenses16.value',
          type: 'currency',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Expenses household 1 - Private education costs frequency',
          key: 'expenses.household1.householdExpenses16.frequency',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Expenses household 1 - Tertiary & vocational education',
          key: 'expenses.household1.householdExpenses17.value',
          type: 'currency',
          required: false,
          weight: 34
        },
        {
          name: 'Deal - Expenses household 1 - Tertiary & vocational education frequency',
          key: 'expenses.household1.householdExpenses17.frequency',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Deal - Expenses household 1 - Childcare',
          key: 'expenses.household1.householdExpenses18.value',
          type: 'currency',
          required: false,
          weight: 36
        },
        {
          name: 'Deal - Expenses household 1 - Childcare frequency',
          key: 'expenses.household1.householdExpenses18.frequency',
          type: 'string',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 1 - Child or spousal maintenance',
          key: 'expenses.household1.householdExpenses19.value',
          type: 'currency',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 1 - Child or spousal maintenance frequency',
          key: 'expenses.household1.householdExpenses19.frequency',
          type: 'string',
          required: false,
          weight: 39
        },
        {
          name: 'Deal - Expenses household 1 - Private health insurance',
          key: 'expenses.household1.householdExpenses20.value',
          type: 'currency',
          required: false,
          weight: 40
        },
        {
          name: 'Deal - Expenses household 1 - Private health insurance frequency',
          key: 'expenses.household1.householdExpenses20.frequency',
          type: 'string',
          required: false,
          weight: 41
        },
        {
          name: 'Deal - Expenses household 1 - Doctor, dentist, pharmacy, glasses',
          key: 'expenses.household1.householdExpenses21.value',
          type: 'currency',
          required: false,
          weight: 42
        },
        {
          name: 'Deal - Expenses household 1 - Doctor, dentist, pharmacy, glasses frequency',
          key: 'expenses.household1.householdExpenses21.frequency',
          type: 'string',
          required: false,
          weight: 43
        },
        {
          name: 'Deal - Expenses household 1 - Life, trauma, income insurance',
          key: 'expenses.household1.householdExpenses22.value',
          type: 'currency',
          required: false,
          weight: 44
        },
        {
          name: 'Deal - Expenses household 1 - Life, trauma, income insurance frequency',
          key: 'expenses.household1.householdExpenses22.frequency',
          type: 'string',
          required: false,
          weight: 45
        },
        {
          name: 'Deal - Expenses household 1 - Essential vehicle running cost',
          key: 'expenses.household1.householdExpenses23.value',
          type: 'currency',
          required: false,
          weight: 46
        },
        {
          name: 'Deal - Expenses household 1 - Essential vehicle running cost frequency',
          key: 'expenses.household1.householdExpenses23.frequency',
          type: 'string',
          required: false,
          weight: 47
        },
        {
          name: 'Deal - Expenses household 1 - Public transport, taxis & ride share, commuting airfares',
          key: 'expenses.household1.householdExpenses24.value',
          type: 'currency',
          required: false,
          weight: 48
        },
        {
          name: 'Deal - Expenses household 1 - Public transport, taxis & ride share, commuting airfares frequency',
          key: 'expenses.household1.householdExpenses24.frequency',
          type: 'string',
          required: false,
          weight: 49
        },
        {
          name: 'Deal - Expenses household 1 - Essential vehicle insurance',
          key: 'expenses.household1.householdExpenses25.value',
          type: 'currency',
          required: false,
          weight: 50
        },
        {
          name: 'Deal - Expenses household 1 - Essential vehicle insurance frequency',
          key: 'expenses.household1.householdExpenses25.frequency',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Deal - Expenses household 1 - Current rent expense',
          key: 'expenses.household1.householdExpenses26.value',
          type: 'currency',
          required: false,
          weight: 52
        },
        {
          name: 'Deal - Expenses household 1 - Current rent expense frequency',
          key: 'expenses.household1.householdExpenses26.frequency',
          type: 'string',
          required: false,
          weight: 53
        },
        {
          name: 'Deal - Expenses household 1 - Ongoing board expense',
          key: 'expenses.household1.householdExpenses27.value',
          type: 'currency',
          required: false,
          weight: 54
        },
        {
          name: 'Deal - Expenses household 1 - Ongoing board expense frequency',
          key: 'expenses.household1.householdExpenses27.frequency',
          type: 'string',
          required: false,
          weight: 55
        },
        {
          name: 'Deal - Expenses household 1 - Primary residence running costs',
          key: 'expenses.household1.householdExpenses28.value',
          type: 'currency',
          required: false,
          weight: 56
        },
        {
          name: 'Deal - Expenses household 1 - Primary residence running costs frequency',
          key: 'expenses.household1.householdExpenses28.frequency',
          type: 'string',
          required: false,
          weight: 57
        },
        {
          name: 'Deal - Expenses household 1 - Primary residence body corp',
          key: 'expenses.household1.householdExpenses29.value',
          type: 'currency',
          required: false,
          weight: 58
        },
        {
          name: 'Deal - Expenses household 1 - Primary residence body corp frequency',
          key: 'expenses.household1.householdExpenses29.frequency',
          type: 'string',
          required: false,
          weight: 59
        },
        {
          name: 'Deal - Expenses household 1 - Secondary residence running costs',
          key: 'expenses.household1.householdExpenses30.value',
          type: 'currency',
          required: false,
          weight: 60
        },
        {
          name: 'Deal - Expenses household 1 - Secondary residence running costs frequency',
          key: 'expenses.household1.householdExpenses30.frequency',
          type: 'string',
          required: false,
          weight: 61
        },
        {
          name: 'Deal - Expenses household 1 - Secondary residence body corp',
          key: 'expenses.household1.householdExpenses31.value',
          type: 'currency',
          required: false,
          weight: 62
        },
        {
          name: 'Deal - Expenses household 1 - Secondary residence body corp frequency',
          key: 'expenses.household1.householdExpenses31.frequency',
          type: 'string',
          required: false,
          weight: 63
        },
        {
          name: 'Deal - Expenses household 1 - Investment property running costs',
          key: 'expenses.household1.householdExpenses32.value',
          type: 'currency',
          required: false,
          weight: 64
        },
        {
          name: 'Deal - Expenses household 1 - Investment property running costs frequency',
          key: 'expenses.household1.householdExpenses32.frequency',
          type: 'string',
          required: false,
          weight: 65
        },
        {
          name: 'Deal - Expenses household 1 - Investment property body corp',
          key: 'expenses.household1.householdExpenses33.value',
          type: 'currency',
          required: false,
          weight: 66
        },
        {
          name: 'Deal - Expenses household 1 - Investment property body corp frequency',
          key: 'expenses.household1.householdExpenses33.frequency',
          type: 'string',
          required: false,
          weight: 67
        },
        {
          name: 'Deal - Expenses household 2 - Contacts',
          key: 'expenses.household2.idContacts',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Expenses household 2 - Food & supermarket',
          key: 'expenses.household2.householdExpenses1.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Expenses household 2 - Food & supermarket frequency',
          key: 'expenses.household2.householdExpenses1.frequency',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Expenses household 2 - Coffees, lunches takeaway',
          key: 'expenses.household2.householdExpenses2.value',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Expenses household 2 - Coffees, lunches takeaway frequency',
          key: 'expenses.household2.householdExpenses2.frequency',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Expenses household 2 - Entertainment',
          key: 'expenses.household2.householdExpenses3.value',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Expenses household 2 - Entertainment frequency',
          key: 'expenses.household2.householdExpenses3.frequency',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Expenses household 2 - Domestic holidays',
          key: 'expenses.household2.householdExpenses4.value',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Expenses household 2 - Domestic holidays frequency',
          key: 'expenses.household2.householdExpenses4.frequency',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Expenses household 2 - Gym fees, sport, other health & wellness',
          key: 'expenses.household2.householdExpenses5.value',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Expenses household 2 - Gym fees, sport, other health & wellness frequency',
          key: 'expenses.household2.householdExpenses5.frequency',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Expenses household 2 - Cigarettes & alcohol',
          key: 'expenses.household2.householdExpenses6.value',
          type: 'currency',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Expenses household 2 - Cigarettes & alcohol frequency',
          key: 'expenses.household2.householdExpenses6.frequency',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Expenses household 2 - Clothing, shoes & accessories',
          key: 'expenses.household2.householdExpenses7.value',
          type: 'currency',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Expenses household 2 - Clothing, shoes & accessories frequency',
          key: 'expenses.household2.householdExpenses7.frequency',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Expenses household 2 - Hairdressing & grooming',
          key: 'expenses.household2.householdExpenses8.value',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Expenses household 2 - Hairdressing & grooming frequency',
          key: 'expenses.household2.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Expenses household 2 - Phone, Internet & pay TV',
          key: 'expenses.household2.householdExpenses9.value',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Expenses household 2 - Phone, Internet & pay TV frequency',
          key: 'expenses.household2.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Expenses household 2 - Media streaming & subscription services',
          key: 'expenses.household2.householdExpenses10.value',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Expenses household 2 - Media streaming & subscription services frequency',
          key: 'expenses.household2.householdExpenses10.frequency',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Expenses household 2 - Gifts & celebrations',
          key: 'expenses.household2.householdExpenses11.value',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Expenses household 2 - Gifts & celebrations frequency',
          key: 'expenses.household2.householdExpenses11.frequency',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Expenses household 2 - Other discretionary expenses',
          key: 'expenses.household2.householdExpenses12.value',
          type: 'currency',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Expenses household 2 - Other discretionary expenses frequency',
          key: 'expenses.household2.householdExpenses12.frequency',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Expenses household 2 - Recreational vehicle running costs',
          key: 'expenses.household2.householdExpenses13.value',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Expenses household 2 - Recreational vehicle running costs frequency',
          key: 'expenses.household2.householdExpenses13.frequency',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Expenses household 2 - Pets',
          key: 'expenses.household2.householdExpenses14.value',
          type: 'currency',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Expenses household 2 - Pets frequency',
          key: 'expenses.household2.householdExpenses14.frequency',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Expenses household 2 - Public education costs',
          key: 'expenses.household2.householdExpenses15.value',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Expenses household 2 - Public education costs frequency',
          key: 'expenses.household2.householdExpenses15.frequency',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Expenses household 2 - Private education costs',
          key: 'expenses.household2.householdExpenses16.value',
          type: 'currency',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Expenses household 2 - Private education costs frequency',
          key: 'expenses.household2.householdExpenses16.frequency',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Expenses household 2 - Tertiary & vocational education',
          key: 'expenses.household2.householdExpenses17.value',
          type: 'currency',
          required: false,
          weight: 34
        },
        {
          name: 'Deal - Expenses household 2 - Tertiary & vocational education frequency',
          key: 'expenses.household2.householdExpenses17.frequency',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Deal - Expenses household 2 - Childcare',
          key: 'expenses.household2.householdExpenses18.value',
          type: 'currency',
          required: false,
          weight: 36
        },
        {
          name: 'Deal - Expenses household 2 - Childcare frequency',
          key: 'expenses.household2.householdExpenses18.frequency',
          type: 'string',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 2 - Child or spousal maintenance',
          key: 'expenses.household2.householdExpenses19.value',
          type: 'currency',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 2 - Child or spousal maintenance frequency',
          key: 'expenses.household2.householdExpenses19.frequency',
          type: 'string',
          required: false,
          weight: 39
        },
        {
          name: 'Deal - Expenses household 2 - Private health insurance',
          key: 'expenses.household2.householdExpenses20.value',
          type: 'currency',
          required: false,
          weight: 40
        },
        {
          name: 'Deal - Expenses household 2 - Private health insurance frequency',
          key: 'expenses.household2.householdExpenses20.frequency',
          type: 'string',
          required: false,
          weight: 41
        },
        {
          name: 'Deal - Expenses household 2 - Doctor, dentist, pharmacy, glasses',
          key: 'expenses.household2.householdExpenses21.value',
          type: 'currency',
          required: false,
          weight: 42
        },
        {
          name: 'Deal - Expenses household 2 - Doctor, dentist, pharmacy, glasses frequency',
          key: 'expenses.household2.householdExpenses21.frequency',
          type: 'string',
          required: false,
          weight: 43
        },
        {
          name: 'Deal - Expenses household 2 - Life, trauma, income insurance',
          key: 'expenses.household2.householdExpenses22.value',
          type: 'currency',
          required: false,
          weight: 44
        },
        {
          name: 'Deal - Expenses household 2 - Life, trauma, income insurance frequency',
          key: 'expenses.household2.householdExpenses22.frequency',
          type: 'string',
          required: false,
          weight: 45
        },
        {
          name: 'Deal - Expenses household 2 - Essential vehicle running cost',
          key: 'expenses.household2.householdExpenses23.value',
          type: 'currency',
          required: false,
          weight: 46
        },
        {
          name: 'Deal - Expenses household 2 - Essential vehicle running cost frequency',
          key: 'expenses.household2.householdExpenses23.frequency',
          type: 'string',
          required: false,
          weight: 47
        },
        {
          name: 'Deal - Expenses household 2 - Public transport, taxis & ride share, commuting airfares',
          key: 'expenses.household2.householdExpenses24.value',
          type: 'currency',
          required: false,
          weight: 48
        },
        {
          name: 'Deal - Expenses household 2 - Public transport, taxis & ride share, commuting airfares frequency',
          key: 'expenses.household2.householdExpenses24.frequency',
          type: 'string',
          required: false,
          weight: 49
        },
        {
          name: 'Deal - Expenses household 2 - Essential vehicle insurance',
          key: 'expenses.household2.householdExpenses25.value',
          type: 'currency',
          required: false,
          weight: 50
        },
        {
          name: 'Deal - Expenses household 2 - Essential vehicle insurance frequency',
          key: 'expenses.household2.householdExpenses25.frequency',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Deal - Expenses household 2 - Current rent expense',
          key: 'expenses.household2.householdExpenses26.value',
          type: 'currency',
          required: false,
          weight: 52
        },
        {
          name: 'Deal - Expenses household 2 - Current rent expense frequency',
          key: 'expenses.household2.householdExpenses26.frequency',
          type: 'string',
          required: false,
          weight: 53
        },
        {
          name: 'Deal - Expenses household 2 - Ongoing board expense',
          key: 'expenses.household2.householdExpenses27.value',
          type: 'currency',
          required: false,
          weight: 54
        },
        {
          name: 'Deal - Expenses household 2 - Ongoing board expense frequency',
          key: 'expenses.household2.householdExpenses27.frequency',
          type: 'string',
          required: false,
          weight: 55
        },
        {
          name: 'Deal - Expenses household 2 - Primary residence running costs',
          key: 'expenses.household2.householdExpenses28.value',
          type: 'currency',
          required: false,
          weight: 56
        },
        {
          name: 'Deal - Expenses household 2 - Primary residence running costs frequency',
          key: 'expenses.household2.householdExpenses28.frequency',
          type: 'string',
          required: false,
          weight: 57
        },
        {
          name: 'Deal - Expenses household 2 - Primary residence body corp',
          key: 'expenses.household2.householdExpenses29.value',
          type: 'currency',
          required: false,
          weight: 58
        },
        {
          name: 'Deal - Expenses household 2 - Primary residence body corp frequency',
          key: 'expenses.household2.householdExpenses29.frequency',
          type: 'string',
          required: false,
          weight: 59
        },
        {
          name: 'Deal - Expenses household 2 - Secondary residence running costs',
          key: 'expenses.household2.householdExpenses30.value',
          type: 'currency',
          required: false,
          weight: 60
        },
        {
          name: 'Deal - Expenses household 2 - Secondary residence running costs frequency',
          key: 'expenses.household2.householdExpenses30.frequency',
          type: 'string',
          required: false,
          weight: 61
        },
        {
          name: 'Deal - Expenses household 2 - Secondary residence body corp',
          key: 'expenses.household2.householdExpenses31.value',
          type: 'currency',
          required: false,
          weight: 62
        },
        {
          name: 'Deal - Expenses household 2 - Secondary residence body corp frequency',
          key: 'expenses.household2.householdExpenses31.frequency',
          type: 'string',
          required: false,
          weight: 63
        },
        {
          name: 'Deal - Expenses household 2 - Investment property running costs',
          key: 'expenses.household2.householdExpenses32.value',
          type: 'currency',
          required: false,
          weight: 64
        },
        {
          name: 'Deal - Expenses household 2 - Investment property running costs frequency',
          key: 'expenses.household2.householdExpenses32.frequency',
          type: 'string',
          required: false,
          weight: 65
        },
        {
          name: 'Deal - Expenses household 2 - Investment property body corp',
          key: 'expenses.household2.householdExpenses33.value',
          type: 'currency',
          required: false,
          weight: 66
        },
        {
          name: 'Deal - Expenses household 2 - Investment property body corp frequency',
          key: 'expenses.household2.householdExpenses33.frequency',
          type: 'string',
          required: false,
          weight: 67
        },
        {
          name: 'Deal - Expenses household 3 - Contacts',
          key: 'expenses.household3.idContacts',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Expenses household 3 - Food & supermarket',
          key: 'expenses.household3.householdExpenses1.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Expenses household 3 - Food & supermarket frequency',
          key: 'expenses.household3.householdExpenses1.frequency',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Expenses household 3 - Coffees, lunches takeaway',
          key: 'expenses.household3.householdExpenses2.value',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Expenses household 3 - Coffees, lunches takeaway frequency',
          key: 'expenses.household3.householdExpenses2.frequency',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Expenses household 3 - Entertainment',
          key: 'expenses.household3.householdExpenses3.value',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Expenses household 3 - Entertainment frequency',
          key: 'expenses.household3.householdExpenses3.frequency',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Expenses household 3 - Domestic holidays',
          key: 'expenses.household3.householdExpenses4.value',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Expenses household 3 - Domestic holidays frequency',
          key: 'expenses.household3.householdExpenses4.frequency',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Expenses household 3 - Gym fees, sport, other health & wellness',
          key: 'expenses.household3.householdExpenses5.value',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Expenses household 3 - Gym fees, sport, other health & wellness frequency',
          key: 'expenses.household3.householdExpenses5.frequency',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Expenses household 3 - Cigarettes & alcohol',
          key: 'expenses.household3.householdExpenses6.value',
          type: 'currency',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Expenses household 3 - Cigarettes & alcohol frequency',
          key: 'expenses.household3.householdExpenses6.frequency',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Expenses household 3 - Clothing, shoes & accessories',
          key: 'expenses.household3.householdExpenses7.value',
          type: 'currency',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Expenses household 3 - Clothing, shoes & accessories frequency',
          key: 'expenses.household3.householdExpenses7.frequency',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Expenses household 3 - Hairdressing & grooming',
          key: 'expenses.household3.householdExpenses8.value',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Expenses household 3 - Hairdressing & grooming frequency',
          key: 'expenses.household3.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Expenses household 3 - Phone, Internet & pay TV',
          key: 'expenses.household3.householdExpenses9.value',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Expenses household 3 - Phone, Internet & pay TV frequency',
          key: 'expenses.household3.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Expenses household 3 - Media streaming & subscription services',
          key: 'expenses.household3.householdExpenses10.value',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Expenses household 3 - Media streaming & subscription services frequency',
          key: 'expenses.household3.householdExpenses10.frequency',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Expenses household 3 - Gifts & celebrations',
          key: 'expenses.household3.householdExpenses11.value',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Expenses household 3 - Gifts & celebrations frequency',
          key: 'expenses.household3.householdExpenses11.frequency',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Expenses household 3 - Other discretionary expenses',
          key: 'expenses.household3.householdExpenses12.value',
          type: 'currency',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Expenses household 3 - Other discretionary expenses frequency',
          key: 'expenses.household3.householdExpenses12.frequency',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Expenses household 3 - Recreational vehicle running costs',
          key: 'expenses.household3.householdExpenses13.value',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Expenses household 3 - Recreational vehicle running costs frequency',
          key: 'expenses.household3.householdExpenses13.frequency',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Expenses household 3 - Pets',
          key: 'expenses.household3.householdExpenses14.value',
          type: 'currency',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Expenses household 3 - Pets frequency',
          key: 'expenses.household3.householdExpenses14.frequency',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Expenses household 3 - Public education costs',
          key: 'expenses.household3.householdExpenses15.value',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Expenses household 3 - Public education costs frequency',
          key: 'expenses.household3.householdExpenses15.frequency',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Expenses household 3 - Private education costs',
          key: 'expenses.household3.householdExpenses16.value',
          type: 'currency',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Expenses household 3 - Private education costs frequency',
          key: 'expenses.household3.householdExpenses16.frequency',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Expenses household 3 - Tertiary & vocational education',
          key: 'expenses.household3.householdExpenses17.value',
          type: 'currency',
          required: false,
          weight: 34
        },
        {
          name: 'Deal - Expenses household 3 - Tertiary & vocational education frequency',
          key: 'expenses.household3.householdExpenses17.frequency',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Deal - Expenses household 3 - Childcare',
          key: 'expenses.household3.householdExpenses18.value',
          type: 'currency',
          required: false,
          weight: 36
        },
        {
          name: 'Deal - Expenses household 3 - Childcare frequency',
          key: 'expenses.household3.householdExpenses18.frequency',
          type: 'string',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 3 - Child or spousal maintenance',
          key: 'expenses.household3.householdExpenses19.value',
          type: 'currency',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 3 - Child or spousal maintenance frequency',
          key: 'expenses.household3.householdExpenses19.frequency',
          type: 'string',
          required: false,
          weight: 39
        },
        {
          name: 'Deal - Expenses household 3 - Private health insurance',
          key: 'expenses.household3.householdExpenses20.value',
          type: 'currency',
          required: false,
          weight: 40
        },
        {
          name: 'Deal - Expenses household 3 - Private health insurance frequency',
          key: 'expenses.household3.householdExpenses20.frequency',
          type: 'string',
          required: false,
          weight: 41
        },
        {
          name: 'Deal - Expenses household 3 - Doctor, dentist, pharmacy, glasses',
          key: 'expenses.household3.householdExpenses21.value',
          type: 'currency',
          required: false,
          weight: 42
        },
        {
          name: 'Deal - Expenses household 3 - Doctor, dentist, pharmacy, glasses frequency',
          key: 'expenses.household3.householdExpenses21.frequency',
          type: 'string',
          required: false,
          weight: 43
        },
        {
          name: 'Deal - Expenses household 3 - Life, trauma, income insurance',
          key: 'expenses.household3.householdExpenses22.value',
          type: 'currency',
          required: false,
          weight: 44
        },
        {
          name: 'Deal - Expenses household 3 - Life, trauma, income insurance frequency',
          key: 'expenses.household3.householdExpenses22.frequency',
          type: 'string',
          required: false,
          weight: 45
        },
        {
          name: 'Deal - Expenses household 3 - Essential vehicle running cost',
          key: 'expenses.household3.householdExpenses23.value',
          type: 'currency',
          required: false,
          weight: 46
        },
        {
          name: 'Deal - Expenses household 3 - Essential vehicle running cost frequency',
          key: 'expenses.household3.householdExpenses23.frequency',
          type: 'string',
          required: false,
          weight: 47
        },
        {
          name: 'Deal - Expenses household 3 - Public transport, taxis & ride share, commuting airfares',
          key: 'expenses.household3.householdExpenses24.value',
          type: 'currency',
          required: false,
          weight: 48
        },
        {
          name: 'Deal - Expenses household 3 - Public transport, taxis & ride share, commuting airfares frequency',
          key: 'expenses.household3.householdExpenses24.frequency',
          type: 'string',
          required: false,
          weight: 49
        },
        {
          name: 'Deal - Expenses household 3 - Essential vehicle insurance',
          key: 'expenses.household3.householdExpenses25.value',
          type: 'currency',
          required: false,
          weight: 50
        },
        {
          name: 'Deal - Expenses household 3 - Essential vehicle insurance frequency',
          key: 'expenses.household3.householdExpenses25.frequency',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Deal - Expenses household 3 - Current rent expense',
          key: 'expenses.household3.householdExpenses26.value',
          type: 'currency',
          required: false,
          weight: 52
        },
        {
          name: 'Deal - Expenses household 3 - Current rent expense frequency',
          key: 'expenses.household3.householdExpenses26.frequency',
          type: 'string',
          required: false,
          weight: 53
        },
        {
          name: 'Deal - Expenses household 3 - Ongoing board expense',
          key: 'expenses.household3.householdExpenses27.value',
          type: 'currency',
          required: false,
          weight: 54
        },
        {
          name: 'Deal - Expenses household 3 - Ongoing board expense frequency',
          key: 'expenses.household3.householdExpenses27.frequency',
          type: 'string',
          required: false,
          weight: 55
        },
        {
          name: 'Deal - Expenses household 3 - Primary residence running costs',
          key: 'expenses.household3.householdExpenses28.value',
          type: 'currency',
          required: false,
          weight: 56
        },
        {
          name: 'Deal - Expenses household 3 - Primary residence running costs frequency',
          key: 'expenses.household3.householdExpenses28.frequency',
          type: 'string',
          required: false,
          weight: 57
        },
        {
          name: 'Deal - Expenses household 3 - Primary residence body corp',
          key: 'expenses.household3.householdExpenses29.value',
          type: 'currency',
          required: false,
          weight: 58
        },
        {
          name: 'Deal - Expenses household 3 - Primary residence body corp frequency',
          key: 'expenses.household3.householdExpenses29.frequency',
          type: 'string',
          required: false,
          weight: 59
        },
        {
          name: 'Deal - Expenses household 3 - Secondary residence running costs',
          key: 'expenses.household3.householdExpenses30.value',
          type: 'currency',
          required: false,
          weight: 60
        },
        {
          name: 'Deal - Expenses household 3 - Secondary residence running costs frequency',
          key: 'expenses.household3.householdExpenses30.frequency',
          type: 'string',
          required: false,
          weight: 61
        },
        {
          name: 'Deal - Expenses household 3 - Secondary residence body corp',
          key: 'expenses.household3.householdExpenses31.value',
          type: 'currency',
          required: false,
          weight: 62
        },
        {
          name: 'Deal - Expenses household 3 - Secondary residence body corp frequency',
          key: 'expenses.household3.householdExpenses31.frequency',
          type: 'string',
          required: false,
          weight: 63
        },
        {
          name: 'Deal - Expenses household 3 - Investment property running costs',
          key: 'expenses.household3.householdExpenses32.value',
          type: 'currency',
          required: false,
          weight: 64
        },
        {
          name: 'Deal - Expenses household 3 - Investment property running costs frequency',
          key: 'expenses.household3.householdExpenses32.frequency',
          type: 'string',
          required: false,
          weight: 65
        },
        {
          name: 'Deal - Expenses household 3 - Investment property body corp',
          key: 'expenses.household3.householdExpenses33.value',
          type: 'currency',
          required: false,
          weight: 66
        },
        {
          name: 'Deal - Expenses household 3 - Investment property body corp frequency',
          key: 'expenses.household3.householdExpenses33.frequency',
          type: 'string',
          required: false,
          weight: 67
        },
        {
          name: 'Deal - Expenses household 4 - Contacts',
          key: 'expenses.household4.idContacts',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Expenses household 4 - Food & supermarket',
          key: 'expenses.household4.householdExpenses1.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Expenses household 4 - Food & supermarket frequency',
          key: 'expenses.household4.householdExpenses1.frequency',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Expenses household 4 - Coffees, lunches takeaway',
          key: 'expenses.household4.householdExpenses2.value',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Expenses household 4 - Coffees, lunches takeaway frequency',
          key: 'expenses.household4.householdExpenses2.frequency',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Expenses household 4 - Entertainment',
          key: 'expenses.household4.householdExpenses3.value',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Expenses household 4 - Entertainment frequency',
          key: 'expenses.household4.householdExpenses3.frequency',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Expenses household 4 - Domestic holidays',
          key: 'expenses.household4.householdExpenses4.value',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Expenses household 4 - Domestic holidays frequency',
          key: 'expenses.household4.householdExpenses4.frequency',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Expenses household 4 - Gym fees, sport, other health & wellness',
          key: 'expenses.household4.householdExpenses5.value',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Expenses household 4 - Gym fees, sport, other health & wellness frequency',
          key: 'expenses.household4.householdExpenses5.frequency',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Expenses household 4 - Cigarettes & alcohol',
          key: 'expenses.household4.householdExpenses6.value',
          type: 'currency',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Expenses household 4 - Cigarettes & alcohol frequency',
          key: 'expenses.household4.householdExpenses6.frequency',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Expenses household 4 - Clothing, shoes & accessories',
          key: 'expenses.household4.householdExpenses7.value',
          type: 'currency',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Expenses household 4 - Clothing, shoes & accessories frequency',
          key: 'expenses.household4.householdExpenses7.frequency',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Expenses household 4 - Hairdressing & grooming',
          key: 'expenses.household4.householdExpenses8.value',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Expenses household 4 - Hairdressing & grooming frequency',
          key: 'expenses.household4.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Expenses household 4 - Phone, Internet & pay TV',
          key: 'expenses.household4.householdExpenses9.value',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Expenses household 4 - Phone, Internet & pay TV frequency',
          key: 'expenses.household4.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Expenses household 4 - Media streaming & subscription services',
          key: 'expenses.household4.householdExpenses10.value',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Expenses household 4 - Media streaming & subscription services frequency',
          key: 'expenses.household4.householdExpenses10.frequency',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Expenses household 4 - Gifts & celebrations',
          key: 'expenses.household4.householdExpenses11.value',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Expenses household 4 - Gifts & celebrations frequency',
          key: 'expenses.household4.householdExpenses11.frequency',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Expenses household 4 - Other discretionary expenses',
          key: 'expenses.household4.householdExpenses12.value',
          type: 'currency',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Expenses household 4 - Other discretionary expenses frequency',
          key: 'expenses.household4.householdExpenses12.frequency',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Expenses household 4 - Recreational vehicle running costs',
          key: 'expenses.household4.householdExpenses13.value',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Expenses household 4 - Recreational vehicle running costs frequency',
          key: 'expenses.household4.householdExpenses13.frequency',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Expenses household 4 - Pets',
          key: 'expenses.household4.householdExpenses14.value',
          type: 'currency',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Expenses household 4 - Pets frequency',
          key: 'expenses.household4.householdExpenses14.frequency',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Expenses household 4 - Public education costs',
          key: 'expenses.household4.householdExpenses15.value',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Expenses household 4 - Public education costs frequency',
          key: 'expenses.household4.householdExpenses15.frequency',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Expenses household 4 - Private education costs',
          key: 'expenses.household4.householdExpenses16.value',
          type: 'currency',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Expenses household 4 - Private education costs frequency',
          key: 'expenses.household4.householdExpenses16.frequency',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Expenses household 4 - Tertiary & vocational education',
          key: 'expenses.household4.householdExpenses17.value',
          type: 'currency',
          required: false,
          weight: 34
        },
        {
          name: 'Deal - Expenses household 4 - Tertiary & vocational education frequency',
          key: 'expenses.household4.householdExpenses17.frequency',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Deal - Expenses household 4 - Childcare',
          key: 'expenses.household4.householdExpenses18.value',
          type: 'currency',
          required: false,
          weight: 36
        },
        {
          name: 'Deal - Expenses household 4 - Childcare frequency',
          key: 'expenses.household4.householdExpenses18.frequency',
          type: 'string',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 4 - Child or spousal maintenance',
          key: 'expenses.household4.householdExpenses19.value',
          type: 'currency',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 4 - Child or spousal maintenance frequency',
          key: 'expenses.household4.householdExpenses19.frequency',
          type: 'string',
          required: false,
          weight: 39
        },
        {
          name: 'Deal - Expenses household 4 - Private health insurance',
          key: 'expenses.household4.householdExpenses20.value',
          type: 'currency',
          required: false,
          weight: 40
        },
        {
          name: 'Deal - Expenses household 4 - Private health insurance frequency',
          key: 'expenses.household4.householdExpenses20.frequency',
          type: 'string',
          required: false,
          weight: 41
        },
        {
          name: 'Deal - Expenses household 4 - Doctor, dentist, pharmacy, glasses',
          key: 'expenses.household4.householdExpenses21.value',
          type: 'currency',
          required: false,
          weight: 42
        },
        {
          name: 'Deal - Expenses household 4 - Doctor, dentist, pharmacy, glasses frequency',
          key: 'expenses.household4.householdExpenses21.frequency',
          type: 'string',
          required: false,
          weight: 43
        },
        {
          name: 'Deal - Expenses household 4 - Life, trauma, income insurance',
          key: 'expenses.household4.householdExpenses22.value',
          type: 'currency',
          required: false,
          weight: 44
        },
        {
          name: 'Deal - Expenses household 4 - Life, trauma, income insurance frequency',
          key: 'expenses.household4.householdExpenses22.frequency',
          type: 'string',
          required: false,
          weight: 45
        },
        {
          name: 'Deal - Expenses household 4 - Essential vehicle running cost',
          key: 'expenses.household4.householdExpenses23.value',
          type: 'currency',
          required: false,
          weight: 46
        },
        {
          name: 'Deal - Expenses household 4 - Essential vehicle running cost frequency',
          key: 'expenses.household4.householdExpenses23.frequency',
          type: 'string',
          required: false,
          weight: 47
        },
        {
          name: 'Deal - Expenses household 4 - Public transport, taxis & ride share, commuting airfares',
          key: 'expenses.household4.householdExpenses24.value',
          type: 'currency',
          required: false,
          weight: 48
        },
        {
          name: 'Deal - Expenses household 4 - Public transport, taxis & ride share, commuting airfares frequency',
          key: 'expenses.household4.householdExpenses24.frequency',
          type: 'string',
          required: false,
          weight: 49
        },
        {
          name: 'Deal - Expenses household 4 - Essential vehicle insurance',
          key: 'expenses.household4.householdExpenses25.value',
          type: 'currency',
          required: false,
          weight: 50
        },
        {
          name: 'Deal - Expenses household 4 - Essential vehicle insurance frequency',
          key: 'expenses.household4.householdExpenses25.frequency',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Deal - Expenses household 4 - Current rent expense',
          key: 'expenses.household4.householdExpenses26.value',
          type: 'currency',
          required: false,
          weight: 52
        },
        {
          name: 'Deal - Expenses household 4 - Current rent expense frequency',
          key: 'expenses.household4.householdExpenses26.frequency',
          type: 'string',
          required: false,
          weight: 53
        },
        {
          name: 'Deal - Expenses household 4 - Ongoing board expense',
          key: 'expenses.household4.householdExpenses27.value',
          type: 'currency',
          required: false,
          weight: 54
        },
        {
          name: 'Deal - Expenses household 4 - Ongoing board expense frequency',
          key: 'expenses.household4.householdExpenses27.frequency',
          type: 'string',
          required: false,
          weight: 55
        },
        {
          name: 'Deal - Expenses household 4 - Primary residence running costs',
          key: 'expenses.household4.householdExpenses28.value',
          type: 'currency',
          required: false,
          weight: 56
        },
        {
          name: 'Deal - Expenses household 4 - Primary residence running costs frequency',
          key: 'expenses.household4.householdExpenses28.frequency',
          type: 'string',
          required: false,
          weight: 57
        },
        {
          name: 'Deal - Expenses household 4 - Primary residence body corp',
          key: 'expenses.household4.householdExpenses29.value',
          type: 'currency',
          required: false,
          weight: 58
        },
        {
          name: 'Deal - Expenses household 4 - Primary residence body corp frequency',
          key: 'expenses.household4.householdExpenses29.frequency',
          type: 'string',
          required: false,
          weight: 59
        },
        {
          name: 'Deal - Expenses household 4 - Secondary residence running costs',
          key: 'expenses.household4.householdExpenses30.value',
          type: 'currency',
          required: false,
          weight: 60
        },
        {
          name: 'Deal - Expenses household 4 - Secondary residence running costs frequency',
          key: 'expenses.household4.householdExpenses30.frequency',
          type: 'string',
          required: false,
          weight: 61
        },
        {
          name: 'Deal - Expenses household 4 - Secondary residence body corp',
          key: 'expenses.household4.householdExpenses31.value',
          type: 'currency',
          required: false,
          weight: 62
        },
        {
          name: 'Deal - Expenses household 4 - Secondary residence body corp frequency',
          key: 'expenses.household4.householdExpenses31.frequency',
          type: 'string',
          required: false,
          weight: 63
        },
        {
          name: 'Deal - Expenses household 4 - Investment property running costs',
          key: 'expenses.household4.householdExpenses32.value',
          type: 'currency',
          required: false,
          weight: 64
        },
        {
          name: 'Deal - Expenses household 4 - Investment property running costs frequency',
          key: 'expenses.household4.householdExpenses32.frequency',
          type: 'string',
          required: false,
          weight: 65
        },
        {
          name: 'Deal - Expenses household 4 - Investment property body corp',
          key: 'expenses.household4.householdExpenses33.value',
          type: 'currency',
          required: false,
          weight: 66
        },
        {
          name: 'Deal - Expenses household 4 - Investment property body corp frequency',
          key: 'expenses.household4.householdExpenses33.frequency',
          type: 'string',
          required: false,
          weight: 67
        },
        {
          name: 'Deal - Expenses household 5 - Contacts',
          key: 'expenses.household5.idContacts',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Expenses household 5 - Food & supermarket',
          key: 'expenses.household5.householdExpenses1.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Expenses household 5 - Food & supermarket frequency',
          key: 'expenses.household5.householdExpenses1.frequency',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Expenses household 5 - Coffees, lunches takeaway',
          key: 'expenses.household5.householdExpenses2.value',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Expenses household 5 - Coffees, lunches takeaway frequency',
          key: 'expenses.household5.householdExpenses2.frequency',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Expenses household 5 - Entertainment',
          key: 'expenses.household5.householdExpenses3.value',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Expenses household 5 - Entertainment frequency',
          key: 'expenses.household5.householdExpenses3.frequency',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Expenses household 5 - Domestic holidays',
          key: 'expenses.household5.householdExpenses4.value',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Expenses household 5 - Domestic holidays frequency',
          key: 'expenses.household5.householdExpenses4.frequency',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Expenses household 5 - Gym fees, sport, other health & wellness',
          key: 'expenses.household5.householdExpenses5.value',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Expenses household 5 - Gym fees, sport, other health & wellness frequency',
          key: 'expenses.household5.householdExpenses5.frequency',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Expenses household 5 - Cigarettes & alcohol',
          key: 'expenses.household5.householdExpenses6.value',
          type: 'currency',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Expenses household 5 - Cigarettes & alcohol frequency',
          key: 'expenses.household5.householdExpenses6.frequency',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Expenses household 5 - Clothing, shoes & accessories',
          key: 'expenses.household5.householdExpenses7.value',
          type: 'currency',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Expenses household 5 - Clothing, shoes & accessories frequency',
          key: 'expenses.household5.householdExpenses7.frequency',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Expenses household 5 - Hairdressing & grooming',
          key: 'expenses.household5.householdExpenses8.value',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Expenses household 5 - Hairdressing & grooming frequency',
          key: 'expenses.household5.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Expenses household 5 - Phone, Internet & pay TV',
          key: 'expenses.household5.householdExpenses9.value',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Expenses household 5 - Phone, Internet & pay TV frequency',
          key: 'expenses.household5.householdExpenses8.frequency',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Expenses household 5 - Media streaming & subscription services',
          key: 'expenses.household5.householdExpenses10.value',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Expenses household 5 - Media streaming & subscription services frequency',
          key: 'expenses.household5.householdExpenses10.frequency',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Expenses household 5 - Gifts & celebrations',
          key: 'expenses.household5.householdExpenses11.value',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Expenses household 5 - Gifts & celebrations frequency',
          key: 'expenses.household5.householdExpenses11.frequency',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Expenses household 5 - Other discretionary expenses',
          key: 'expenses.household5.householdExpenses12.value',
          type: 'currency',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Expenses household 5 - Other discretionary expenses frequency',
          key: 'expenses.household5.householdExpenses12.frequency',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Expenses household 5 - Recreational vehicle running costs',
          key: 'expenses.household5.householdExpenses13.value',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Expenses household 5 - Recreational vehicle running costs frequency',
          key: 'expenses.household5.householdExpenses13.frequency',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Expenses household 5 - Pets',
          key: 'expenses.household5.householdExpenses14.value',
          type: 'currency',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Expenses household 5 - Pets frequency',
          key: 'expenses.household5.householdExpenses14.frequency',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Expenses household 5 - Public education costs',
          key: 'expenses.household5.householdExpenses15.value',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Expenses household 5 - Public education costs frequency',
          key: 'expenses.household5.householdExpenses15.frequency',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Expenses household 5 - Private education costs',
          key: 'expenses.household5.householdExpenses16.value',
          type: 'currency',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Expenses household 5 - Private education costs frequency',
          key: 'expenses.household5.householdExpenses16.frequency',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Expenses household 5 - Tertiary & vocational education',
          key: 'expenses.household5.householdExpenses17.value',
          type: 'currency',
          required: false,
          weight: 34
        },
        {
          name: 'Deal - Expenses household 5 - Tertiary & vocational education frequency',
          key: 'expenses.household5.householdExpenses17.frequency',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Deal - Expenses household 5 - Childcare',
          key: 'expenses.household5.householdExpenses18.value',
          type: 'currency',
          required: false,
          weight: 36
        },
        {
          name: 'Deal - Expenses household 5 - Childcare frequency',
          key: 'expenses.household5.householdExpenses18.frequency',
          type: 'string',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 5 - Child or spousal maintenance',
          key: 'expenses.household5.householdExpenses19.value',
          type: 'currency',
          required: false,
          weight: 38
        },
        {
          name: 'Deal - Expenses household 5 - Child or spousal maintenance frequency',
          key: 'expenses.household5.householdExpenses19.frequency',
          type: 'string',
          required: false,
          weight: 39
        },
        {
          name: 'Deal - Expenses household 5 - Private health insurance',
          key: 'expenses.household5.householdExpenses20.value',
          type: 'currency',
          required: false,
          weight: 40
        },
        {
          name: 'Deal - Expenses household 5 - Private health insurance frequency',
          key: 'expenses.household5.householdExpenses20.frequency',
          type: 'string',
          required: false,
          weight: 41
        },
        {
          name: 'Deal - Expenses household 5 - Doctor, dentist, pharmacy, glasses',
          key: 'expenses.household5.householdExpenses21.value',
          type: 'currency',
          required: false,
          weight: 42
        },
        {
          name: 'Deal - Expenses household 5 - Doctor, dentist, pharmacy, glasses frequency',
          key: 'expenses.household5.householdExpenses21.frequency',
          type: 'string',
          required: false,
          weight: 43
        },
        {
          name: 'Deal - Expenses household 5 - Life, trauma, income insurance',
          key: 'expenses.household5.householdExpenses22.value',
          type: 'currency',
          required: false,
          weight: 44
        },
        {
          name: 'Deal - Expenses household 5 - Life, trauma, income insurance frequency',
          key: 'expenses.household5.householdExpenses22.frequency',
          type: 'string',
          required: false,
          weight: 45
        },
        {
          name: 'Deal - Expenses household 5 - Essential vehicle running cost',
          key: 'expenses.household5.householdExpenses23.value',
          type: 'currency',
          required: false,
          weight: 46
        },
        {
          name: 'Deal - Expenses household 5 - Essential vehicle running cost frequency',
          key: 'expenses.household5.householdExpenses23.frequency',
          type: 'string',
          required: false,
          weight: 47
        },
        {
          name: 'Deal - Expenses household 5 - Public transport, taxis & ride share, commuting airfares',
          key: 'expenses.household5.householdExpenses24.value',
          type: 'currency',
          required: false,
          weight: 48
        },
        {
          name: 'Deal - Expenses household 5 - Public transport, taxis & ride share, commuting airfares frequency',
          key: 'expenses.household5.householdExpenses24.frequency',
          type: 'string',
          required: false,
          weight: 49
        },
        {
          name: 'Deal - Expenses household 5 - Essential vehicle insurance',
          key: 'expenses.household5.householdExpenses25.value',
          type: 'currency',
          required: false,
          weight: 50
        },
        {
          name: 'Deal - Expenses household 5 - Essential vehicle insurance frequency',
          key: 'expenses.household5.householdExpenses25.frequency',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Deal - Expenses household 5 - Current rent expense',
          key: 'expenses.household5.householdExpenses26.value',
          type: 'currency',
          required: false,
          weight: 52
        },
        {
          name: 'Deal - Expenses household 5 - Current rent expense frequency',
          key: 'expenses.household5.householdExpenses26.frequency',
          type: 'string',
          required: false,
          weight: 53
        },
        {
          name: 'Deal - Expenses household 5 - Ongoing board expense',
          key: 'expenses.household5.householdExpenses27.value',
          type: 'currency',
          required: false,
          weight: 54
        },
        {
          name: 'Deal - Expenses household 5 - Ongoing board expense frequency',
          key: 'expenses.household5.householdExpenses27.frequency',
          type: 'string',
          required: false,
          weight: 55
        },
        {
          name: 'Deal - Expenses household 5 - Primary residence running costs',
          key: 'expenses.household5.householdExpenses28.value',
          type: 'currency',
          required: false,
          weight: 56
        },
        {
          name: 'Deal - Expenses household 5 - Primary residence running costs frequency',
          key: 'expenses.household5.householdExpenses28.frequency',
          type: 'string',
          required: false,
          weight: 57
        },
        {
          name: 'Deal - Expenses household 5 - Primary residence body corp',
          key: 'expenses.household5.householdExpenses29.value',
          type: 'currency',
          required: false,
          weight: 58
        },
        {
          name: 'Deal - Expenses household 5 - Primary residence body corp frequency',
          key: 'expenses.household5.householdExpenses29.frequency',
          type: 'string',
          required: false,
          weight: 59
        },
        {
          name: 'Deal - Expenses household 5 - Secondary residence running costs',
          key: 'expenses.household5.householdExpenses30.value',
          type: 'currency',
          required: false,
          weight: 60
        },
        {
          name: 'Deal - Expenses household 5 - Secondary residence running costs frequency',
          key: 'expenses.household5.householdExpenses30.frequency',
          type: 'string',
          required: false,
          weight: 61
        },
        {
          name: 'Deal - Expenses household 5 - Secondary residence body corp',
          key: 'expenses.household5.householdExpenses31.value',
          type: 'currency',
          required: false,
          weight: 62
        },
        {
          name: 'Deal - Expenses household 5 - Secondary residence body corp frequency',
          key: 'expenses.household5.householdExpenses31.frequency',
          type: 'string',
          required: false,
          weight: 63
        },
        {
          name: 'Deal - Expenses household 5 - Investment property running costs',
          key: 'expenses.household5.householdExpenses32.value',
          type: 'currency',
          required: false,
          weight: 64
        },
        {
          name: 'Deal - Expenses household 5 - Investment property running costs frequency',
          key: 'expenses.household5.householdExpenses32.frequency',
          type: 'string',
          required: false,
          weight: 65
        },
        {
          name: 'Deal - Expenses household 5 - Investment property body corp',
          key: 'expenses.household5.householdExpenses33.value',
          type: 'currency',
          required: false,
          weight: 66
        },
        {
          name: 'Deal - Expenses household 5 - Investment property body corp frequency',
          key: 'expenses.household5.householdExpenses33.frequency',
          type: 'string',
          required: false,
          weight: 67
        },
        {
          name: 'Deal - Income contact 1 - PAYG gross salary',
          key: 'income.payg1.grossSalary',
          type: 'currency',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Income contact 1 - PAYG gross salary frequency',
          key: 'income.payg1.grossSalaryFrequency',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Income contact 1 - PAYG bonus',
          key: 'income.payg1.bonus',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Income contact 1 - PAYG bonus frequency',
          key: 'income.payg1.bonusFrequency',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Income contact 1 - PAYG overtime essential',
          key: 'income.payg1.overtimeEssential',
          type: 'currency',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Income contact 1 - PAYG overtime essential frequency',
          key: 'income.payg1.overtimeEssentialFrequency',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Income contact 1 - PAYG overtime non essential',
          key: 'income.payg1.overtimeNonEssential',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Income contact 1 - PAYG overtime non essential frequency',
          key: 'income.payg1.overtimeNonEssentialFrequency',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Income contact 1 - PAYG commission',
          key: 'income.payg1.commission',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Income contact 1 - PAYG commission frequency',
          key: 'income.payg1.commissionFrequency',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Income contact 1 - PAYG allowance',
          key: 'income.payg1.allowance',
          type: 'currency',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Income contact 1 - PAYG allowance frequency',
          key: 'income.payg1.allowanceFrequency',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Income contact 1 - PAYG foreign income',
          key: 'income.payg1.foreignIncome',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Income contact 1 - PAYG linked contact',
          key: 'income.payg1.idContact',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Income contact 1 - PAYG linked employer',
          key: 'income.payg1.idEmployer',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Income contact 1 - Business last tax year profit before tax',
          key: 'income.business2.lastTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Income contact 1 - Business last tax year depreciation',
          key: 'income.business2.lastTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Income contact 1 - Business last tax year interest and other addbacks',
          key: 'income.business2.lastTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Income contact 1 - Business last tax year',
          key: 'income.business2.lastTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Income contact 1 - Business previous tax year profit before tax',
          key: 'income.business2.previousTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Income contact 1 - Business previous tax year depreciation',
          key: 'income.business2.previousTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Income contact 1 - Business previous tax year interest and other addbacks',
          key: 'income.business2.previousTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Income contact 1 - Business previous tax year',
          key: 'income.business2.previousTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Income contact 1 - Business linked contact',
          key: 'income.business2.idContact',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Income contact 1 - Business linked employer',
          key: 'income.business2.idEmployer',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Income contact 1 - Other taxable gross income',
          key: 'income.otherTaxable3.grossValue',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Income contact 1 - Other taxable gross income Description',
          key: 'income.otherTaxable3.description',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Income contact 1 - Other taxable gross income Frequency',
          key: 'income.otherTaxable3.frequency',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Income contact 1 - Other taxable linked contact',
          key: 'income.otherTaxable3.idContact',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Income contact 1 - Non taxable gross income',
          key: 'income.nonTaxable4.grossValue',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Income contact 1 - Non taxable gross income description',
          key: 'income.nonTaxable4.description',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Income contact 1 - Non taxable gross income frequency',
          key: 'income.nonTaxable4.frequency',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Income contact 1 - Non taxable linked contact',
          key: 'income.nonTaxable4.idContact',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Income contact 2 - PAYG gross salary',
          key: 'income.payg5.grossSalary',
          type: 'currency',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Income contact 2 - PAYG gross salary Frequency',
          key: 'income.payg5.grossSalaryFrequency',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Income contact 2 - PAYG bonus',
          key: 'income.payg5.bonus',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Income contact 2 - PAYG bonus Frequency',
          key: 'income.payg5.bonusFrequency',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Income contact 2 - PAYG overtime essential',
          key: 'income.payg5.overtimeEssential',
          type: 'currency',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Income contact 2 - PAYG overtime essential Frequency',
          key: 'income.payg5.overtimeEssentialFrequency',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Income contact 2 - PAYG overtime non essential',
          key: 'income.payg5.overtimeNonEssential',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Income contact 2 - PAYG overtime non essential Frequency',
          key: 'income.payg5.overtimeNonEssentialFrequency',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Income contact 2 - PAYG commission',
          key: 'income.payg5.commission',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Income contact 2 - PAYG commission Frequency',
          key: 'income.payg5.commissionFrequency',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Income contact 2 - PAYG allowance',
          key: 'income.payg5.allowance',
          type: 'currency',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Income contact 2 - PAYG allowance Frequency',
          key: 'income.payg5.allowanceFrequency',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Income contact 2 - PAYG foreign income',
          key: 'income.payg5.foreignIncome',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Income contact 2 - PAYG linked contact',
          key: 'income.payg5.idContact',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Income contact 2 - PAYG linked employer',
          key: 'income.payg5.idEmployer',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Income contact 2 - Business last tax year profit before tax',
          key: 'income.business6.lastTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Income contact 2 - Business last tax year depreciation',
          key: 'income.business6.lastTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Income contact 2 - Business last tax year interest and other addbacks',
          key: 'income.business6.lastTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Income contact 2 - Business last tax year',
          key: 'income.business6.lastTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Income contact 2 - Business previous tax year profit before tax',
          key: 'income.business6.previousTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Income contact 2 - Business previous tax year depreciation',
          key: 'income.business6.previousTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Income contact 2 - Business previous tax year interest and other addbacks',
          key: 'income.business6.previousTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Income contact 2 - Business previous tax year',
          key: 'income.business6.previousTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Income contact 2 - Business linked contact',
          key: 'income.business6.idContact',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Income contact 2 - Business linked employer',
          key: 'income.business6.idEmployer',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Income contact 2 - Other taxable gross income',
          key: 'income.otherTaxable7.grossValue',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Income contact 2 - Other taxable gross income Description',
          key: 'income.otherTaxable7.description',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Income contact 2 - Other taxable gross income Frequency',
          key: 'income.otherTaxable7.frequency',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Income contact 2 - Other taxable linked contact',
          key: 'income.otherTaxable7.idContact',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Income contact 2 - Non taxable gross income',
          key: 'income.nonTaxable8.grossValue',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Income contact 2 - Non taxable gross income description',
          key: 'income.nonTaxable8.description',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Income contact 2 - Non taxable gross income frequency',
          key: 'income.nonTaxable8.frequency',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Income contact 2 - Non taxable linked contact',
          key: 'income.nonTaxable8.idContact',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Income contact 3 - PAYG gross salary',
          key: 'income.payg9.grossSalary',
          type: 'currency',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Income contact 3 - PAYG gross salary Frequency',
          key: 'income.payg9.grossSalaryFrequency',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Income contact 3 - PAYG bonus',
          key: 'income.payg9.bonus',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Income contact 3 - PAYG bonus Frequency',
          key: 'income.payg9.bonusFrequency',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Income contact 3 - PAYG overtime essential',
          key: 'income.payg9.overtimeEssential',
          type: 'currency',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Income contact 3 - PAYG overtime essential Frequency',
          key: 'income.payg9.overtimeEssentialFrequency',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Income contact 3 - PAYG overtime non essential',
          key: 'income.payg9.overtimeNonEssential',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Income contact 3 - PAYG overtime non essential Frequency',
          key: 'income.payg9.overtimeNonEssentialFrequency',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Income contact 3 - PAYG commission',
          key: 'income.payg9.commission',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Income contact 3 - PAYG commission Frequency',
          key: 'income.payg9.commissionFrequency',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Income contact 3 - PAYG allowance',
          key: 'income.payg9.allowance',
          type: 'currency',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Income contact 3 - PAYG allowance Frequency',
          key: 'income.payg9.allowanceFrequency',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Income contact 3 - PAYG foreign income',
          key: 'income.payg9.foreignIncome',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Income contact 3 - PAYG linked contact',
          key: 'income.payg9.idContact',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Income contact 3 - PAYG linked employer',
          key: 'income.payg9.idEmployer',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Income contact 3 - Business last tax year profit before tax',
          key: 'income.business10.lastTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Income contact 3 - Business last tax year depreciation',
          key: 'income.business10.lastTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Income contact 3 - Business last tax year interest and other addbacks',
          key: 'income.business10.lastTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Income contact 3 - Business last tax year',
          key: 'income.business10.lastTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Income contact 3 - Business previous tax year profit before tax',
          key: 'income.business10.previousTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Income contact 3 - Business previous tax year depreciation',
          key: 'income.business10.previousTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Income contact 3 - Business previous tax year interest and other addbacks',
          key: 'income.business10.previousTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Income contact 3 - Business previous tax year',
          key: 'income.business10.previousTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Income contact 3 - Business linked contact',
          key: 'income.business10.idContact',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Income contact 3 - Business linked employer',
          key: 'income.business10.idEmployer',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Income contact 3 - Other taxable gross income',
          key: 'income.otherTaxable11.grossValue',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Income contact 3 - Other taxable gross income Description',
          key: 'income.otherTaxable11.description',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Income contact 3 - Other taxable gross income Frequency',
          key: 'income.otherTaxable11.frequency',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Income contact 3 - Other taxable linked contact',
          key: 'income.otherTaxable11.idContact',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Income contact 3 - Non taxable gross income',
          key: 'income.nonTaxable12.grossValue',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Income contact 3 - Non taxable gross income description',
          key: 'income.nonTaxable12.description',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Income contact 3 - Non taxable gross income frequency',
          key: 'income.nonTaxable12.frequency',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Income contact 3 - Non taxable linked contact',
          key: 'income.nonTaxable12.idContact',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Income contact 4 - PAYG gross salary',
          key: 'income.payg13.grossSalary',
          type: 'currency',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Income contact 4 - PAYG gross salary Frequency',
          key: 'income.payg13.grossSalaryFrequency',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Income contact 4 - PAYG bonus',
          key: 'income.payg13.bonus',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Income contact 4 - PAYG bonus Frequency',
          key: 'income.payg13.bonusFrequency',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Income contact 4 - PAYG overtime essential',
          key: 'income.payg13.overtimeEssential',
          type: 'currency',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Income contact 4 - PAYG overtime essential Frequency',
          key: 'income.payg13.overtimeEssentialFrequency',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Income contact 4 - PAYG overtime non essential',
          key: 'income.payg13.overtimeNonEssential',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Income contact 4 - PAYG overtime non essential Frequency',
          key: 'income.payg13.overtimeNonEssentialFrequency',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Income contact 4 - PAYG commission',
          key: 'income.payg13.commission',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Income contact 4 - PAYG commission Frequency',
          key: 'income.payg13.commissionFrequency',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Income contact 4 - PAYG allowance',
          key: 'income.payg13.allowance',
          type: 'currency',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Income contact 4 - PAYG allowance Frequency',
          key: 'income.payg13.allowanceFrequency',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Income contact 4 - PAYG foreign income',
          key: 'income.payg13.foreignIncome',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Income contact 4 - PAYG linked contact',
          key: 'income.payg13.idContact',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Income contact 4 - PAYG linked employer',
          key: 'income.payg13.idEmployer',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Income contact 4 - Business last tax year profit before tax',
          key: 'income.business14.lastTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Income contact 4 - Business last tax year depreciation',
          key: 'income.business14.lastTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Income contact 4 - Business last tax year interest and other addbacks',
          key: 'income.business14.lastTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Income contact 4 - Business last tax year',
          key: 'income.business14.lastTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Income contact 4 - Business previous tax year profit before tax',
          key: 'income.business14.previousTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Income contact 4 - Business previous tax year depreciation',
          key: 'income.business14.previousTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Income contact 4 - Business previous tax year interest and other addbacks',
          key: 'income.business14.previousTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Income contact 4 - Business previous tax year',
          key: 'income.business14.previousTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Income contact 4 - Business linked contact',
          key: 'income.business14.idContact',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Income contact 4 - Business linked employer',
          key: 'income.business14.idEmployer',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Income contact 4 - Other taxable gross income',
          key: 'income.otherTaxable15.grossValue',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Income contact 4 - Other taxable gross income Description',
          key: 'income.otherTaxable15.description',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Income contact 4 - Other taxable gross income Frequency',
          key: 'income.otherTaxable15.frequency',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Income contact 4 - Other taxable linked contact',
          key: 'income.otherTaxable15.idContact',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Income contact 4 - Non taxable gross income',
          key: 'income.nonTaxable16.grossValue',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Income contact 4 - Non taxable gross income description',
          key: 'income.nonTaxable16.description',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Income contact 4 - Non taxable gross income frequency',
          key: 'income.nonTaxable16.frequency',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Income contact 4 - Non taxable linked contact',
          key: 'income.nonTaxable16.idContact',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Income contact 5 - PAYG gross salary',
          key: 'income.payg17.grossSalary',
          type: 'currency',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Income contact 5 - PAYG gross salary Frequency',
          key: 'income.payg17.grossSalaryFrequency',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Income contact 5 - PAYG bonus',
          key: 'income.payg17.bonus',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Income contact 5 - PAYG bonus Frequency',
          key: 'income.payg17.bonusFrequency',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Income contact 5 - PAYG overtime essential',
          key: 'income.payg17.overtimeEssential',
          type: 'currency',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Income contact 5 - PAYG overtime essential Frequency',
          key: 'income.payg17.overtimeEssentialFrequency',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Income contact 5 - PAYG overtime non essential',
          key: 'income.payg17.overtimeNonEssential',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Income contact 5 - PAYG overtime non essential Frequency',
          key: 'income.payg17.overtimeNonEssentialFrequency',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Income contact 5 - PAYG commission',
          key: 'income.payg17.commission',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Income contact 5 - PAYG commission Frequency',
          key: 'income.payg17.commissionFrequency',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Income contact 5 - PAYG allowance',
          key: 'income.payg17.allowance',
          type: 'currency',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Income contact 5 - PAYG allowance Frequency',
          key: 'income.payg17.allowanceFrequency',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Income contact 5 - PAYG foreign income',
          key: 'income.payg17.foreignIncome',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Income contact 5 - PAYG linked contact',
          key: 'income.payg17.idContact',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Income contact 5 - PAYG linked employer',
          key: 'income.payg17.idEmployer',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Income contact 5 - Business last tax year profit before tax',
          key: 'income.business18.lastTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Income contact 5 - Business last tax year depreciation',
          key: 'income.business18.lastTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Income contact 5 - Business last tax year interest and other addbacks',
          key: 'income.business18.lastTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Income contact 5 - Business last tax year',
          key: 'income.business18.lastTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Income contact 5 - Business previous tax year profit before tax',
          key: 'income.business18.previousTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Income contact 5 - Business previous tax year depreciation',
          key: 'income.business18.previousTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Income contact 5 - Business previous tax year interest and other addbacks',
          key: 'income.business18.previousTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Income contact 5 - Business previous tax year',
          key: 'income.business18.previousTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Income contact 5 - Business linked contact',
          key: 'income.business18.idContact',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Income contact 5 - Business linked employer',
          key: 'income.business18.idEmployer',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Income contact 5 - Other taxable gross income',
          key: 'income.otherTaxable19.grossValue',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Income contact 5 - Other taxable gross income description',
          key: 'income.otherTaxable19.description',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Income contact 5 - Other taxable gross income frequency',
          key: 'income.otherTaxable19.frequency',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Income contact 5 - Other taxable linked contact',
          key: 'income.otherTaxable19.idContact',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Income contact 5 - Non taxable gross income',
          key: 'income.nonTaxable20.grossValue',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Income contact 5 - Non taxable gross income description',
          key: 'income.nonTaxable20.description',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Income contact 5 - Non taxable gross income frequency',
          key: 'income.nonTaxable20.frequency',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Income contact 5 - Non taxable linked contact',
          key: 'income.nonTaxable20.idContact',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Income contact 6 - PAYG gross salary',
          key: 'income.payg21.grossSalary',
          type: 'currency',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Income contact 6 - PAYG gross salary Frequency',
          key: 'income.payg21.grossSalaryFrequency',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Income contact 6 - PAYG bonus',
          key: 'income.payg21.bonus',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Income contact 6 - PAYG bonus Frequency',
          key: 'income.payg21.bonusFrequency',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Income contact 6 - PAYG overtime essential',
          key: 'income.payg21.overtimeEssential',
          type: 'currency',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Income contact 6 - PAYG overtime essential Frequency',
          key: 'income.payg21.overtimeEssentialFrequency',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Income contact 6 - PAYG overtime non essential',
          key: 'income.payg21.overtimeNonEssential',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Income contact 6 - PAYG overtime non essential Frequency',
          key: 'income.payg21.overtimeNonEssentialFrequency',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Income contact 6 - PAYG commission',
          key: 'income.payg21.commission',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Income contact 6 - PAYG commission Frequency',
          key: 'income.payg21.commissionFrequency',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Income contact 6 - PAYG allowance',
          key: 'income.payg21.allowance',
          type: 'currency',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Income contact 6 - PAYG allowance Frequency',
          key: 'income.payg21.allowanceFrequency',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Income contact 6 - PAYG foreign income',
          key: 'income.payg21.foreignIncome',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Income contact 6 - PAYG linked contact',
          key: 'income.payg21.idContact',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Income contact 6 - PAYG linked employer',
          key: 'income.payg21.idEmployer',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Income contact 6 - Business last tax year profit before tax',
          key: 'income.business22.lastTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Income contact 6 - Business last tax year depreciation',
          key: 'income.business22.lastTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Income contact 6 - Business last tax year interest and other addbacks',
          key: 'income.business22.lastTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Income contact 6 - Business last tax year',
          key: 'income.business22.lastTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Income contact 6 - Business previous tax year profit before tax',
          key: 'income.business22.previousTaxYear.profitBeforeTax',
          type: 'currency',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Income contact 6 - Business previous tax year depreciation',
          key: 'income.business22.previousTaxYear.depreciation',
          type: 'currency',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Income contact 6 - Business previous tax year interest and other addbacks',
          key: 'income.business22.previousTaxYear.interestAndOtherAddbacks',
          type: 'currency',
          required: false,
          weight: 22
        },
        {
          name: 'Deal - Income contact 6 - Business previous tax year',
          key: 'income.business22.previousTaxYear.taxYear',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Deal - Income contact 6 - Business linked contact',
          key: 'income.business22.idContact',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Deal - Income contact 6 - Business linked employer',
          key: 'income.business22.idEmployer',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Deal - Income contact 6 - Other Taxable Gross Income',
          key: 'income.otherTaxable23.grossValue',
          type: 'currency',
          required: false,
          weight: 26
        },
        {
          name: 'Deal - Income contact 6 - Other taxable gross income description',
          key: 'income.otherTaxable23.description',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Deal - Income contact 6 - Other taxable gross income frequency',
          key: 'income.otherTaxable23.frequency',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Deal - Income contact 6 - Other taxable linked contact',
          key: 'income.otherTaxable23.idContact',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Deal - Income contact 6 - Non taxable gross income',
          key: 'income.nonTaxable24.grossValue',
          type: 'currency',
          required: false,
          weight: 30
        },
        {
          name: 'Deal - Income contact 6 - Non taxable gross income description',
          key: 'income.nonTaxable24.description',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Deal - Income contact 6 - Non taxable gross income frequency',
          key: 'income.nonTaxable24.frequency',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Deal - Income contact 6 - Non taxable linked contact',
          key: 'income.nonTaxable24.idContact',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property address formatted',
          key: 'assets.ownerOccupier1.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property address unit number',
          key: 'assets.ownerOccupier1.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property address street number',
          key: 'assets.ownerOccupier1.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property address street name',
          key: 'assets.ownerOccupier1.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property address city',
          key: 'assets.ownerOccupier1.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property address state',
          key: 'assets.ownerOccupier1.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property address country',
          key: 'assets.ownerOccupier1.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property address postal code',
          key: 'assets.ownerOccupier1.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property value',
          key: 'assets.ownerOccupier1.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property type',
          key: 'assets.ownerOccupier1.propertyType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property zoning',
          key: 'assets.ownerOccupier1.zoning',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property valuation',
          key: 'assets.ownerOccupier1.valuation',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property to be sold',
          key: 'assets.ownerOccupier1.toBeSold',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property ownership contact 1 percent',
          key: 'assets.ownerOccupier1.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property ownership contact 2 percent',
          key: 'assets.ownerOccupier1.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property ownership contact 3 percent',
          key: 'assets.ownerOccupier1.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property ownership contact 4 percent',
          key: 'assets.ownerOccupier1.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property ownership contact 5 percent',
          key: 'assets.ownerOccupier1.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets owner occupier 1 - Property ownership contact 6 percent',
          key: 'assets.ownerOccupier1.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property address formatted',
          key: 'assets.ownerOccupier2.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property address unit number',
          key: 'assets.ownerOccupier2.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property address street number',
          key: 'assets.ownerOccupier2.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property address street name',
          key: 'assets.ownerOccupier2.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property address city',
          key: 'assets.ownerOccupier2.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property address state',
          key: 'assets.ownerOccupier2.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property address country',
          key: 'assets.ownerOccupier2.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property address postal code',
          key: 'assets.ownerOccupier2.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property value',
          key: 'assets.ownerOccupier2.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property type',
          key: 'assets.ownerOccupier2.propertyType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property zoning',
          key: 'assets.ownerOccupier2.zoning',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property valuation',
          key: 'assets.ownerOccupier2.valuation',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property to be sold',
          key: 'assets.ownerOccupier2.toBeSold',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property ownership contact 1 percent',
          key: 'assets.ownerOccupier2.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property ownership contact 2 percent',
          key: 'assets.ownerOccupier2.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property ownership contact 3 percent',
          key: 'assets.ownerOccupier2.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property ownership contact 4 percent',
          key: 'assets.ownerOccupier2.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property ownership contact 5 percent',
          key: 'assets.ownerOccupier2.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets owner occupier 2 - Property ownership contact 6 percent',
          key: 'assets.ownerOccupier2.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property address formatted',
          key: 'assets.ownerOccupier3.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property address unit number',
          key: 'assets.ownerOccupier3.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property address street number',
          key: 'assets.ownerOccupier3.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property address street name',
          key: 'assets.ownerOccupier3.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property address city',
          key: 'assets.ownerOccupier3.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property address state',
          key: 'assets.ownerOccupier3.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property address country',
          key: 'assets.ownerOccupier3.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property address postal code',
          key: 'assets.ownerOccupier3.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property value',
          key: 'assets.ownerOccupier3.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property type',
          key: 'assets.ownerOccupier3.propertyType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property zoning',
          key: 'assets.ownerOccupier3.zoning',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property valuation',
          key: 'assets.ownerOccupier3.valuation',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property to be sold',
          key: 'assets.ownerOccupier3.toBeSold',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property ownership contact 1 percent',
          key: 'assets.ownerOccupier3.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property ownership contact 2 percent',
          key: 'assets.ownerOccupier3.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property ownership contact 3 percent',
          key: 'assets.ownerOccupier3.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property ownership contact 4 percent',
          key: 'assets.ownerOccupier3.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property ownership contact 5 percent',
          key: 'assets.ownerOccupier3.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets owner occupier 3 - Property ownership contact 6 percent',
          key: 'assets.ownerOccupier3.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property address formatted',
          key: 'assets.ownerOccupier4.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property address unit number',
          key: 'assets.ownerOccupier4.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property address street number',
          key: 'assets.ownerOccupier4.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property address street name',
          key: 'assets.ownerOccupier4.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property address city',
          key: 'assets.ownerOccupier4.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property address state',
          key: 'assets.ownerOccupier4.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property address country',
          key: 'assets.ownerOccupier4.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property address postal code',
          key: 'assets.ownerOccupier4.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property value',
          key: 'assets.ownerOccupier4.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property type',
          key: 'assets.ownerOccupier4.propertyType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property zoning',
          key: 'assets.ownerOccupier4.zoning',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property valuation',
          key: 'assets.ownerOccupier4.valuation',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property to be sold',
          key: 'assets.ownerOccupier4.toBeSold',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property ownership contact 1 percent',
          key: 'assets.ownerOccupier4.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property ownership contact 2 percent',
          key: 'assets.ownerOccupier4.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property ownership contact 3 percent',
          key: 'assets.ownerOccupier4.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property ownership contact 4 percent',
          key: 'assets.ownerOccupier4.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property ownership contact 5 percent',
          key: 'assets.ownerOccupier4.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets owner occupier 4 - Property ownership contact 6 percent',
          key: 'assets.ownerOccupier4.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property address formatted',
          key: 'assets.ownerOccupier5.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property address unit number',
          key: 'assets.ownerOccupier5.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property address street number',
          key: 'assets.ownerOccupier5.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property address street name',
          key: 'assets.ownerOccupier5.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property address city',
          key: 'assets.ownerOccupier5.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property address state',
          key: 'assets.ownerOccupier5.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property address country',
          key: 'assets.ownerOccupier5.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property address postal code',
          key: 'assets.ownerOccupier5.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property value',
          key: 'assets.ownerOccupier5.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property type',
          key: 'assets.ownerOccupier5.propertyType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property zoning',
          key: 'assets.ownerOccupier5.zoning',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property valuation',
          key: 'assets.ownerOccupier5.valuation',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property to be sold',
          key: 'assets.ownerOccupier5.toBeSold',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property ownership contact 1 percent',
          key: 'assets.ownerOccupier5.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property ownership contact 2 percent',
          key: 'assets.ownerOccupier5.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property ownership contact 3 percent',
          key: 'assets.ownerOccupier5.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property ownership contact 4 percent',
          key: 'assets.ownerOccupier5.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property ownership contact 5 percent',
          key: 'assets.ownerOccupier5.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets owner occupier 5 - Property ownership contact 6 percent',
          key: 'assets.ownerOccupier5.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property address formatted',
          key: 'assets.ownerOccupier6.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property address unit number',
          key: 'assets.ownerOccupier6.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property address street number',
          key: 'assets.ownerOccupier6.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property address street name',
          key: 'assets.ownerOccupier6.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property address city',
          key: 'assets.ownerOccupier6.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property address state',
          key: 'assets.ownerOccupier6.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property address country',
          key: 'assets.ownerOccupier6.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property address postal code',
          key: 'assets.ownerOccupier6.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property value',
          key: 'assets.ownerOccupier6.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property type',
          key: 'assets.ownerOccupier6.propertyType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property zoning',
          key: 'assets.ownerOccupier6.zoning',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property valuation',
          key: 'assets.ownerOccupier6.valuation',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property to be sold',
          key: 'assets.ownerOccupier6.toBeSold',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property ownership contact 1 percent',
          key: 'assets.ownerOccupier6.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property ownership contact 2 percent',
          key: 'assets.ownerOccupier6.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property ownership contact 3 percent',
          key: 'assets.ownerOccupier6.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property ownership contact 4 percent',
          key: 'assets.ownerOccupier6.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property ownership contact 5 percent',
          key: 'assets.ownerOccupier6.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets owner occupier 6 - Property ownership contact 6 percent',
          key: 'assets.ownerOccupier6.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets investment 1 - Property address formatted',
          key: 'assets.investment7.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets investment 1 - Property address unit number',
          key: 'assets.investment7.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets investment 1 - Property address street number',
          key: 'assets.investment7.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets investment 1 - Property address street name',
          key: 'assets.investment7.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets investment 1 - Property address city',
          key: 'assets.investment7.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets investment 1 - Property address state',
          key: 'assets.investment7.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets investment 1 - Property address country',
          key: 'assets.investment7.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets investment 1 - Property address postal code',
          key: 'assets.investment7.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets investment 1 - Property value',
          key: 'assets.investment7.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets investment 1 - Property Monthly Rental Income',
          key: 'assets.investment7.monthlyRentalIncome',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets investment 1 - Property type',
          key: 'assets.investment7.propertyType',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets investment 1 - Property zoning',
          key: 'assets.investment7.zoning',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets investment 1 - Property valuation',
          key: 'assets.investment7.valuation',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets investment 1 - Property to be sold',
          key: 'assets.investment7.toBeSold',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets investment 1 - Property ownership contact 1 percent',
          key: 'assets.investment7.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets investment 1 - Property ownership contact 2 percent',
          key: 'assets.investment7.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets investment 1 - Property ownership contact 3 percent',
          key: 'assets.investment7.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets investment 1 - Property ownership contact 4 percent',
          key: 'assets.investment7.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets investment 1 - Property ownership contact 5 percent',
          key: 'assets.investment7.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Assets investment 1 - Property ownership contact 6 percent',
          key: 'assets.investment7.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Assets investment 2 - Property address formatted',
          key: 'assets.investment8.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets investment 2 - Property address unit number',
          key: 'assets.investment8.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets investment 2 - Property address street number',
          key: 'assets.investment8.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets investment 2 - Property address street name',
          key: 'assets.investment8.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets investment 2 - Property address city',
          key: 'assets.investment8.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets investment 2 - Property address state',
          key: 'assets.investment8.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets investment 2 - Property address country',
          key: 'assets.investment8.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets investment 2 - Property address postal code',
          key: 'assets.investment8.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets investment 2 - Property value',
          key: 'assets.investment8.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets investment 2 - Property Monthly Rental Income',
          key: 'assets.investment8.monthlyRentalIncome',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets investment 2 - Property type',
          key: 'assets.investment8.propertyType',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets investment 2 - Property zoning',
          key: 'assets.investment8.zoning',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets investment 2 - Property valuation',
          key: 'assets.investment8.valuation',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets investment 2 - Property to be sold',
          key: 'assets.investment8.toBeSold',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets investment 2 - Property ownership contact 1 percent',
          key: 'assets.investment8.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets investment 2 - Property ownership contact 2 percent',
          key: 'assets.investment8.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets investment 2 - Property ownership contact 3 percent',
          key: 'assets.investment8.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets investment 2 - Property ownership contact 4 percent',
          key: 'assets.investment8.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets investment 2 - Property ownership contact 5 percent',
          key: 'assets.investment8.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Assets investment 2 - Property ownership contact 6 percent',
          key: 'assets.investment8.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Assets investment 3 - Property address formatted',
          key: 'assets.investment9.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets investment 3 - Property address unit number',
          key: 'assets.investment9.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets investment 3 - Property address street number',
          key: 'assets.investment9.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets investment 3 - Property address street name',
          key: 'assets.investment9.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets investment 3 - Property address city',
          key: 'assets.investment9.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets investment 3 - Property address state',
          key: 'assets.investment9.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets investment 3 - Property address country',
          key: 'assets.investment9.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets investment 3 - Property address postal code',
          key: 'assets.investment9.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets investment 3 - Property value',
          key: 'assets.investment9.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets investment 3 - Property Monthly Rental Income',
          key: 'assets.investment9.monthlyRentalIncome',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets investment 3 - Property type',
          key: 'assets.investment9.propertyType',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets investment 3 - Property zoning',
          key: 'assets.investment9.zoning',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets investment 3 - Property valuation',
          key: 'assets.investment9.valuation',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets investment 3 - Property to be sold',
          key: 'assets.investment9.toBeSold',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets investment 3 - Property ownership contact 1 percent',
          key: 'assets.investment9.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets investment 3 - Property ownership contact 2 percent',
          key: 'assets.investment9.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets investment 3 - Property ownership contact 3 percent',
          key: 'assets.investment9.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets investment 3 - Property ownership contact 4 percent',
          key: 'assets.investment9.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets investment 3 - Property ownership contact 5 percent',
          key: 'assets.investment9.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Assets investment 3 - Property ownership contact 6 percent',
          key: 'assets.investment9.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Assets investment 4 - Property address formatted',
          key: 'assets.investment10.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets investment 4 - Property address unit number',
          key: 'assets.investment10.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets investment 4 - Property address street number',
          key: 'assets.investment10.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets investment 4 - Property address street name',
          key: 'assets.investment10.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets investment 4 - Property address city',
          key: 'assets.investment10.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets investment 4 - Property address state',
          key: 'assets.investment10.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets investment 4 - Property address country',
          key: 'assets.investment10.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets investment 4 - Property address postal code',
          key: 'assets.investment10.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets investment 4 - Property value',
          key: 'assets.investment10.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets investment 4 - Property Monthly Rental Income',
          key: 'assets.investment10.monthlyRentalIncome',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets investment 4 - Property type',
          key: 'assets.investment10.propertyType',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets investment 4 - Property zoning',
          key: 'assets.investment10.zoning',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets investment 4 - Property valuation',
          key: 'assets.investment10.valuation',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets investment 4 - Property to be sold',
          key: 'assets.investment10.toBeSold',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets investment 4 - Property ownership contact 1 percent',
          key: 'assets.investment10.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets investment 4 - Property ownership contact 2 percent',
          key: 'assets.investment10.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets investment 4 - Property ownership contact 3 percent',
          key: 'assets.investment10.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets investment 4 - Property ownership contact 4 percent',
          key: 'assets.investment10.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets investment 4 - Property ownership contact 5 percent',
          key: 'assets.investment10.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Assets investment 4 - Property ownership contact 6 percent',
          key: 'assets.investment10.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Assets investment 5 - Property address formatted',
          key: 'assets.investment11.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets investment 5 - Property address unit number',
          key: 'assets.investment11.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets investment 5 - Property address street number',
          key: 'assets.investment11.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets investment 5 - Property address street name',
          key: 'assets.investment11.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets investment 5 - Property address city',
          key: 'assets.investment11.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets investment 5 - Property address state',
          key: 'assets.investment11.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets investment 5 - Property address country',
          key: 'assets.investment11.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets investment 5 - Property address postal code',
          key: 'assets.investment11.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets investment 5 - Property value',
          key: 'assets.investment11.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets investment 5 - Property Monthly Rental Income',
          key: 'assets.investment11.monthlyRentalIncome',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets investment 5 - Property type',
          key: 'assets.investment11.propertyType',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets investment 5 - Property zoning',
          key: 'assets.investment11.zoning',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets investment 5 - Property valuation',
          key: 'assets.investment11.valuation',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets investment 5 - Property to be sold',
          key: 'assets.investment11.toBeSold',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets investment 5 - Property ownership contact 1 percent',
          key: 'assets.investment11.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets investment 5 - Property ownership contact 2 percent',
          key: 'assets.investment11.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets investment 5 - Property ownership contact 3 percent',
          key: 'assets.investment11.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets investment 5 - Property ownership contact 4 percent',
          key: 'assets.investment11.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets investment 5 - Property ownership contact 5 percent',
          key: 'assets.investment11.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Assets investment 5 - Property ownership contact 6 percent',
          key: 'assets.investment11.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Assets investment 6 - Property address formatted',
          key: 'assets.investment12.address.formatted',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets investment 6 - Property address unit number',
          key: 'assets.investment12.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets investment 6 - Property address street number',
          key: 'assets.investment12.address.streetNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets investment 6 - Property address street name',
          key: 'assets.investment12.address.street',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets investment 6 - Property address city',
          key: 'assets.investment12.address.city',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets investment 6 - Property address state',
          key: 'assets.investment12.address.state',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets investment 6 - Property address country',
          key: 'assets.investment12.address.country',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets investment 6 - Property address postal code',
          key: 'assets.investment12.address.postCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets investment 6 - Property value',
          key: 'assets.investment12.value',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets investment 6 - Property Monthly Rental Income',
          key: 'assets.investment12.monthlyRentalIncome',
          type: 'currency',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets investment 6 - Property type',
          key: 'assets.investment12.propertyType',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets investment 6 - Property zoning',
          key: 'assets.investment12.zoning',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets investment 6 - Property valuation',
          key: 'assets.investment12.valuation',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Assets investment 6 - Property to be sold',
          key: 'assets.investment12.toBeSold',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Assets investment 6 - Property ownership contact 1 percent',
          key: 'assets.investment12.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Assets investment 6 - Property ownership contact 2 percent',
          key: 'assets.investment12.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Assets investment 6 - Property ownership contact 3 percent',
          key: 'assets.investment12.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Assets investment 6 - Property ownership contact 4 percent',
          key: 'assets.investment12.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Assets investment 6 - Property ownership contact 5 percent',
          key: 'assets.investment12.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Assets investment 6 - Property ownership contact 6 percent',
          key: 'assets.investment12.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Assets vehicle 1 - Make and model',
          key: 'assets.vehicle13.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets vehicle 1 - Type',
          key: 'assets.vehicle13.vehicleType',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets vehicle 1 - Estimated build date',
          key: 'assets.vehicle13.vehicleBuildDate',
          type: 'date',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets vehicle 1 - Value',
          key: 'assets.vehicle13.value',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets vehicle 1 - Ownership contact 1 percent',
          key: 'assets.vehicle13.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets vehicle 1 - Ownership contact 2 percent',
          key: 'assets.vehicle13.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets vehicle 1 - Ownership contact 3 percent',
          key: 'assets.vehicle13.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets vehicle 1 - Ownership contact 4 percent',
          key: 'assets.vehicle13.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets vehicle 1 - Ownership contact 5 percent',
          key: 'assets.vehicle13.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets vehicle 1 - Ownership contact 6 percent',
          key: 'assets.vehicle13.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets vehicle 2 - Make and model',
          key: 'assets.vehicle14.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets vehicle 2 - Type',
          key: 'assets.vehicle14.vehicleType',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets vehicle 2 - Estimated build date',
          key: 'assets.vehicle14.vehicleBuildDate',
          type: 'date',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets vehicle 2 - Value',
          key: 'assets.vehicle14.value',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets vehicle 2 - Ownership contact 1 percent',
          key: 'assets.vehicle14.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets vehicle 2 - Ownership contact 2 percent',
          key: 'assets.vehicle14.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets vehicle 2 - Ownership contact 3 percent',
          key: 'assets.vehicle14.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets vehicle 2 - Ownership contact 4 percent',
          key: 'assets.vehicle14.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets vehicle 2 - Ownership contact 5 percent',
          key: 'assets.vehicle14.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets vehicle 2 - Ownership contact 6 percent',
          key: 'assets.vehicle14.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets vehicle 3 - Make and model',
          key: 'assets.vehicle15.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets vehicle 3 - Type',
          key: 'assets.vehicle15.vehicleType',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets vehicle 3 - Estimated build date',
          key: 'assets.vehicle15.vehicleBuildDate',
          type: 'date',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets vehicle 3 - Value',
          key: 'assets.vehicle15.value',
          type: 'currency',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets vehicle 3 - Ownership contact 1 percent',
          key: 'assets.vehicle15.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets vehicle 3 - Ownership contact 2 percent',
          key: 'assets.vehicle15.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets vehicle 3 - Ownership contact 3 percent',
          key: 'assets.vehicle15.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets vehicle 3 - Ownership contact 4 percent',
          key: 'assets.vehicle15.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets vehicle 3 - Ownership contact 5 percent',
          key: 'assets.vehicle15.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets vehicle 3 - Ownership contact 6 percent',
          key: 'assets.vehicle15.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets bank accounts 1 - Bank',
          key: 'assets.bankAccounts16.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets bank accounts 1 - Bank other name',
          key: 'assets.bankAccounts16.bankOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets bank accounts 1 - Bank account type',
          key: 'assets.bankAccounts16.bankAccountType',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets bank accounts 1 - Bank BSB',
          key: 'assets.bankAccounts16.bankBsb',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets bank accounts 1 - Bank account number',
          key: 'assets.bankAccounts16.bankAccountNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets bank accounts 1 - Value',
          key: 'assets.bankAccounts16.value',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets bank accounts 1 - Ownership contact 1 percent',
          key: 'assets.bankAccounts16.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets bank accounts 1 - Ownership contact 2 percent',
          key: 'assets.bankAccounts16.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets bank accounts 1 - Ownership contact 3 percent',
          key: 'assets.bankAccounts16.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets bank accounts 1 - Ownership contact 4 percent',
          key: 'assets.bankAccounts16.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets bank accounts 1 - Ownership contact 5 percent',
          key: 'assets.bankAccounts16.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets bank accounts 1 - Ownership contact 6 percent',
          key: 'assets.bankAccounts16.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets bank accounts 2 - Bank',
          key: 'assets.bankAccounts17.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets bank accounts 2 - Bank other name',
          key: 'assets.bankAccounts17.bankOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets bank accounts 2 - Bank account type',
          key: 'assets.bankAccounts17.bankAccountType',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets bank accounts 2 - Bank BSB',
          key: 'assets.bankAccounts17.bankBsb',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets bank accounts 2 - Bank account number',
          key: 'assets.bankAccounts17.bankAccountNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets bank accounts 2 - Value',
          key: 'assets.bankAccounts17.value',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets bank accounts 2 - Ownership contact 1 percent',
          key: 'assets.bankAccounts17.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets bank accounts 2 - Ownership contact 2 percent',
          key: 'assets.bankAccounts17.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets bank accounts 2 - Ownership contact 3 percent',
          key: 'assets.bankAccounts17.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets bank accounts 2 - Ownership contact 4 percent',
          key: 'assets.bankAccounts17.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets bank accounts 2 - Ownership contact 5 percent',
          key: 'assets.bankAccounts17.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets bank accounts 2 - Ownership contact 6 percent',
          key: 'assets.bankAccounts17.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets bank accounts 3 - Bank',
          key: 'assets.bankAccounts18.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets bank accounts 3 - Bank other name',
          key: 'assets.bankAccounts18.bankOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets bank accounts 3 - Bank account type',
          key: 'assets.bankAccounts18.bankAccountType',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets bank accounts 3 - Bank BSB',
          key: 'assets.bankAccounts18.bankBsb',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets bank accounts 3 - Bank account number',
          key: 'assets.bankAccounts18.bankAccountNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets bank accounts 3 - Value',
          key: 'assets.bankAccounts18.value',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets bank accounts 3 - Ownership contact 1 percent',
          key: 'assets.bankAccounts18.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets bank accounts 3 - Ownership contact 2 percent',
          key: 'assets.bankAccounts18.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets bank accounts 3 - Ownership contact 3 percent',
          key: 'assets.bankAccounts18.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets bank accounts 3 - Ownership contact 4 percent',
          key: 'assets.bankAccounts18.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Assets bank accounts 3 - Ownership contact 5 percent',
          key: 'assets.bankAccounts18.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Assets bank accounts 3 - Ownership contact 6 percent',
          key: 'assets.bankAccounts18.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Assets home contents 1 - Contents',
          key: 'assets.homeContents19.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets home contents 1 - Value',
          key: 'assets.homeContents19.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets home contents 1 - Ownership contact 1 percent',
          key: 'assets.homeContents19.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets home contents 1 - Ownership contact 2 percent',
          key: 'assets.homeContents19.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets home contents 1 - Ownership contact 3 percent',
          key: 'assets.homeContents19.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets home contents 1 - Ownership contact 4 percent',
          key: 'assets.homeContents19.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets home contents 1 - Ownership contact 5 percent',
          key: 'assets.homeContents19.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets home contents 1 - Ownership contact 6 percent',
          key: 'assets.homeContents19.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets home contents 2 - Contents',
          key: 'assets.homeContents20.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets home contents 2 - Value',
          key: 'assets.homeContents20.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets home contents 2 - Ownership contact 1 percent',
          key: 'assets.homeContents20.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets home contents 2 - Ownership contact 2 percent',
          key: 'assets.homeContents20.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets home contents 2 - Ownership contact 3 percent',
          key: 'assets.homeContents20.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets home contents 2 - Ownership contact 4 percent',
          key: 'assets.homeContents20.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets home contents 2 - Ownership contact 5 percent',
          key: 'assets.homeContents20.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets home contents 2 - Ownership contact 6 percent',
          key: 'assets.homeContents20.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets home contents 3 - Contents',
          key: 'assets.homeContents21.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets home contents 3 - Value',
          key: 'assets.homeContents21.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets home contents 3 - Ownership contact 1 percent',
          key: 'assets.homeContents21.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets home contents 3 - Ownership contact 2 percent',
          key: 'assets.homeContents21.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets home contents 3 - Ownership contact 3 percent',
          key: 'assets.homeContents21.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets home contents 3 - Ownership contact 4 percent',
          key: 'assets.homeContents21.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets home contents 3 - Ownership contact 5 percent',
          key: 'assets.homeContents21.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets home contents 3 - Ownership contact 6 percent',
          key: 'assets.homeContents21.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets KiwiSaver 1 - KiwiSaver',
          key: 'assets.kiwisaver22.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets KiwiSaver 1 - Value',
          key: 'assets.kiwisaver22.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets KiwiSaver 1 - Ownership contact 1 percent',
          key: 'assets.kiwisaver22.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets KiwiSaver 1 - Ownership contact 2 percent',
          key: 'assets.kiwisaver22.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets KiwiSaver 1 - Ownership contact 3 percent',
          key: 'assets.kiwisaver22.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets KiwiSaver 1 - Ownership contact 4 percent',
          key: 'assets.kiwisaver22.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets KiwiSaver 1 - Ownership contact 5 percent',
          key: 'assets.kiwisaver22.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets KiwiSaver 1 - Ownership contact 6 percent',
          key: 'assets.kiwisaver22.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets KiwiSaver 2 - KiwiSaver',
          key: 'assets.kiwisaver23.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets KiwiSaver 2 - Value',
          key: 'assets.kiwisaver23.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets KiwiSaver 2 - Ownership contact 1 percent',
          key: 'assets.kiwisaver23.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets KiwiSaver 2 - Ownership contact 2 percent',
          key: 'assets.kiwisaver23.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets KiwiSaver 2 - Ownership contact 3 percent',
          key: 'assets.kiwisaver23.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets KiwiSaver 2 - Ownership contact 4 percent',
          key: 'assets.kiwisaver23.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets KiwiSaver 2 - Ownership contact 5 percent',
          key: 'assets.kiwisaver23.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets KiwiSaver 2 - Ownership contact 6 percent',
          key: 'assets.kiwisaver23.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets KiwiSaver 3 - KiwiSaver',
          key: 'assets.kiwisaver24.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets KiwiSaver 3 - Value',
          key: 'assets.kiwisaver24.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets KiwiSaver 3 - Ownership contact 1 percent',
          key: 'assets.kiwisaver24.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets KiwiSaver 3 - Ownership contact 2 percent',
          key: 'assets.kiwisaver24.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets KiwiSaver 3 - Ownership contact 3 percent',
          key: 'assets.kiwisaver24.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets KiwiSaver 3 - Ownership contact 4 percent',
          key: 'assets.kiwisaver24.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets KiwiSaver 3 - Ownership contact 5 percent',
          key: 'assets.kiwisaver24.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets KiwiSaver 3 - Ownership contact 6 percent',
          key: 'assets.kiwisaver24.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets superfund institution 1 - Superfund institution',
          key: 'assets.superfundInstitution25.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets superfund institution 1 - Membership number',
          key: 'assets.superfundInstitution25.membershipNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets superfund institution 1 - Value',
          key: 'assets.superfundInstitution25.value',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets superfund institution 1 - Ownership contact 1 percent',
          key: 'assets.superfundInstitution25.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets superfund institution 1 - Ownership contact 2 percent',
          key: 'assets.superfundInstitution25.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets superfund institution 1 - Ownership contact 3 percent',
          key: 'assets.superfundInstitution25.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets superfund institution 1 - Ownership contact 4 percent',
          key: 'assets.superfundInstitution25.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets superfund institution 1 - Ownership contact 5 percent',
          key: 'assets.superfundInstitution25.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets superfund institution 1 - Ownership contact 6 percent',
          key: 'assets.superfundInstitution25.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets superfund institution 2 - Superfund institution',
          key: 'assets.superfundInstitution26.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets superfund institution 2 - Membership number',
          key: 'assets.superfundInstitution26.membershipNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets superfund institution 2 - Value',
          key: 'assets.superfundInstitution26.value',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets superfund institution 2 - Ownership contact 1 percent',
          key: 'assets.superfundInstitution26.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets superfund institution 2 - Ownership contact 2 percent',
          key: 'assets.superfundInstitution26.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets superfund institution 2 - Ownership contact 3 percent',
          key: 'assets.superfundInstitution26.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets superfund institution 2 - Ownership contact 4 percent',
          key: 'assets.superfundInstitution26.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets superfund institution 2 - Ownership contact 5 percent',
          key: 'assets.superfundInstitution26.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets superfund institution 2 - Ownership contact 6 percent',
          key: 'assets.superfundInstitution26.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets superfund institution 3 - Superfund institution',
          key: 'assets.superfundInstitution27.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets superfund institution 3 - Membership number',
          key: 'assets.superfundInstitution27.membershipNumber',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets superfund institution 3 - Value',
          key: 'assets.superfundInstitution27.value',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets superfund institution 3 - Ownership contact 1 percent',
          key: 'assets.superfundInstitution27.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets superfund institution 3 - Ownership contact 2 percent',
          key: 'assets.superfundInstitution27.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets superfund institution 3 - Ownership contact 3 percent',
          key: 'assets.superfundInstitution27.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets superfund institution 3 - Ownership contact 4 percent',
          key: 'assets.superfundInstitution27.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets superfund institution 3 - Ownership contact 5 percent',
          key: 'assets.superfundInstitution27.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets superfund institution 3 - Ownership contact 6 percent',
          key: 'assets.superfundInstitution27.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets shares 1 - Shares',
          key: 'assets.shares28.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets shares 1 - Value',
          key: 'assets.shares28.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets shares 1 - Ownership contact 1 percent',
          key: 'assets.shares28.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets shares 1 - Ownership contact 2 percent',
          key: 'assets.shares28.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets shares 1 - Ownership contact 3 percent',
          key: 'assets.shares28.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets shares 1 - Ownership contact 4 percent',
          key: 'assets.shares28.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets shares 1 - Ownership contact 5 percent',
          key: 'assets.shares28.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets shares 1 - Ownership contact 6 percent',
          key: 'assets.shares28.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets shares 2 - Shares',
          key: 'assets.shares29.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets shares 2 - Value',
          key: 'assets.shares29.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets shares 2 - Ownership contact 1 percent',
          key: 'assets.shares29.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets shares 2 - Ownership contact 2 percent',
          key: 'assets.shares29.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets shares 2 - Ownership contact 3 percent',
          key: 'assets.shares29.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets shares 2 - Ownership contact 4 percent',
          key: 'assets.shares29.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets shares 2 - Ownership contact 5 percent',
          key: 'assets.shares29.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets shares 2 - Ownership contact 6 percent',
          key: 'assets.shares29.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets shares 3 - Shares',
          key: 'assets.shares30.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets shares 3 - Value',
          key: 'assets.shares30.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets shares 3 - Ownership contact 1 percent',
          key: 'assets.shares30.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets shares 3 - Ownership contact 2 percent',
          key: 'assets.shares30.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets shares 3 - Ownership contact 3 percent',
          key: 'assets.shares30.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets shares 3 - Ownership contact 4 percent',
          key: 'assets.shares30.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets shares 3 - Ownership contact 5 percent',
          key: 'assets.shares30.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets shares 3 - Ownership contact 6 percent',
          key: 'assets.shares30.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets other 1 - Other',
          key: 'assets.other31.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets other 1 - Value',
          key: 'assets.other31.value',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets other 1 - Ownership contact 1 percent',
          key: 'assets.other31.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets other 1 - Ownership contact 2 percent',
          key: 'assets.other31.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets other 1 - Ownership contact 3 percent',
          key: 'assets.other31.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets other 1 - Ownership contact 4 percent',
          key: 'assets.other31.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets other 1 - Ownership contact 5 percent',
          key: 'assets.other31.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets other 1 - Ownership contact 6 percent',
          key: 'assets.other31.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets balance sheet 1 - Balance sheet item',
          key: 'assets.balanceSheet32.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets balance sheet 1 - As at date',
          key: 'assets.balanceSheet32.asAtDate',
          type: 'date',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets balance sheet 1 - Value',
          key: 'assets.balanceSheet32.value',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets balance sheet 1 - Ownership contact 1 percent',
          key: 'assets.balanceSheet32.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets balance sheet 1 - Ownership contact 2 percent',
          key: 'assets.balanceSheet32.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets balance sheet 1 - Ownership contact 3 percent',
          key: 'assets.balanceSheet32.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets balance sheet 1 - Ownership contact 4 percent',
          key: 'assets.balanceSheet32.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets balance sheet 1 - Ownership contact 5 percent',
          key: 'assets.balanceSheet32.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets balance sheet 1 - Ownership contact 6 percent',
          key: 'assets.balanceSheet32.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets balance sheet 2 - Balance sheet item',
          key: 'assets.balanceSheet33.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets balance sheet 2 - As at date',
          key: 'assets.balanceSheet33.asAtDate',
          type: 'date',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets balance sheet 2 - Value',
          key: 'assets.balanceSheet33.value',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets balance sheet 2 - Ownership contact 1 percent',
          key: 'assets.balanceSheet33.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets balance sheet 2 - Ownership contact 2 percent',
          key: 'assets.balanceSheet33.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets balance sheet 2 - Ownership contact 3 percent',
          key: 'assets.balanceSheet33.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets balance sheet 2 - Ownership contact 4 percent',
          key: 'assets.balanceSheet33.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets balance sheet 2 - Ownership contact 5 percent',
          key: 'assets.balanceSheet33.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets balance sheet 2 - Ownership contact 6 percent',
          key: 'assets.balanceSheet33.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Assets balance sheet 2 - Balance sheet item',
          key: 'assets.balanceSheet34.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Assets balance sheet 3 - As at date',
          key: 'assets.balanceSheet34.asAtDate',
          type: 'date',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Assets balance sheet 3 - Value',
          key: 'assets.balanceSheet34.value',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Assets balance sheet 3 - Ownership contact 1 percent',
          key: 'assets.balanceSheet34.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Assets balance sheet 3 - Ownership contact 2 percent',
          key: 'assets.balanceSheet34.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Assets balance sheet 3 - Ownership contact 3 percent',
          key: 'assets.balanceSheet34.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Assets balance sheet 3 - Ownership contact 4 percent',
          key: 'assets.balanceSheet34.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Assets balance sheet 3 - Ownership contact 5 percent',
          key: 'assets.balanceSheet34.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Assets balance sheet 3 - Ownership contact 6 percent',
          key: 'assets.balanceSheet34.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Lender',
          key: 'liabilities.mortgageLoan1.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Lender other name',
          key: 'liabilities.mortgageLoan1.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - BSB',
          key: 'liabilities.mortgageLoan1.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Account number',
          key: 'liabilities.mortgageLoan1.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Interest rate',
          key: 'liabilities.mortgageLoan1.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Mortgage type',
          key: 'liabilities.mortgageLoan1.mortgageType',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Limit',
          key: 'liabilities.mortgageLoan1.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Balance',
          key: 'liabilities.mortgageLoan1.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Repayment monthly',
          key: 'liabilities.mortgageLoan1.repayment',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Repayment type',
          key: 'liabilities.mortgageLoan1.repaymentType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Loan term expiry date',
          key: 'liabilities.mortgageLoan1.endDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Interest only expiry date',
          key: 'liabilities.mortgageLoan1.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Fixed expiry date',
          key: 'liabilities.mortgageLoan1.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Refinance',
          key: 'liabilities.mortgageLoan1.isRefinanced',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Linked asset',
          key: 'liabilities.mortgageLoan1.idAsset',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Ownership contact 1 percent',
          key: 'liabilities.mortgageLoan1.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Ownership contact 2 percent',
          key: 'liabilities.mortgageLoan1.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Ownership contact 3 percent',
          key: 'liabilities.mortgageLoan1.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Ownership contact 4 percent',
          key: 'liabilities.mortgageLoan1.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Ownership contact 5 percent',
          key: 'liabilities.mortgageLoan1.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities mortgage loan 1 - Ownership contact 6 percent',
          key: 'liabilities.mortgageLoan1.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Lender',
          key: 'liabilities.mortgageLoan2.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Lender other name',
          key: 'liabilities.mortgageLoan2.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - BSB',
          key: 'liabilities.mortgageLoan2.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Account number',
          key: 'liabilities.mortgageLoan2.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Interest rate',
          key: 'liabilities.mortgageLoan2.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Mortgage type',
          key: 'liabilities.mortgageLoan2.mortgageType',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Limit',
          key: 'liabilities.mortgageLoan2.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Balance',
          key: 'liabilities.mortgageLoan2.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Repayment monthly',
          key: 'liabilities.mortgageLoan2.repayment',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Repayment type',
          key: 'liabilities.mortgageLoan2.repaymentType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Loan term expiry date',
          key: 'liabilities.mortgageLoan2.endDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Interest only expiry date',
          key: 'liabilities.mortgageLoan2.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Fixed expiry date',
          key: 'liabilities.mortgageLoan2.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Refinance',
          key: 'liabilities.mortgageLoan2.isRefinanced',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Linked asset',
          key: 'liabilities.mortgageLoan2.idAsset',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Ownership contact 1 percent',
          key: 'liabilities.mortgageLoan2.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Ownership contact 2 percent',
          key: 'liabilities.mortgageLoan2.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Ownership contact 3 percent',
          key: 'liabilities.mortgageLoan2.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Ownership contact 4 percent',
          key: 'liabilities.mortgageLoan2.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Ownership contact 5 percent',
          key: 'liabilities.mortgageLoan2.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities mortgage loan 2 - Ownership contact 6 percent',
          key: 'liabilities.mortgageLoan2.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Lender',
          key: 'liabilities.mortgageLoan3.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Lender other name',
          key: 'liabilities.mortgageLoan3.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - BSB',
          key: 'liabilities.mortgageLoan3.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Account number',
          key: 'liabilities.mortgageLoan3.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Interest rate',
          key: 'liabilities.mortgageLoan3.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Mortgage type',
          key: 'liabilities.mortgageLoan3.mortgageType',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Limit',
          key: 'liabilities.mortgageLoan3.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Balance',
          key: 'liabilities.mortgageLoan3.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Repayment monthly',
          key: 'liabilities.mortgageLoan3.repayment',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Repayment type',
          key: 'liabilities.mortgageLoan3.repaymentType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Loan term expiry date',
          key: 'liabilities.mortgageLoan3.endDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Interest only expiry date',
          key: 'liabilities.mortgageLoan3.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Fixed expiry date',
          key: 'liabilities.mortgageLoan3.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Refinance',
          key: 'liabilities.mortgageLoan3.isRefinanced',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Linked asset',
          key: 'liabilities.mortgageLoan3.idAsset',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Ownership contact 1 percent',
          key: 'liabilities.mortgageLoan3.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Ownership contact 2 percent',
          key: 'liabilities.mortgageLoan3.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Ownership contact 3 percent',
          key: 'liabilities.mortgageLoan3.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Ownership contact 4 percent',
          key: 'liabilities.mortgageLoan3.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Ownership contact 5 percent',
          key: 'liabilities.mortgageLoan3.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities mortgage loan 3 - Ownership contact 6 percent',
          key: 'liabilities.mortgageLoan3.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Lender',
          key: 'liabilities.mortgageLoan4.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Lender other name',
          key: 'liabilities.mortgageLoan4.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - BSB',
          key: 'liabilities.mortgageLoan4.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Account number',
          key: 'liabilities.mortgageLoan4.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Interest rate',
          key: 'liabilities.mortgageLoan4.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Mortgage type',
          key: 'liabilities.mortgageLoan4.mortgageType',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Limit',
          key: 'liabilities.mortgageLoan4.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Balance',
          key: 'liabilities.mortgageLoan4.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Repayment monthly',
          key: 'liabilities.mortgageLoan4.repayment',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Repayment type',
          key: 'liabilities.mortgageLoan4.repaymentType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Loan term expiry date',
          key: 'liabilities.mortgageLoan4.endDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Interest only expiry date',
          key: 'liabilities.mortgageLoan4.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Fixed expiry date',
          key: 'liabilities.mortgageLoan4.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Refinance',
          key: 'liabilities.mortgageLoan4.isRefinanced',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Linked asset',
          key: 'liabilities.mortgageLoan4.idAsset',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Ownership contact 1 percent',
          key: 'liabilities.mortgageLoan4.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Ownership contact 2 percent',
          key: 'liabilities.mortgageLoan4.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Ownership contact 3 percent',
          key: 'liabilities.mortgageLoan4.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Ownership contact 4 percent',
          key: 'liabilities.mortgageLoan4.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Ownership contact 5 percent',
          key: 'liabilities.mortgageLoan4.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities mortgage loan 4 - Ownership contact 6 percent',
          key: 'liabilities.mortgageLoan4.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Lender',
          key: 'liabilities.mortgageLoan5.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Lender other name',
          key: 'liabilities.mortgageLoan5.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - BSB',
          key: 'liabilities.mortgageLoan5.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Account number',
          key: 'liabilities.mortgageLoan5.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Interest rate',
          key: 'liabilities.mortgageLoan5.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Mortgage type',
          key: 'liabilities.mortgageLoan5.mortgageType',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Limit',
          key: 'liabilities.mortgageLoan5.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Balance',
          key: 'liabilities.mortgageLoan5.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Repayment monthly',
          key: 'liabilities.mortgageLoan5.repayment',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Repayment type',
          key: 'liabilities.mortgageLoan5.repaymentType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Loan term expiry date',
          key: 'liabilities.mortgageLoan5.endDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Interest only expiry date',
          key: 'liabilities.mortgageLoan5.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Fixed expiry date',
          key: 'liabilities.mortgageLoan5.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Refinance',
          key: 'liabilities.mortgageLoan5.isRefinanced',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Linked asset',
          key: 'liabilities.mortgageLoan5.idAsset',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Ownership contact 1 percent',
          key: 'liabilities.mortgageLoan5.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Ownership contact 2 percent',
          key: 'liabilities.mortgageLoan5.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Ownership contact 3 percent',
          key: 'liabilities.mortgageLoan5.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Ownership contact 4 percent',
          key: 'liabilities.mortgageLoan5.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Ownership contact 5 percent',
          key: 'liabilities.mortgageLoan5.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities mortgage loan 5 - Ownership contact 6 percent',
          key: 'liabilities.mortgageLoan5.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Lender',
          key: 'liabilities.mortgageLoan6.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Lender other name',
          key: 'liabilities.mortgageLoan6.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - BSB',
          key: 'liabilities.mortgageLoan6.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Account number',
          key: 'liabilities.mortgageLoan6.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Interest rate',
          key: 'liabilities.mortgageLoan6.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Mortgage type',
          key: 'liabilities.mortgageLoan6.mortgageType',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Limit',
          key: 'liabilities.mortgageLoan6.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Balance',
          key: 'liabilities.mortgageLoan6.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Repayment monthly',
          key: 'liabilities.mortgageLoan6.repayment',
          type: 'currency',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Repayment type',
          key: 'liabilities.mortgageLoan6.repaymentType',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Loan term expiry date',
          key: 'liabilities.mortgageLoan6.endDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Interest only expiry date',
          key: 'liabilities.mortgageLoan6.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Fixed expiry date',
          key: 'liabilities.mortgageLoan6.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Refinance',
          key: 'liabilities.mortgageLoan6.isRefinanced',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Linked asset',
          key: 'liabilities.mortgageLoan6.idAsset',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Ownership contact 1 percent',
          key: 'liabilities.mortgageLoan6.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Ownership contact 2 percent',
          key: 'liabilities.mortgageLoan6.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Ownership contact 3 percent',
          key: 'liabilities.mortgageLoan6.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Ownership contact 4 percent',
          key: 'liabilities.mortgageLoan6.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Ownership contact 5 percent',
          key: 'liabilities.mortgageLoan6.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities mortgage loan 6 - Ownership contact 6 percent',
          key: 'liabilities.mortgageLoan6.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 21
        },
        {
          name: 'Deal - Liabilities credit card 1 - Lender',
          key: 'liabilities.creditCard7.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities credit card 1 - Lender other name',
          key: 'liabilities.creditCard7.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities credit card 1 - Type',
          key: 'liabilities.creditCard7.creditCardType',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities credit card 1 - Number',
          key: 'liabilities.creditCard7.creditCardNumber',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities credit card 1 - Limit',
          key: 'liabilities.creditCard7.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities credit card 1 - Balance',
          key: 'liabilities.creditCard7.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities credit card 1 - Refinance',
          key: 'liabilities.creditCard7.isRefinanced',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities credit card 1 - Ownership contact 1 percent',
          key: 'liabilities.creditCard7.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities credit card 1 - Ownership contact 2 percent',
          key: 'liabilities.creditCard7.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities credit card 1 - Ownership contact 3 percent',
          key: 'liabilities.creditCard7.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities credit card 1 - Ownership contact 4 percent',
          key: 'liabilities.creditCard7.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities credit card 1 - Ownership contact 5 percent',
          key: 'liabilities.creditCard7.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities credit card 1 - Ownership contact 6 percent',
          key: 'liabilities.creditCard7.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities credit card 2 - Lender',
          key: 'liabilities.creditCard8.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities credit card 2 - Lender other name',
          key: 'liabilities.creditCard8.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities credit card 2 - Type',
          key: 'liabilities.creditCard8.creditCardType',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities credit card 2 - Number',
          key: 'liabilities.creditCard8.creditCardNumber',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities credit card 2 - Limit',
          key: 'liabilities.creditCard8.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities credit card 2 - Balance',
          key: 'liabilities.creditCard8.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities credit card 2 - Refinance',
          key: 'liabilities.creditCard8.isRefinanced',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities credit card 2 - Ownership contact 1 percent',
          key: 'liabilities.creditCard8.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities credit card 2 - Ownership contact 2 percent',
          key: 'liabilities.creditCard8.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities credit card 2 - Ownership contact 3 percent',
          key: 'liabilities.creditCard8.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities credit card 2 - Ownership contact 4 percent',
          key: 'liabilities.creditCard8.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities credit card 2 - Ownership contact 5 percent',
          key: 'liabilities.creditCard8.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities credit card 2 - Ownership contact 6 percent',
          key: 'liabilities.creditCard8.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities credit card 3 - Lender',
          key: 'liabilities.creditCard9.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities credit card 3 - Lender other name',
          key: 'liabilities.creditCard9.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities credit card 3 - Type',
          key: 'liabilities.creditCard9.creditCardType',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities credit card 3 - Number',
          key: 'liabilities.creditCard9.creditCardNumber',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities credit card 3 - Limit',
          key: 'liabilities.creditCard9.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities credit card 3 - Balance',
          key: 'liabilities.creditCard9.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities credit card 3 - Refinance',
          key: 'liabilities.creditCard9.isRefinanced',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities credit card 3 - Ownership contact 1 percent',
          key: 'liabilities.creditCard9.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities credit card 3 - Ownership contact 2 percent',
          key: 'liabilities.creditCard9.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities credit card 3 - Ownership contact 3 percent',
          key: 'liabilities.creditCard9.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities credit card 3 - Ownership contact 4 percent',
          key: 'liabilities.creditCard9.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities credit card 3 - Ownership contact 5 percent',
          key: 'liabilities.creditCard9.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities credit card 3 - Ownership contact 6 percent',
          key: 'liabilities.creditCard9.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Lender',
          key: 'liabilities.overdraft10.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Lender other name',
          key: 'liabilities.overdraft10.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Limit',
          key: 'liabilities.overdraft10.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Balance',
          key: 'liabilities.overdraft10.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Refinance',
          key: 'liabilities.overdraft10.isRefinanced',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Ownership contact 1 percent',
          key: 'liabilities.overdraft10.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Ownership contact 2 percent',
          key: 'liabilities.overdraft10.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Ownership contact 3 percent',
          key: 'liabilities.overdraft10.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Ownership contact 4 percent',
          key: 'liabilities.overdraft10.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Ownership contact 5 percent',
          key: 'liabilities.overdraft10.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities overdraft 1 - Ownership contact 6 percent',
          key: 'liabilities.overdraft10.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Lender',
          key: 'liabilities.overdraft11.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Lender other name',
          key: 'liabilities.overdraft11.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Limit',
          key: 'liabilities.overdraft11.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Balance',
          key: 'liabilities.overdraft11.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Refinance',
          key: 'liabilities.overdraft11.isRefinanced',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Ownership contact 1 percent',
          key: 'liabilities.overdraft11.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Ownership contact 2 percent',
          key: 'liabilities.overdraft11.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Ownership contact 3 percent',
          key: 'liabilities.overdraft11.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Ownership contact 4 percent',
          key: 'liabilities.overdraft11.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Ownership contact 5 percent',
          key: 'liabilities.overdraft11.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities overdraft 2 - Ownership contact 6 percent',
          key: 'liabilities.overdraft11.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Lender',
          key: 'liabilities.overdraft12.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Lender other name',
          key: 'liabilities.overdraft12.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Limit',
          key: 'liabilities.overdraft12.limit',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Balance',
          key: 'liabilities.overdraft12.balance',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Refinance',
          key: 'liabilities.overdraft12.isRefinanced',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Ownership contact 1 percent',
          key: 'liabilities.overdraft12.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Ownership contact 2 percent',
          key: 'liabilities.overdraft12.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Ownership contact 3 percent',
          key: 'liabilities.overdraft12.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Ownership contact 4 percent',
          key: 'liabilities.overdraft12.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Ownership contact 5 percent',
          key: 'liabilities.overdraft12.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities overdraft 3 - Ownership contact 6 percent',
          key: 'liabilities.overdraft12.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Lender',
          key: 'liabilities.vehicleLoan13.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Lender other name',
          key: 'liabilities.vehicleLoan13.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - BSB',
          key: 'liabilities.vehicleLoan13.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Account number',
          key: 'liabilities.vehicleLoan13.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Interest rate',
          key: 'liabilities.vehicleLoan13.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Limit',
          key: 'liabilities.vehicleLoan13.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Balance',
          key: 'liabilities.vehicleLoan13.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Repayment monthly',
          key: 'liabilities.vehicleLoan13.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Loan term expiry date',
          key: 'liabilities.vehicleLoan13.endDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Refinance',
          key: 'liabilities.vehicleLoan13.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Linked asset',
          key: 'liabilities.vehicleLoan13.idAsset',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Ownership contact 1 percent',
          key: 'liabilities.vehicleLoan13.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Ownership contact 2 percent',
          key: 'liabilities.vehicleLoan13.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Ownership contact 3 percent',
          key: 'liabilities.vehicleLoan13.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Ownership contact 4 percent',
          key: 'liabilities.vehicleLoan13.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Ownership contact 5 percent',
          key: 'liabilities.vehicleLoan13.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities vehicle loan 1 - Ownership contact 6 percent',
          key: 'liabilities.vehicleLoan13.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Lender',
          key: 'liabilities.vehicleLoan14.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Lender other name',
          key: 'liabilities.vehicleLoan14.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - BSB',
          key: 'liabilities.vehicleLoan14.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Account number',
          key: 'liabilities.vehicleLoan14.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Interest rate',
          key: 'liabilities.vehicleLoan14.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Limit',
          key: 'liabilities.vehicleLoan14.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Balance',
          key: 'liabilities.vehicleLoan14.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Repayment monthly',
          key: 'liabilities.vehicleLoan14.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Loan term expiry date',
          key: 'liabilities.vehicleLoan14.endDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Refinance',
          key: 'liabilities.vehicleLoan14.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Linked asset',
          key: 'liabilities.vehicleLoan14.idAsset',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Ownership contact 1 percent',
          key: 'liabilities.vehicleLoan14.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Ownership contact 2 percent',
          key: 'liabilities.vehicleLoan14.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Ownership contact 3 percent',
          key: 'liabilities.vehicleLoan14.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Ownership contact 4 percent',
          key: 'liabilities.vehicleLoan14.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Ownership contact 5 percent',
          key: 'liabilities.vehicleLoan14.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities vehicle loan 2 - Ownership contact 6 percent',
          key: 'liabilities.vehicleLoan14.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Lender',
          key: 'liabilities.vehicleLoan15.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Lender other name',
          key: 'liabilities.vehicleLoan15.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - BSB',
          key: 'liabilities.vehicleLoan15.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Account number',
          key: 'liabilities.vehicleLoan15.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Interest rate',
          key: 'liabilities.vehicleLoan15.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Limit',
          key: 'liabilities.vehicleLoan15.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Balance',
          key: 'liabilities.vehicleLoan15.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Repayment monthly',
          key: 'liabilities.vehicleLoan15.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Loan term expiry date',
          key: 'liabilities.vehicleLoan15.endDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Refinance',
          key: 'liabilities.vehicleLoan15.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Linked asset',
          key: 'liabilities.vehicleLoan15.idAsset',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Ownership contact 1 percent',
          key: 'liabilities.vehicleLoan15.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Ownership contact 2 percent',
          key: 'liabilities.vehicleLoan15.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Ownership contact 3 percent',
          key: 'liabilities.vehicleLoan15.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Ownership contact 4 percent',
          key: 'liabilities.vehicleLoan15.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Ownership contact 5 percent',
          key: 'liabilities.vehicleLoan15.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities vehicle loan 3 - Ownership contact 6 percent',
          key: 'liabilities.vehicleLoan15.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Lender',
          key: 'liabilities.personalLoan16.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Lender other name',
          key: 'liabilities.personalLoan16.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities personal loan 1 - BSB',
          key: 'liabilities.personalLoan16.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Account number',
          key: 'liabilities.personalLoan16.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Interest rate',
          key: 'liabilities.personalLoan16.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Limit',
          key: 'liabilities.personalLoan16.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Balance',
          key: 'liabilities.personalLoan16.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Repayment monthly',
          key: 'liabilities.personalLoan16.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Loan term expiry date',
          key: 'liabilities.personalLoan16.endDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Refinance',
          key: 'liabilities.personalLoan16.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Ownership contact 1 percent',
          key: 'liabilities.personalLoan16.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Ownership contact 2 percent',
          key: 'liabilities.personalLoan16.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Ownership contact 3 percent',
          key: 'liabilities.personalLoan16.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Ownership contact 4 percent',
          key: 'liabilities.personalLoan16.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Ownership contact 5 percent',
          key: 'liabilities.personalLoan16.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities personal loan 1 - Ownership contact 6 percent',
          key: 'liabilities.personalLoan16.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Lender',
          key: 'liabilities.personalLoan17.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Lender other name',
          key: 'liabilities.personalLoan17.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities personal loan 2 - BSB',
          key: 'liabilities.personalLoan17.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Account number',
          key: 'liabilities.personalLoan17.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Interest rate',
          key: 'liabilities.personalLoan17.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Limit',
          key: 'liabilities.personalLoan17.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Balance',
          key: 'liabilities.personalLoan17.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Repayment monthly',
          key: 'liabilities.personalLoan17.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Loan term expiry date',
          key: 'liabilities.personalLoan17.endDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Refinance',
          key: 'liabilities.personalLoan17.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Ownership contact 1 percent',
          key: 'liabilities.personalLoan17.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Ownership contact 2 percent',
          key: 'liabilities.personalLoan17.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Ownership contact 3 percent',
          key: 'liabilities.personalLoan17.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Ownership contact 4 percent',
          key: 'liabilities.personalLoan17.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Ownership contact 5 percent',
          key: 'liabilities.personalLoan17.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities personal loan 2 - Ownership contact 6 percent',
          key: 'liabilities.personalLoan17.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Lender',
          key: 'liabilities.personalLoan18.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Lender other name',
          key: 'liabilities.personalLoan18.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities personal loan 3 - BSB',
          key: 'liabilities.personalLoan18.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Account number',
          key: 'liabilities.personalLoan18.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Interest rate',
          key: 'liabilities.personalLoan18.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Limit',
          key: 'liabilities.personalLoan18.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Balance',
          key: 'liabilities.personalLoan18.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Repayment monthly',
          key: 'liabilities.personalLoan18.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Loan term expiry date',
          key: 'liabilities.personalLoan18.endDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Refinance',
          key: 'liabilities.personalLoan18.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Ownership contact 1 percent',
          key: 'liabilities.personalLoan18.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Ownership contact 2 percent',
          key: 'liabilities.personalLoan18.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Ownership contact 3 percent',
          key: 'liabilities.personalLoan18.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Ownership contact 4 percent',
          key: 'liabilities.personalLoan18.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Ownership contact 5 percent',
          key: 'liabilities.personalLoan18.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities personal loan 3 - Ownership contact 6 percent',
          key: 'liabilities.personalLoan18.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Lender',
          key: 'liabilities.smsfLoan19.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Lender other name',
          key: 'liabilities.smsfLoan19.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - BSB',
          key: 'liabilities.smsfLoan19.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Account number',
          key: 'liabilities.smsfLoan19.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Interest rate',
          key: 'liabilities.smsfLoan19.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Limit',
          key: 'liabilities.smsfLoan19.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Balance',
          key: 'liabilities.smsfLoan19.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Repayment monthly',
          key: 'liabilities.smsfLoan19.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Repayment type',
          key: 'liabilities.smsfLoan19.repaymentType',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Loan term expiry date',
          key: 'liabilities.smsfLoan19.endDate',
          type: 'date',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Interest only expiry date',
          key: 'liabilities.smsfLoan19.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Fixed expiry date',
          key: 'liabilities.smsfLoan19.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Refinance',
          key: 'liabilities.smsfLoan19.isRefinanced',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Linked asset',
          key: 'liabilities.smsfLoan19.idAsset',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Ownership contact 1 percent',
          key: 'liabilities.smsfLoan19.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Ownership contact 2 percent',
          key: 'liabilities.smsfLoan19.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Ownership contact 3 percent',
          key: 'liabilities.smsfLoan19.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Ownership contact 4 percent',
          key: 'liabilities.smsfLoan19.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Ownership contact 5 percent',
          key: 'liabilities.smsfLoan19.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities SMSF loan 1 - Ownership contact 6 percent',
          key: 'liabilities.smsfLoan19.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Lender',
          key: 'liabilities.smsfLoan20.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Lender other name',
          key: 'liabilities.smsfLoan20.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - BSB',
          key: 'liabilities.smsfLoan20.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Account number',
          key: 'liabilities.smsfLoan20.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Interest rate',
          key: 'liabilities.smsfLoan20.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Limit',
          key: 'liabilities.smsfLoan20.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Balance',
          key: 'liabilities.smsfLoan20.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Repayment monthly',
          key: 'liabilities.smsfLoan20.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Repayment type',
          key: 'liabilities.smsfLoan20.repaymentType',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Loan term expiry date',
          key: 'liabilities.smsfLoan20.endDate',
          type: 'date',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Interest only expiry date',
          key: 'liabilities.smsfLoan20.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Fixed expiry date',
          key: 'liabilities.smsfLoan20.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Refinance',
          key: 'liabilities.smsfLoan20.isRefinanced',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Linked asset',
          key: 'liabilities.smsfLoan20.idAsset',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Ownership contact 1 percent',
          key: 'liabilities.smsfLoan20.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Ownership contact 2 percent',
          key: 'liabilities.smsfLoan20.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Ownership contact 3 percent',
          key: 'liabilities.smsfLoan20.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Ownership contact 4 percent',
          key: 'liabilities.smsfLoan20.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Ownership contact 5 percent',
          key: 'liabilities.smsfLoan20.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities SMSF loan 2 - Ownership contact 6 percent',
          key: 'liabilities.smsfLoan20.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Lender',
          key: 'liabilities.smsfLoan21.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Lender other name',
          key: 'liabilities.smsfLoan21.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - BSB',
          key: 'liabilities.smsfLoan21.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Account number',
          key: 'liabilities.smsfLoan21.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Interest rate',
          key: 'liabilities.smsfLoan21.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Limit',
          key: 'liabilities.smsfLoan21.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Balance',
          key: 'liabilities.smsfLoan21.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Repayment monthly',
          key: 'liabilities.smsfLoan21.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Repayment type',
          key: 'liabilities.smsfLoan21.repaymentType',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Loan term expiry date',
          key: 'liabilities.smsfLoan21.endDate',
          type: 'date',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Interest only expiry date',
          key: 'liabilities.smsfLoan21.interestOnlyExpiryDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Fixed expiry date',
          key: 'liabilities.smsfLoan21.fixedExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Refinance',
          key: 'liabilities.smsfLoan21.isRefinanced',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Linked asset',
          key: 'liabilities.smsfLoan21.idAsset',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Ownership contact 1 percent',
          key: 'liabilities.smsfLoan21.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Ownership contact 2 percent',
          key: 'liabilities.smsfLoan21.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Ownership contact 3 percent',
          key: 'liabilities.smsfLoan21.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 17
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Ownership contact 4 percent',
          key: 'liabilities.smsfLoan21.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 18
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Ownership contact 5 percent',
          key: 'liabilities.smsfLoan21.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 19
        },
        {
          name: 'Deal - Liabilities SMSF loan 3 - Ownership contact 6 percent',
          key: 'liabilities.smsfLoan21.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 20
        },
        {
          name: 'Deal - Liabilities education debt 1 - Details',
          key: 'liabilities.educationDebt22.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities education debt 1 - Balance',
          key: 'liabilities.educationDebt22.balance',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities education debt 1 - Repayment monthly',
          key: 'liabilities.educationDebt22.repayment',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities education debt 1 - Ownership contact 1 percent',
          key: 'liabilities.educationDebt22.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities education debt 1 - Ownership contact 2 percent',
          key: 'liabilities.educationDebt22.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities education debt 1 - Ownership contact 3 percent',
          key: 'liabilities.educationDebt22.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities education debt 1 - Ownership contact 4 percent',
          key: 'liabilities.educationDebt22.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities education debt 1 - Ownership contact 5 percent',
          key: 'liabilities.educationDebt22.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities education debt 1 - Ownership contact 6 percent',
          key: 'liabilities.educationDebt22.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities education debt 2 - Details',
          key: 'liabilities.educationDebt23.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities education debt 2 - Balance',
          key: 'liabilities.educationDebt23.balance',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities education debt 2 - Repayment monthly',
          key: 'liabilities.educationDebt23.repayment',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities education debt 2 - Ownership contact 1 percent',
          key: 'liabilities.educationDebt23.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities education debt 2 - Ownership contact 2 percent',
          key: 'liabilities.educationDebt23.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities education debt 2 - Ownership contact 3 percent',
          key: 'liabilities.educationDebt23.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities education debt 2 - Ownership contact 4 percent',
          key: 'liabilities.educationDebt23.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities education debt 2 - Ownership contact 5 percent',
          key: 'liabilities.educationDebt23.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities education debt 2 - Ownership contact 6 percent',
          key: 'liabilities.educationDebt23.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities education debt 3 - Details',
          key: 'liabilities.educationDebt24.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities education debt 3 - Balance',
          key: 'liabilities.educationDebt24.balance',
          type: 'currency',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities education debt 3 - Repayment monthly',
          key: 'liabilities.educationDebt24.repayment',
          type: 'currency',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities education debt 3 - Ownership contact 1 percent',
          key: 'liabilities.educationDebt24.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities education debt 3 - Ownership contact 2 percent',
          key: 'liabilities.educationDebt24.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities education debt 3 - Ownership contact 3 percent',
          key: 'liabilities.educationDebt24.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities education debt 3 - Ownership contact 4 percent',
          key: 'liabilities.educationDebt24.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities education debt 3 - Ownership contact 5 percent',
          key: 'liabilities.educationDebt24.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities education debt 3 - Ownership contact 6 percent',
          key: 'liabilities.educationDebt24.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities other 1 - Lender',
          key: 'liabilities.other25.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities other 1 - Lender other name',
          key: 'liabilities.other25.lenderOtherName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Deal - Liabilities other 1 - BSB',
          key: 'liabilities.other25.bsb',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Deal - Liabilities other 1 - Account number',
          key: 'liabilities.other25.accountNumber',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Deal - Liabilities other 1 - Interest rate',
          key: 'liabilities.other25.interestRate',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Deal - Liabilities other 1 - Limit',
          key: 'liabilities.other25.limit',
          type: 'currency',
          required: false,
          weight: 6
        },
        {
          name: 'Deal - Liabilities other 1 - Balance',
          key: 'liabilities.other25.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities other 1 - Repayment monthly',
          key: 'liabilities.other25.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities other 1 - Loan term expiry date',
          key: 'liabilities.other25.endDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities other 1 - Refinance',
          key: 'liabilities.other25.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities other 1 - Ownership contact 1 percent',
          key: 'liabilities.other25.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities other 1 - Ownership contact 2 percent',
          key: 'liabilities.other25.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities other 1 - Ownership contact 3 percent',
          key: 'liabilities.other25.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities other 1 - Ownership contact 4 percent',
          key: 'liabilities.other25.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities other 1 - Ownership contact 5 percent',
          key: 'liabilities.other25.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities other 1 - Ownership contact 6 percent',
          key: 'liabilities.other25.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Name',
          key: 'liabilities.balanceSheet26.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Balance',
          key: 'liabilities.balanceSheet26.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Repayment monthly',
          key: 'liabilities.balanceSheet26.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - As at date',
          key: 'liabilities.balanceSheet26.asAtDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Refinance',
          key: 'liabilities.balanceSheet26.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Ownership contact 1 percent',
          key: 'liabilities.balanceSheet26.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Ownership contact 2 percent',
          key: 'liabilities.balanceSheet26.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Ownership contact 3 percent',
          key: 'liabilities.balanceSheet26.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Ownership contact 4 percent',
          key: 'liabilities.balanceSheet26.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Ownership contact 5 percent',
          key: 'liabilities.balanceSheet26.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities balance sheet 1 - Ownership contact 6 percent',
          key: 'liabilities.balanceSheet26.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Name',
          key: 'liabilities.balanceSheet27.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Balance',
          key: 'liabilities.balanceSheet27.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Repayment monthly',
          key: 'liabilities.balanceSheet27.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - As at date',
          key: 'liabilities.balanceSheet27.asAtDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Refinance',
          key: 'liabilities.balanceSheet27.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Ownership contact 1 percent',
          key: 'liabilities.balanceSheet27.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Ownership contact 2 percent',
          key: 'liabilities.balanceSheet27.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Ownership contact 3 percent',
          key: 'liabilities.balanceSheet27.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Ownership contact 4 percent',
          key: 'liabilities.balanceSheet27.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Ownership contact 5 percent',
          key: 'liabilities.balanceSheet27.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities balance sheet 2 - Ownership contact 6 percent',
          key: 'liabilities.balanceSheet27.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 16
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Name',
          key: 'liabilities.balanceSheet28.name',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Balance',
          key: 'liabilities.balanceSheet28.balance',
          type: 'currency',
          required: false,
          weight: 7
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Repayment monthly',
          key: 'liabilities.balanceSheet28.repayment',
          type: 'currency',
          required: false,
          weight: 8
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - As at date',
          key: 'liabilities.balanceSheet28.asAtDate',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Refinance',
          key: 'liabilities.balanceSheet28.isRefinanced',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Ownership contact 1 percent',
          key: 'liabilities.balanceSheet28.ownershipPercent1',
          type: 'number',
          required: false,
          weight: 11
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Ownership contact 2 percent',
          key: 'liabilities.balanceSheet28.ownershipPercent2',
          type: 'number',
          required: false,
          weight: 12
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Ownership contact 3 percent',
          key: 'liabilities.balanceSheet28.ownershipPercent3',
          type: 'number',
          required: false,
          weight: 13
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Ownership contact 4 percent',
          key: 'liabilities.balanceSheet28.ownershipPercent4',
          type: 'number',
          required: false,
          weight: 14
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Ownership contact 5 percent',
          key: 'liabilities.balanceSheet28.ownershipPercent5',
          type: 'number',
          required: false,
          weight: 15
        },
        {
          name: 'Deal - Liabilities balance sheet 3 - Ownership contact 6 percent',
          key: 'liabilities.balanceSheet28.ownershipPercent6',
          type: 'number',
          required: false,
          weight: 16
        }
      ],
      CONTACT_PERSON: [
        {
          name: 'Person 1 - Personal details - Title',
          key: 'person.information.title',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 1 - Personal details - Full name',
          key: 'person.information.fullName',
          type: 'string',
          required: true,
          weight: 2
        },
        {
          name: 'Person 1 - Personal details - First name',
          key: 'person.information.firstName',
          type: 'string',
          required: true,
          weight: 3
        },
        {
          name: 'Person 1 - Personal details - Middle name',
          key: 'person.information.middleName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 1 - Personal details - Surname',
          key: 'person.information.familyName',
          type: 'string',
          required: true,
          weight: 5
        },
        {
          name: 'Person 1 - Personal details - Preferred name',
          key: 'person.information.preferredName',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 1 - Personal details - Previous name',
          key: 'person.information.previousName',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 1 - Personal details - Gender',
          key: 'person.information.gender',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 1 - Personal details - Date of birth',
          key: 'person.information.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 1 - Personal details - Notes',
          key: 'description',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 1 - Personal details - Contact owner',
          key: 'person.idOwner',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 1 - Personal details - Contact date created',
          key: 'person.timeStamp',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 1 - Contact details - Mobile phone',
          key: 'person.contact.primary',
          type: 'phone',
          required: false,
          weight: 1
        },
        {
          name: 'Person 1 - Contact details - Home Phone',
          key: 'person.contact.home',
          type: 'phone',
          required: false,
          weight: 2
        },
        {
          name: 'Person 1 - Contact details - Work Phone',
          key: 'person.contact.work',
          type: 'phone',
          required: false,
          weight: 3
        },
        {
          name: 'Person 1 - Contact details - E-Mail 1',
          key: 'person.contact.email',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 1 - Contact details - E-Mail 2',
          key: 'person.contact.secondaryEmail',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 1 - Contact details - Website',
          key: 'person.contact.website',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 1 - Contact details - Current address',
          key: 'person.contact.address.formatted',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 1 - Contact details - Current address unit number',
          key: 'person.contact.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 1 - Contact details - Current address street number',
          key: 'person.contact.address.streetNumber',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 1 - Contact details - Current address street name',
          key: 'person.contact.address.street',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 1 - Contact details - Current address city',
          key: 'person.contact.address.city',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 1 - Contact details - Current address state',
          key: 'person.contact.address.state',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 1 - Contact details - Current address postal code',
          key: 'person.contact.address.postCode',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 1 - Contact details - Current residential status',
          key: 'person.contact.housing',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 1 - Contact details - Current address from',
          key: 'person.contact.from',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 1 - Contact details - Previous address',
          key: 'person.contact.previousAddress.formatted',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 1 - Contact details - Previous address unit number',
          key: 'person.contact.previousAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 1 - Contact details - Previous address street number',
          key: 'person.contact.previousAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 1 - Contact details - Previous address street name',
          key: 'person.contact.previousAddress.street',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 1 - Contact details - Previous address city',
          key: 'person.contact.previousAddress.city',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 1 - Contact details - Previous address state',
          key: 'person.contact.previousAddress.state',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 1 - Contact details - Previous address postal code',
          key: 'person.contact.previousAddress.postCode',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 1 - Contact details - Previous residential status',
          key: 'person.contact.previousHousing',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 1 - Contact details - Previous address from',
          key: 'person.contact.previousFrom',
          type: 'date',
          required: false,
          weight: 22
        },
        {
          name: 'Person 1 - Contact details - Mailing address',
          key: 'person.contact.mailingAddress.formatted',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 1 - Contact details - Mailing address unit number',
          key: 'person.contact.mailingAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 1 - Contact details - Mailing address street number',
          key: 'person.contact.mailingAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Person 1 - Contact details - Mailing address street name',
          key: 'person.contact.mailingAddress.street',
          type: 'string',
          required: false,
          weight: 26
        },
        {
          name: 'Person 1 - Contact details - Mailing address city',
          key: 'person.contact.mailingAddress.city',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Person 1 - Contact details - Mailing address state',
          key: 'person.contact.mailingAddress.state',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Person 1 - Contact details - Mailing address postal code',
          key: 'person.contact.mailingAddress.postCode',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Person 1 - Contact details - Settlement address',
          key: 'person.contact.settlementAddress.formatted',
          type: 'string',
          required: false,
          weight: 30
        },
        {
          name: 'Person 1 - Contact details - Settlement address unit number',
          key: 'person.contact.settlementAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Person 1 - Contact details - Settlement address street number',
          key: 'person.contact.settlementAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Person 1 - Contact details - Settlement address street name',
          key: 'person.contact.settlementAddress.street',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Person 1 - Contact details - Settlement address city',
          key: 'person.contact.settlementAddress.city',
          type: 'string',
          required: false,
          weight: 34
        },
        {
          name: 'Person 1 - Contact details - Settlement address state',
          key: 'person.contact.settlementAddress.state',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Person 1 - Contact details - Settlement address postal code',
          key: 'person.contact.settlementAddress.postCode',
          type: 'string',
          required: false,
          weight: 36
        },
        {
          name: 'Person 1 - Contact details - Settlement residential status',
          key: 'person.contact.settlementHousing',
          type: 'string',
          required: false,
          weight: 37
        },
        {
          name: 'Person 1 - Identification - Country of residency',
          key: 'person.information.countryOfResidency',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 1 - Identification - Country of tax residence',
          key: 'person.information.countryOfTaxResidence',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 1 - Identification - Citizenship of',
          key: 'person.information.citizenship',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 1 - Identification - Residential status',
          key: 'person.information.residentialStatus',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 1 - Identification - Drivers license number',
          key: 'person.information.driversLicenseNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 1 - Identification - Drivers license card number',
          key: 'person.information.driversLicenseCardNumber',
          type: 'string',
          required: false,
          weight: 50
        },
        {
          name: 'Person 1 - Identification - Drivers license version number',
          key: 'person.information.driversLicenseVersionNumber',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Person 1 - Identification - Drivers license name on document',
          key: 'person.information.driversLicenseNameOnDocument',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 1 - Identification - Drivers license state of issue',
          key: 'person.information.driversLicenseStateOfIssue',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 1 - Identification - Drivers license expiry date',
          key: 'person.information.driversLicenseExpiryDate',
          type: 'date',
          required: false,
          weight: 8
        },
        {
          name: 'Person 1 - Identification - Passport number',
          key: 'person.information.passportNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 1 - Identification - Passport name on document',
          key: 'person.information.passportNameOnDocument',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 1 - Identification - Passport issue country',
          key: 'person.information.passportIssueCountry',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 1 - Identification - Passport issue date',
          key: 'person.information.passportIssueDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 1 - Identification - Passport expiry date',
          key: 'person.information.passportExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 1 - Family relations - Marital status',
          key: 'person.information.maritalStatus',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: "Person 1 - Family relations - Mother's maiden name",
          key: 'person.information.mothersMaidenName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 1 - Family relations - Number of dependents',
          key: 'person.information.numberOfDependents',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Person 1 - Family relations - Name of dependent 1',
          key: 'person.information.dependents1.name',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 1 - Family relations - Date of birth of dependent 1',
          key: 'person.information.dependents1.dateOfBirth',
          type: 'date',
          required: false,
          weight: 7
        },
        {
          name: 'Person 1 - Family relations - Name of dependent 2',
          key: 'person.information.dependents2.name',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 1 - Family relations - Date of birth of dependent 2',
          key: 'person.information.dependents2.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 1 - Family relations - Name of dependent 3',
          key: 'person.information.dependents3.name',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 1 - Family relations - Date of birth of dependent 3',
          key: 'person.information.dependents3.dateOfBirth',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 1 - Family relations - Name of dependent 4',
          key: 'person.information.dependents4.name',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 1 - Family relations - Date of birth of dependent 4',
          key: 'person.information.dependents4.dateOfBirth',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Person 1 - Family relations - Name of dependent 5',
          key: 'person.information.dependents5.name',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 1 - Family relations - Date of birth of dependent 5',
          key: 'person.information.dependents5.dateOfBirth',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 1 - Family relations - Next of kin full name',
          key: 'person.information.nextOfKinFullName',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 1 - Family relations - Next of kin address',
          key: 'person.information.nextOfKinAddress.formatted',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 1 - Family relations - Next of kin address unit number',
          key: 'person.information.nextOfKinAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 1 - Family relations - Next of kin address street number',
          key: 'person.information.nextOfKinAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 1 - Family relations - Next of kin address street name',
          key: 'person.information.nextOfKinAddress.street',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 1 - Family relations - Next of kin address city',
          key: 'person.information.nextOfKinAddress.city',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 1 - Family relations - Next of kin address state',
          key: 'person.information.nextOfKinAddress.state',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 1 - Family relations - Next of kin address postal code',
          key: 'person.information.nextOfKinAddress.postCode',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 1 - Family relations - Next of kin relationship',
          key: 'person.information.nextOfKinRelationship',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 1 - Family relations - Next of kin phone',
          key: 'person.information.nextOfKinPhone',
          type: 'phone',
          required: false,
          weight: 25
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employment type',
          key: 'person.employments.current.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employment status',
          key: 'person.employments.current.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employment basis',
          key: 'person.employments.current.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employment on benefits',
          key: 'person.employments.current.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employment student',
          key: 'person.employments.current.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employment home duties',
          key: 'person.employments.current.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 1 - Employments details (current employer) - Role',
          key: 'person.employments.current.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer name',
          key: 'person.employments.current.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer address',
          key: 'person.employments.current.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer address unit number',
          key: 'person.employments.current.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer address street number',
          key: 'person.employments.current.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer address street name',
          key: 'person.employments.current.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer address city',
          key: 'person.employments.current.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer address state',
          key: 'person.employments.current.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer address postal code',
          key: 'person.employments.current.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer contact title',
          key: 'person.employments.current.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer contact first name',
          key: 'person.employments.current.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer contact surname',
          key: 'person.employments.current.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer phone',
          key: 'person.employments.current.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer type',
          key: 'person.employments.current.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer ABN',
          key: 'person.employments.current.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 1 - Employments details (current employer) - Employer ACN',
          key: 'person.employments.current.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 1 - Employments details (current employer) - Start date',
          key: 'person.employments.current.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employment type',
          key: 'person.employments.previous.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employment status',
          key: 'person.employments.previous.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employment basis',
          key: 'person.employments.previous.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employment on benefits',
          key: 'person.employments.previous.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employment student',
          key: 'person.employments.previous.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employment home duties',
          key: 'person.employments.previous.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Role',
          key: 'person.employments.previous.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer name',
          key: 'person.employments.previous.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer address',
          key: 'person.employments.previous.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer address unit number',
          key: 'person.employments.previous.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer address street number',
          key: 'person.employments.previous.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer address street name',
          key: 'person.employments.previous.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer address city',
          key: 'person.employments.previous.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer address state',
          key: 'person.employments.previous.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer address postal code',
          key: 'person.employments.previous.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer contact title',
          key: 'person.employments.previous.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer contact first name',
          key: 'person.employments.previous.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer contact surname',
          key: 'person.employments.previous.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer phone',
          key: 'person.employments.previous.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer type',
          key: 'person.employments.previous.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer ABN',
          key: 'person.employments.previous.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Employer ACN',
          key: 'person.employments.previous.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 1 - Employments details (previous employer) - Start date',
          key: 'person.employments.previous.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 1 - Employments details (previous employer) - End Date',
          key: 'person.employments.previous.endDate',
          type: 'date',
          required: false,
          weight: 24
        },

        {
          name: 'Person 2 - Personal details - Title',
          key: 'person.information.title',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 2 - Personal details - Full name',
          key: 'person.information.fullName',
          type: 'string',
          required: true,
          weight: 2
        },
        {
          name: 'Person 2 - Personal details - First name',
          key: 'person.information.firstName',
          type: 'string',
          required: true,
          weight: 3
        },
        {
          name: 'Person 2 - Personal details - Middle name',
          key: 'person.information.middleName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 2 - Personal details - Surname',
          key: 'person.information.familyName',
          type: 'string',
          required: true,
          weight: 5
        },
        {
          name: 'Person 2 - Personal details - Preferred name',
          key: 'person.information.preferredName',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 2 - Personal details - Previous name',
          key: 'person.information.previousName',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 2 - Personal details - Gender',
          key: 'person.information.gender',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 2 - Personal details - Date of birth',
          key: 'person.information.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 2 - Personal details - Notes',
          key: 'description',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 2 - Personal details - Contact owner',
          key: 'person.idOwner',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 2 - Personal details - Contact date created',
          key: 'person.timeStamp',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 2 - Contact details - Mobile phone',
          key: 'person.contact.primary',
          type: 'phone',
          required: false,
          weight: 1
        },
        {
          name: 'Person 2 - Contact details - Home Phone',
          key: 'person.contact.home',
          type: 'phone',
          required: false,
          weight: 2
        },
        {
          name: 'Person 2 - Contact details - Work Phone',
          key: 'person.contact.work',
          type: 'phone',
          required: false,
          weight: 3
        },
        {
          name: 'Person 2 - Contact details - E-Mail 1',
          key: 'person.contact.email',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 2 - Contact details - E-Mail 2',
          key: 'person.contact.secondaryEmail',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 2 - Contact details - Website',
          key: 'person.contact.website',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 2 - Contact details - Current address',
          key: 'person.contact.address.formatted',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 2 - Contact details - Current address unit number',
          key: 'person.contact.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 2 - Contact details - Current address street number',
          key: 'person.contact.address.streetNumber',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 2 - Contact details - Current address street name',
          key: 'person.contact.address.street',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 2 - Contact details - Current address city',
          key: 'person.contact.address.city',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 2 - Contact details - Current address state',
          key: 'person.contact.address.state',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 2 - Contact details - Current address postal code',
          key: 'person.contact.address.postCode',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 2 - Contact details - Current residential status',
          key: 'person.contact.housing',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 2 - Contact details - Current address from',
          key: 'person.contact.from',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 2 - Contact details - Previous address',
          key: 'person.contact.previousAddress.formatted',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 2 - Contact details - Previous address unit number',
          key: 'person.contact.previousAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 2 - Contact details - Previous address street number',
          key: 'person.contact.previousAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 2 - Contact details - Previous address street name',
          key: 'person.contact.previousAddress.street',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 2 - Contact details - Previous address city',
          key: 'person.contact.previousAddress.city',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 2 - Contact details - Previous address state',
          key: 'person.contact.previousAddress.state',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 2 - Contact details - Previous address postal code',
          key: 'person.contact.previousAddress.postCode',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 2 - Contact details - Previous residential status',
          key: 'person.contact.previousHousing',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 2 - Contact details - Previous address from',
          key: 'person.contact.previousFrom',
          type: 'date',
          required: false,
          weight: 22
        },
        {
          name: 'Person 2 - Contact details - Mailing address',
          key: 'person.contact.mailingAddress.formatted',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 2 - Contact details - Mailing address unit number',
          key: 'person.contact.mailingAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 2 - Contact details - Mailing address street number',
          key: 'person.contact.mailingAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Person 2 - Contact details - Mailing address street name',
          key: 'person.contact.mailingAddress.street',
          type: 'string',
          required: false,
          weight: 26
        },
        {
          name: 'Person 2 - Contact details - Mailing address city',
          key: 'person.contact.mailingAddress.city',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Person 2 - Contact details - Mailing address state',
          key: 'person.contact.mailingAddress.state',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Person 2 - Contact details - Mailing address postal code',
          key: 'person.contact.mailingAddress.postCode',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Person 2 - Contact details - Settlement address',
          key: 'person.contact.settlementAddress.formatted',
          type: 'string',
          required: false,
          weight: 30
        },
        {
          name: 'Person 2 - Contact details - Settlement address unit number',
          key: 'person.contact.settlementAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Person 2 - Contact details - Settlement address street number',
          key: 'person.contact.settlementAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Person 2 - Contact details - Settlement address street name',
          key: 'person.contact.settlementAddress.street',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Person 2 - Contact details - Settlement address city',
          key: 'person.contact.settlementAddress.city',
          type: 'string',
          required: false,
          weight: 34
        },
        {
          name: 'Person 2 - Contact details - Settlement address state',
          key: 'person.contact.settlementAddress.state',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Person 2 - Contact details - Settlement address postal code',
          key: 'person.contact.settlementAddress.postCode',
          type: 'string',
          required: false,
          weight: 36
        },
        {
          name: 'Person 2 - Contact details - Settlement residential status',
          key: 'person.contact.settlementHousing',
          type: 'string',
          required: false,
          weight: 37
        },
        {
          name: 'Person 2 - Identification - Country of residency',
          key: 'person.information.countryOfResidency',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 2 - Identification - Country of tax residence',
          key: 'person.information.countryOfTaxResidence',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 2 - Identification - Citizenship of',
          key: 'person.information.citizenship',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 2 - Identification - Residential status',
          key: 'person.information.residentialStatus',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 2 - Identification - Drivers license number',
          key: 'person.information.driversLicenseNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 2 - Identification - Drivers license card number',
          key: 'person.information.driversLicenseCardNumber',
          type: 'string',
          required: false,
          weight: 50
        },
        {
          name: 'Person 2 - Identification - Drivers license version number',
          key: 'person.information.driversLicenseVersionNumber',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Person 2 - Identification - Drivers license name on document',
          key: 'person.information.driversLicenseNameOnDocument',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 2 - Identification - Drivers license state of issue',
          key: 'person.information.driversLicenseStateOfIssue',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 2 - Identification - Drivers license expiry date',
          key: 'person.information.driversLicenseExpiryDate',
          type: 'date',
          required: false,
          weight: 8
        },
        {
          name: 'Person 2 - Identification - Passport number',
          key: 'person.information.passportNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 2 - Identification - Passport name on document',
          key: 'person.information.passportNameOnDocument',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 2 - Identification - Passport issue country',
          key: 'person.information.passportIssueCountry',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 2 - Identification - Passport issue date',
          key: 'person.information.passportIssueDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 2 - Identification - Passport expiry date',
          key: 'person.information.passportExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 2 - Family relations - Marital status',
          key: 'person.information.maritalStatus',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: "Person 2 - Family relations - Mother's maiden name",
          key: 'person.information.mothersMaidenName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 2 - Family relations - Number of dependents',
          key: 'person.information.numberOfDependents',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Person 2 - Family relations - Name of dependent 1',
          key: 'person.information.dependents1.name',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 2 - Family relations - Date of birth of dependent 1',
          key: 'person.information.dependents1.dateOfBirth',
          type: 'date',
          required: false,
          weight: 7
        },
        {
          name: 'Person 2 - Family relations - Name of dependent 2',
          key: 'person.information.dependents2.name',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 2 - Family relations - Date of birth of dependent 2',
          key: 'person.information.dependents2.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 2 - Family relations - Name of dependent 3',
          key: 'person.information.dependents3.name',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 2 - Family relations - Date of birth of dependent 3',
          key: 'person.information.dependents3.dateOfBirth',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 2 - Family relations - Name of dependent 4',
          key: 'person.information.dependents4.name',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 2 - Family relations - Date of birth of dependent 4',
          key: 'person.information.dependents4.dateOfBirth',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Person 2 - Family relations - Name of dependent 5',
          key: 'person.information.dependents5.name',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 2 - Family relations - Date of birth of dependent 5',
          key: 'person.information.dependents5.dateOfBirth',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 2 - Family relations - Next of kin full name',
          key: 'person.information.nextOfKinFullName',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 2 - Family relations - Next of kin address',
          key: 'person.information.nextOfKinAddress.formatted',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 2 - Family relations - Next of kin address unit number',
          key: 'person.information.nextOfKinAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 2 - Family relations - Next of kin address street number',
          key: 'person.information.nextOfKinAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 2 - Family relations - Next of kin address street name',
          key: 'person.information.nextOfKinAddress.street',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 2 - Family relations - Next of kin address city',
          key: 'person.information.nextOfKinAddress.city',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 2 - Family relations - Next of kin address state',
          key: 'person.information.nextOfKinAddress.state',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 2 - Family relations - Next of kin address postal code',
          key: 'person.information.nextOfKinAddress.postCode',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 2 - Family relations - Next of kin relationship',
          key: 'person.information.nextOfKinRelationship',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 2 - Family relations - Next of kin phone',
          key: 'person.information.nextOfKinPhone',
          type: 'phone',
          required: false,
          weight: 25
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employment type',
          key: 'person.employments.current.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employment status',
          key: 'person.employments.current.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employment basis',
          key: 'person.employments.current.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employment on benefits',
          key: 'person.employments.current.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employment student',
          key: 'person.employments.current.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employment home duties',
          key: 'person.employments.current.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 2 - Employments details (current employer) - Role',
          key: 'person.employments.current.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer name',
          key: 'person.employments.current.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer address',
          key: 'person.employments.current.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer address unit number',
          key: 'person.employments.current.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer address street number',
          key: 'person.employments.current.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer address street name',
          key: 'person.employments.current.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer address city',
          key: 'person.employments.current.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer address state',
          key: 'person.employments.current.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer address postal code',
          key: 'person.employments.current.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer contact title',
          key: 'person.employments.current.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer contact first name',
          key: 'person.employments.current.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer contact surname',
          key: 'person.employments.current.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer phone',
          key: 'person.employments.current.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer type',
          key: 'person.employments.current.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer ABN',
          key: 'person.employments.current.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 2 - Employments details (current employer) - Employer ACN',
          key: 'person.employments.current.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 2 - Employments details (current employer) - Start date',
          key: 'person.employments.current.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employment type',
          key: 'person.employments.previous.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employment status',
          key: 'person.employments.previous.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employment basis',
          key: 'person.employments.previous.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employment on benefits',
          key: 'person.employments.previous.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employment student',
          key: 'person.employments.previous.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employment home duties',
          key: 'person.employments.previous.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Role',
          key: 'person.employments.previous.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer name',
          key: 'person.employments.previous.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer address',
          key: 'person.employments.previous.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer address unit number',
          key: 'person.employments.previous.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer address street number',
          key: 'person.employments.previous.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer address street name',
          key: 'person.employments.previous.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer address city',
          key: 'person.employments.previous.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer address state',
          key: 'person.employments.previous.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer address postal code',
          key: 'person.employments.previous.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer contact title',
          key: 'person.employments.previous.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer contact first name',
          key: 'person.employments.previous.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer contact surname',
          key: 'person.employments.previous.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer phone',
          key: 'person.employments.previous.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer type',
          key: 'person.employments.previous.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer ABN',
          key: 'person.employments.previous.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Employer ACN',
          key: 'person.employments.previous.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 2 - Employments details (previous employer) - Start date',
          key: 'person.employments.previous.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 2 - Employments details (previous employer) - End Date',
          key: 'person.employments.previous.endDate',
          type: 'date',
          required: false,
          weight: 24
        },

        {
          name: 'Person 3 - Personal details - Title',
          key: 'person.information.title',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 3 - Personal details - Full name',
          key: 'person.information.fullName',
          type: 'string',
          required: true,
          weight: 2
        },
        {
          name: 'Person 3 - Personal details - First name',
          key: 'person.information.firstName',
          type: 'string',
          required: true,
          weight: 3
        },
        {
          name: 'Person 3 - Personal details - Middle name',
          key: 'person.information.middleName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 3 - Personal details - Surname',
          key: 'person.information.familyName',
          type: 'string',
          required: true,
          weight: 5
        },
        {
          name: 'Person 3 - Personal details - Preferred name',
          key: 'person.information.preferredName',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 3 - Personal details - Previous name',
          key: 'person.information.previousName',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 3 - Personal details - Gender',
          key: 'person.information.gender',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 3 - Personal details - Date of birth',
          key: 'person.information.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 3 - Personal details - Notes',
          key: 'description',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 3 - Personal details - Contact owner',
          key: 'person.idOwner',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 3 - Personal details - Contact date created',
          key: 'person.timeStamp',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 3 - Contact details - Mobile phone',
          key: 'person.contact.primary',
          type: 'phone',
          required: false,
          weight: 1
        },
        {
          name: 'Person 3 - Contact details - Home Phone',
          key: 'person.contact.home',
          type: 'phone',
          required: false,
          weight: 2
        },
        {
          name: 'Person 3 - Contact details - Work Phone',
          key: 'person.contact.work',
          type: 'phone',
          required: false,
          weight: 3
        },
        {
          name: 'Person 3 - Contact details - E-Mail 1',
          key: 'person.contact.email',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 3 - Contact details - E-Mail 2',
          key: 'person.contact.secondaryEmail',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 3 - Contact details - Website',
          key: 'person.contact.website',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 3 - Contact details - Current address',
          key: 'person.contact.address.formatted',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 3 - Contact details - Current address unit number',
          key: 'person.contact.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 3 - Contact details - Current address street number',
          key: 'person.contact.address.streetNumber',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 3 - Contact details - Current address street name',
          key: 'person.contact.address.street',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 3 - Contact details - Current address city',
          key: 'person.contact.address.city',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 3 - Contact details - Current address state',
          key: 'person.contact.address.state',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 3 - Contact details - Current address postal code',
          key: 'person.contact.address.postCode',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 3 - Contact details - Current residential status',
          key: 'person.contact.housing',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 3 - Contact details - Current address from',
          key: 'person.contact.from',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 3 - Contact details - Previous address',
          key: 'person.contact.previousAddress.formatted',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 3 - Contact details - Previous address unit number',
          key: 'person.contact.previousAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 3 - Contact details - Previous address street number',
          key: 'person.contact.previousAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 3 - Contact details - Previous address street name',
          key: 'person.contact.previousAddress.street',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 3 - Contact details - Previous address city',
          key: 'person.contact.previousAddress.city',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 3 - Contact details - Previous address state',
          key: 'person.contact.previousAddress.state',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 3 - Contact details - Previous address postal code',
          key: 'person.contact.previousAddress.postCode',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 3 - Contact details - Previous residential status',
          key: 'person.contact.previousHousing',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 3 - Contact details - Previous address from',
          key: 'person.contact.previousFrom',
          type: 'date',
          required: false,
          weight: 22
        },
        {
          name: 'Person 3 - Contact details - Mailing address',
          key: 'person.contact.mailingAddress.formatted',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 3 - Contact details - Mailing address unit number',
          key: 'person.contact.mailingAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 3 - Contact details - Mailing address street number',
          key: 'person.contact.mailingAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Person 3 - Contact details - Mailing address street name',
          key: 'person.contact.mailingAddress.street',
          type: 'string',
          required: false,
          weight: 26
        },
        {
          name: 'Person 3 - Contact details - Mailing address city',
          key: 'person.contact.mailingAddress.city',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Person 3 - Contact details - Mailing address state',
          key: 'person.contact.mailingAddress.state',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Person 3 - Contact details - Mailing address postal code',
          key: 'person.contact.mailingAddress.postCode',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Person 3 - Contact details - Settlement address',
          key: 'person.contact.settlementAddress.formatted',
          type: 'string',
          required: false,
          weight: 30
        },
        {
          name: 'Person 3 - Contact details - Settlement address unit number',
          key: 'person.contact.settlementAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Person 3 - Contact details - Settlement address street number',
          key: 'person.contact.settlementAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Person 3 - Contact details - Settlement address street name',
          key: 'person.contact.settlementAddress.street',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Person 3 - Contact details - Settlement address city',
          key: 'person.contact.settlementAddress.city',
          type: 'string',
          required: false,
          weight: 34
        },
        {
          name: 'Person 3 - Contact details - Settlement address state',
          key: 'person.contact.settlementAddress.state',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Person 3 - Contact details - Settlement address postal code',
          key: 'person.contact.settlementAddress.postCode',
          type: 'string',
          required: false,
          weight: 36
        },
        {
          name: 'Person 3 - Contact details - Settlement residential status',
          key: 'person.contact.settlementHousing',
          type: 'string',
          required: false,
          weight: 37
        },
        {
          name: 'Person 3 - Identification - Country of residency',
          key: 'person.information.countryOfResidency',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 3 - Identification - Country of tax residence',
          key: 'person.information.countryOfTaxResidence',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 3 - Identification - Citizenship of',
          key: 'person.information.citizenship',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 3 - Identification - Residential status',
          key: 'person.information.residentialStatus',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 3 - Identification - Drivers license number',
          key: 'person.information.driversLicenseNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 3 - Identification - Drivers license card number',
          key: 'person.information.driversLicenseCardNumber',
          type: 'string',
          required: false,
          weight: 50
        },
        {
          name: 'Person 3 - Identification - Drivers license version number',
          key: 'person.information.driversLicenseVersionNumber',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Person 3 - Identification - Drivers license name on document',
          key: 'person.information.driversLicenseNameOnDocument',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 3 - Identification - Drivers license state of issue',
          key: 'person.information.driversLicenseStateOfIssue',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 3 - Identification - Drivers license expiry date',
          key: 'person.information.driversLicenseExpiryDate',
          type: 'date',
          required: false,
          weight: 8
        },
        {
          name: 'Person 3 - Identification - Passport number',
          key: 'person.information.passportNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 3 - Identification - Passport name on document',
          key: 'person.information.passportNameOnDocument',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 3 - Identification - Passport issue country',
          key: 'person.information.passportIssueCountry',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 3 - Identification - Passport issue date',
          key: 'person.information.passportIssueDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 3 - Identification - Passport expiry date',
          key: 'person.information.passportExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 3 - Family relations - Marital status',
          key: 'person.information.maritalStatus',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: "Person 3 - Family relations - Mother's maiden name",
          key: 'person.information.mothersMaidenName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 3 - Family relations - Number of dependents',
          key: 'person.information.numberOfDependents',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Person 3 - Family relations - Name of dependent 1',
          key: 'person.information.dependents1.name',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 3 - Family relations - Date of birth of dependent 1',
          key: 'person.information.dependents1.dateOfBirth',
          type: 'date',
          required: false,
          weight: 7
        },
        {
          name: 'Person 3 - Family relations - Name of dependent 2',
          key: 'person.information.dependents2.name',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 3 - Family relations - Date of birth of dependent 2',
          key: 'person.information.dependents2.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 3 - Family relations - Name of dependent 3',
          key: 'person.information.dependents3.name',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 3 - Family relations - Date of birth of dependent 3',
          key: 'person.information.dependents3.dateOfBirth',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 3 - Family relations - Name of dependent 4',
          key: 'person.information.dependents4.name',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 3 - Family relations - Date of birth of dependent 4',
          key: 'person.information.dependents4.dateOfBirth',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Person 3 - Family relations - Name of dependent 5',
          key: 'person.information.dependents5.name',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 3 - Family relations - Date of birth of dependent 5',
          key: 'person.information.dependents5.dateOfBirth',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 3 - Family relations - Next of kin full name',
          key: 'person.information.nextOfKinFullName',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 3 - Family relations - Next of kin address',
          key: 'person.information.nextOfKinAddress.formatted',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 3 - Family relations - Next of kin address unit number',
          key: 'person.information.nextOfKinAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 3 - Family relations - Next of kin address street number',
          key: 'person.information.nextOfKinAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 3 - Family relations - Next of kin address street name',
          key: 'person.information.nextOfKinAddress.street',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 3 - Family relations - Next of kin address city',
          key: 'person.information.nextOfKinAddress.city',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 3 - Family relations - Next of kin address state',
          key: 'person.information.nextOfKinAddress.state',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 3 - Family relations - Next of kin address postal code',
          key: 'person.information.nextOfKinAddress.postCode',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 3 - Family relations - Next of kin relationship',
          key: 'person.information.nextOfKinRelationship',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 3 - Family relations - Next of kin phone',
          key: 'person.information.nextOfKinPhone',
          type: 'phone',
          required: false,
          weight: 25
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employment type',
          key: 'person.employments.current.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employment status',
          key: 'person.employments.current.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employment basis',
          key: 'person.employments.current.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employment on benefits',
          key: 'person.employments.current.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employment student',
          key: 'person.employments.current.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employment home duties',
          key: 'person.employments.current.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 3 - Employments details (current employer) - Role',
          key: 'person.employments.current.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer name',
          key: 'person.employments.current.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer address',
          key: 'person.employments.current.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer address unit number',
          key: 'person.employments.current.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer address street number',
          key: 'person.employments.current.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer address street name',
          key: 'person.employments.current.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer address city',
          key: 'person.employments.current.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer address state',
          key: 'person.employments.current.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer address postal code',
          key: 'person.employments.current.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer contact title',
          key: 'person.employments.current.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer contact first name',
          key: 'person.employments.current.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer contact surname',
          key: 'person.employments.current.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer phone',
          key: 'person.employments.current.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer type',
          key: 'person.employments.current.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer ABN',
          key: 'person.employments.current.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 3 - Employments details (current employer) - Employer ACN',
          key: 'person.employments.current.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 3 - Employments details (current employer) - Start date',
          key: 'person.employments.current.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employment type',
          key: 'person.employments.previous.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employment status',
          key: 'person.employments.previous.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employment basis',
          key: 'person.employments.previous.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employment on benefits',
          key: 'person.employments.previous.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employment student',
          key: 'person.employments.previous.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employment home duties',
          key: 'person.employments.previous.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Role',
          key: 'person.employments.previous.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer name',
          key: 'person.employments.previous.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer address',
          key: 'person.employments.previous.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer address unit number',
          key: 'person.employments.previous.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer address street number',
          key: 'person.employments.previous.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer address street name',
          key: 'person.employments.previous.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer address city',
          key: 'person.employments.previous.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer address state',
          key: 'person.employments.previous.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer address postal code',
          key: 'person.employments.previous.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer contact title',
          key: 'person.employments.previous.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer contact first name',
          key: 'person.employments.previous.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer contact surname',
          key: 'person.employments.previous.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer phone',
          key: 'person.employments.previous.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer type',
          key: 'person.employments.previous.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer ABN',
          key: 'person.employments.previous.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Employer ACN',
          key: 'person.employments.previous.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 3 - Employments details (previous employer) - Start date',
          key: 'person.employments.previous.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 3 - Employments details (previous employer) - End Date',
          key: 'person.employments.previous.endDate',
          type: 'date',
          required: false,
          weight: 24
        },

        {
          name: 'Person 4 - Personal details - Title',
          key: 'person.information.title',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 4 - Personal details - Full name',
          key: 'person.information.fullName',
          type: 'string',
          required: true,
          weight: 2
        },
        {
          name: 'Person 4 - Personal details - First name',
          key: 'person.information.firstName',
          type: 'string',
          required: true,
          weight: 3
        },
        {
          name: 'Person 4 - Personal details - Middle name',
          key: 'person.information.middleName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 4 - Personal details - Surname',
          key: 'person.information.familyName',
          type: 'string',
          required: true,
          weight: 5
        },
        {
          name: 'Person 4 - Personal details - Preferred name',
          key: 'person.information.preferredName',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 4 - Personal details - Previous name',
          key: 'person.information.previousName',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 4 - Personal details - Gender',
          key: 'person.information.gender',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 4 - Personal details - Date of birth',
          key: 'person.information.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 4 - Personal details - Notes',
          key: 'description',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 4 - Personal details - Contact owner',
          key: 'person.idOwner',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 4 - Personal details - Contact date created',
          key: 'person.timeStamp',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 4 - Contact details - Mobile phone',
          key: 'person.contact.primary',
          type: 'phone',
          required: false,
          weight: 1
        },
        {
          name: 'Person 4 - Contact details - Home Phone',
          key: 'person.contact.home',
          type: 'phone',
          required: false,
          weight: 2
        },
        {
          name: 'Person 4 - Contact details - Work Phone',
          key: 'person.contact.work',
          type: 'phone',
          required: false,
          weight: 3
        },
        {
          name: 'Person 4 - Contact details - E-Mail 1',
          key: 'person.contact.email',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 4 - Contact details - E-Mail 2',
          key: 'person.contact.secondaryEmail',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 4 - Contact details - Website',
          key: 'person.contact.website',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 4 - Contact details - Current address',
          key: 'person.contact.address.formatted',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 4 - Contact details - Current address unit number',
          key: 'person.contact.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 4 - Contact details - Current address street number',
          key: 'person.contact.address.streetNumber',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 4 - Contact details - Current address street name',
          key: 'person.contact.address.street',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 4 - Contact details - Current address city',
          key: 'person.contact.address.city',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 4 - Contact details - Current address state',
          key: 'person.contact.address.state',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 4 - Contact details - Current address postal code',
          key: 'person.contact.address.postCode',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 4 - Contact details - Current residential status',
          key: 'person.contact.housing',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 4 - Contact details - Current address from',
          key: 'person.contact.from',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 4 - Contact details - Previous address',
          key: 'person.contact.previousAddress.formatted',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 4 - Contact details - Previous address unit number',
          key: 'person.contact.previousAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 4 - Contact details - Previous address street number',
          key: 'person.contact.previousAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 4 - Contact details - Previous address street name',
          key: 'person.contact.previousAddress.street',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 4 - Contact details - Previous address city',
          key: 'person.contact.previousAddress.city',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 4 - Contact details - Previous address state',
          key: 'person.contact.previousAddress.state',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 4 - Contact details - Previous address postal code',
          key: 'person.contact.previousAddress.postCode',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 4 - Contact details - Previous residential status',
          key: 'person.contact.previousHousing',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 4 - Contact details - Previous address from',
          key: 'person.contact.previousFrom',
          type: 'date',
          required: false,
          weight: 22
        },
        {
          name: 'Person 4 - Contact details - Mailing address',
          key: 'person.contact.mailingAddress.formatted',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 4 - Contact details - Mailing address unit number',
          key: 'person.contact.mailingAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 4 - Contact details - Mailing address street number',
          key: 'person.contact.mailingAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Person 4 - Contact details - Mailing address street name',
          key: 'person.contact.mailingAddress.street',
          type: 'string',
          required: false,
          weight: 26
        },
        {
          name: 'Person 4 - Contact details - Mailing address city',
          key: 'person.contact.mailingAddress.city',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Person 4 - Contact details - Mailing address state',
          key: 'person.contact.mailingAddress.state',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Person 4 - Contact details - Mailing address postal code',
          key: 'person.contact.mailingAddress.postCode',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Person 4 - Contact details - Settlement address',
          key: 'person.contact.settlementAddress.formatted',
          type: 'string',
          required: false,
          weight: 30
        },
        {
          name: 'Person 4 - Contact details - Settlement address unit number',
          key: 'person.contact.settlementAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Person 4 - Contact details - Settlement address street number',
          key: 'person.contact.settlementAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Person 4 - Contact details - Settlement address street name',
          key: 'person.contact.settlementAddress.street',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Person 4 - Contact details - Settlement address city',
          key: 'person.contact.settlementAddress.city',
          type: 'string',
          required: false,
          weight: 34
        },
        {
          name: 'Person 4 - Contact details - Settlement address state',
          key: 'person.contact.settlementAddress.state',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Person 4 - Contact details - Settlement address postal code',
          key: 'person.contact.settlementAddress.postCode',
          type: 'string',
          required: false,
          weight: 36
        },
        {
          name: 'Person 4 - Contact details - Settlement residential status',
          key: 'person.contact.settlementHousing',
          type: 'string',
          required: false,
          weight: 37
        },
        {
          name: 'Person 4 - Identification - Country of residency',
          key: 'person.information.countryOfResidency',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 4 - Identification - Country of tax residence',
          key: 'person.information.countryOfTaxResidence',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 4 - Identification - Citizenship of',
          key: 'person.information.citizenship',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 4 - Identification - Residential status',
          key: 'person.information.residentialStatus',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 4 - Identification - Drivers license number',
          key: 'person.information.driversLicenseNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 4 - Identification - Drivers license card number',
          key: 'person.information.driversLicenseCardNumber',
          type: 'string',
          required: false,
          weight: 50
        },
        {
          name: 'Person 4 - Identification - Drivers license version number',
          key: 'person.information.driversLicenseVersionNumber',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Person 4 - Identification - Drivers license name on document',
          key: 'person.information.driversLicenseNameOnDocument',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 4 - Identification - Drivers license state of issue',
          key: 'person.information.driversLicenseStateOfIssue',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 4 - Identification - Drivers license expiry date',
          key: 'person.information.driversLicenseExpiryDate',
          type: 'date',
          required: false,
          weight: 8
        },
        {
          name: 'Person 4 - Identification - Passport number',
          key: 'person.information.passportNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 4 - Identification - Passport name on document',
          key: 'person.information.passportNameOnDocument',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 4 - Identification - Passport issue country',
          key: 'person.information.passportIssueCountry',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 4 - Identification - Passport issue date',
          key: 'person.information.passportIssueDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 4 - Identification - Passport expiry date',
          key: 'person.information.passportExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 4 - Family relations - Marital status',
          key: 'person.information.maritalStatus',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: "Person 4 - Family relations - Mother's maiden name",
          key: 'person.information.mothersMaidenName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 4 - Family relations - Number of dependents',
          key: 'person.information.numberOfDependents',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Person 4 - Family relations - Name of dependent 1',
          key: 'person.information.dependents1.name',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 4 - Family relations - Date of birth of dependent 1',
          key: 'person.information.dependents1.dateOfBirth',
          type: 'date',
          required: false,
          weight: 7
        },
        {
          name: 'Person 4 - Family relations - Name of dependent 2',
          key: 'person.information.dependents2.name',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 4 - Family relations - Date of birth of dependent 2',
          key: 'person.information.dependents2.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 4 - Family relations - Name of dependent 3',
          key: 'person.information.dependents3.name',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 4 - Family relations - Date of birth of dependent 3',
          key: 'person.information.dependents3.dateOfBirth',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 4 - Family relations - Name of dependent 4',
          key: 'person.information.dependents4.name',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 4 - Family relations - Date of birth of dependent 4',
          key: 'person.information.dependents4.dateOfBirth',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Person 4 - Family relations - Name of dependent 5',
          key: 'person.information.dependents5.name',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 4 - Family relations - Date of birth of dependent 5',
          key: 'person.information.dependents5.dateOfBirth',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 4 - Family relations - Next of kin full name',
          key: 'person.information.nextOfKinFullName',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 4 - Family relations - Next of kin address',
          key: 'person.information.nextOfKinAddress.formatted',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 4 - Family relations - Next of kin address unit number',
          key: 'person.information.nextOfKinAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 4 - Family relations - Next of kin address street number',
          key: 'person.information.nextOfKinAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 4 - Family relations - Next of kin address street name',
          key: 'person.information.nextOfKinAddress.street',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 4 - Family relations - Next of kin address city',
          key: 'person.information.nextOfKinAddress.city',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 4 - Family relations - Next of kin address state',
          key: 'person.information.nextOfKinAddress.state',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 4 - Family relations - Next of kin address postal code',
          key: 'person.information.nextOfKinAddress.postCode',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 4 - Family relations - Next of kin relationship',
          key: 'person.information.nextOfKinRelationship',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 4 - Family relations - Next of kin phone',
          key: 'person.information.nextOfKinPhone',
          type: 'phone',
          required: false,
          weight: 25
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employment type',
          key: 'person.employments.current.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employment status',
          key: 'person.employments.current.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employment basis',
          key: 'person.employments.current.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employment on benefits',
          key: 'person.employments.current.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employment student',
          key: 'person.employments.current.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employment home duties',
          key: 'person.employments.current.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 4 - Employments details (current employer) - Role',
          key: 'person.employments.current.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer name',
          key: 'person.employments.current.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer address',
          key: 'person.employments.current.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer address unit number',
          key: 'person.employments.current.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer address street number',
          key: 'person.employments.current.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer address street name',
          key: 'person.employments.current.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer address city',
          key: 'person.employments.current.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer address state',
          key: 'person.employments.current.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer address postal code',
          key: 'person.employments.current.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer contact title',
          key: 'person.employments.current.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer contact first name',
          key: 'person.employments.current.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer contact surname',
          key: 'person.employments.current.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer phone',
          key: 'person.employments.current.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer type',
          key: 'person.employments.current.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer ABN',
          key: 'person.employments.current.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 4 - Employments details (current employer) - Employer ACN',
          key: 'person.employments.current.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 4 - Employments details (current employer) - Start date',
          key: 'person.employments.current.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employment type',
          key: 'person.employments.previous.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employment status',
          key: 'person.employments.previous.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employment basis',
          key: 'person.employments.previous.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employment on benefits',
          key: 'person.employments.previous.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employment student',
          key: 'person.employments.previous.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employment home duties',
          key: 'person.employments.previous.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Role',
          key: 'person.employments.previous.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer name',
          key: 'person.employments.previous.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer address',
          key: 'person.employments.previous.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer address unit number',
          key: 'person.employments.previous.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer address street number',
          key: 'person.employments.previous.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer address street name',
          key: 'person.employments.previous.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer address city',
          key: 'person.employments.previous.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer address state',
          key: 'person.employments.previous.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer address postal code',
          key: 'person.employments.previous.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer contact title',
          key: 'person.employments.previous.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer contact first name',
          key: 'person.employments.previous.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer contact surname',
          key: 'person.employments.previous.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer phone',
          key: 'person.employments.previous.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer type',
          key: 'person.employments.previous.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer ABN',
          key: 'person.employments.previous.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Employer ACN',
          key: 'person.employments.previous.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 4 - Employments details (previous employer) - Start date',
          key: 'person.employments.previous.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 4 - Employments details (previous employer) - End Date',
          key: 'person.employments.previous.endDate',
          type: 'date',
          required: false,
          weight: 24
        },

        {
          name: 'Person 5 - Personal details - Title',
          key: 'person.information.title',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 5 - Personal details - Full name',
          key: 'person.information.fullName',
          type: 'string',
          required: true,
          weight: 2
        },
        {
          name: 'Person 5 - Personal details - First name',
          key: 'person.information.firstName',
          type: 'string',
          required: true,
          weight: 3
        },
        {
          name: 'Person 5 - Personal details - Middle name',
          key: 'person.information.middleName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 5 - Personal details - Surname',
          key: 'person.information.familyName',
          type: 'string',
          required: true,
          weight: 5
        },
        {
          name: 'Person 5 - Personal details - Preferred name',
          key: 'person.information.preferredName',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 5 - Personal details - Previous name',
          key: 'person.information.previousName',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 5 - Personal details - Gender',
          key: 'person.information.gender',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 5 - Personal details - Date of birth',
          key: 'person.information.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 5 - Personal details - Notes',
          key: 'description',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 5 - Personal details - Contact owner',
          key: 'person.idOwner',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 5 - Personal details - Contact date created',
          key: 'person.timeStamp',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 5 - Contact details - Mobile phone',
          key: 'person.contact.primary',
          type: 'phone',
          required: false,
          weight: 1
        },
        {
          name: 'Person 5 - Contact details - Home Phone',
          key: 'person.contact.home',
          type: 'phone',
          required: false,
          weight: 2
        },
        {
          name: 'Person 5 - Contact details - Work Phone',
          key: 'person.contact.work',
          type: 'phone',
          required: false,
          weight: 3
        },
        {
          name: 'Person 5 - Contact details - E-Mail 1',
          key: 'person.contact.email',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 5 - Contact details - E-Mail 2',
          key: 'person.contact.secondaryEmail',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 5 - Contact details - Website',
          key: 'person.contact.website',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 5 - Contact details - Current address',
          key: 'person.contact.address.formatted',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 5 - Contact details - Current address unit number',
          key: 'person.contact.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 5 - Contact details - Current address street number',
          key: 'person.contact.address.streetNumber',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 5 - Contact details - Current address street name',
          key: 'person.contact.address.street',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 5 - Contact details - Current address city',
          key: 'person.contact.address.city',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 5 - Contact details - Current address state',
          key: 'person.contact.address.state',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 5 - Contact details - Current address postal code',
          key: 'person.contact.address.postCode',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 5 - Contact details - Current residential status',
          key: 'person.contact.housing',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 5 - Contact details - Current address from',
          key: 'person.contact.from',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 5 - Contact details - Previous address',
          key: 'person.contact.previousAddress.formatted',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 5 - Contact details - Previous address unit number',
          key: 'person.contact.previousAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 5 - Contact details - Previous address street number',
          key: 'person.contact.previousAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 5 - Contact details - Previous address street name',
          key: 'person.contact.previousAddress.street',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 5 - Contact details - Previous address city',
          key: 'person.contact.previousAddress.city',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 5 - Contact details - Previous address state',
          key: 'person.contact.previousAddress.state',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 5 - Contact details - Previous address postal code',
          key: 'person.contact.previousAddress.postCode',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 5 - Contact details - Previous residential status',
          key: 'person.contact.previousHousing',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 5 - Contact details - Previous address from',
          key: 'person.contact.previousFrom',
          type: 'date',
          required: false,
          weight: 22
        },
        {
          name: 'Person 5 - Contact details - Mailing address',
          key: 'person.contact.mailingAddress.formatted',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 5 - Contact details - Mailing address unit number',
          key: 'person.contact.mailingAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 5 - Contact details - Mailing address street number',
          key: 'person.contact.mailingAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Person 5 - Contact details - Mailing address street name',
          key: 'person.contact.mailingAddress.street',
          type: 'string',
          required: false,
          weight: 26
        },
        {
          name: 'Person 5 - Contact details - Mailing address city',
          key: 'person.contact.mailingAddress.city',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Person 5 - Contact details - Mailing address state',
          key: 'person.contact.mailingAddress.state',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Person 5 - Contact details - Mailing address postal code',
          key: 'person.contact.mailingAddress.postCode',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Person 5 - Contact details - Settlement address',
          key: 'person.contact.settlementAddress.formatted',
          type: 'string',
          required: false,
          weight: 30
        },
        {
          name: 'Person 5 - Contact details - Settlement address unit number',
          key: 'person.contact.settlementAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 31
        },
        {
          name: 'Person 5 - Contact details - Settlement address street number',
          key: 'person.contact.settlementAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 32
        },
        {
          name: 'Person 5 - Contact details - Settlement address street name',
          key: 'person.contact.settlementAddress.street',
          type: 'string',
          required: false,
          weight: 33
        },
        {
          name: 'Person 5 - Contact details - Settlement address city',
          key: 'person.contact.settlementAddress.city',
          type: 'string',
          required: false,
          weight: 34
        },
        {
          name: 'Person 5 - Contact details - Settlement address state',
          key: 'person.contact.settlementAddress.state',
          type: 'string',
          required: false,
          weight: 35
        },
        {
          name: 'Person 5 - Contact details - Settlement address postal code',
          key: 'person.contact.settlementAddress.postCode',
          type: 'string',
          required: false,
          weight: 36
        },
        {
          name: 'Person 5 - Contact details - Settlement residential status',
          key: 'person.contact.settlementHousing',
          type: 'string',
          required: false,
          weight: 37
        },
        {
          name: 'Person 5 - Identification - Country of residency',
          key: 'person.information.countryOfResidency',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 5 - Identification - Country of tax residence',
          key: 'person.information.countryOfTaxResidence',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 5 - Identification - Citizenship of',
          key: 'person.information.citizenship',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 5 - Identification - Residential status',
          key: 'person.information.residentialStatus',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 5 - Identification - Drivers license number',
          key: 'person.information.driversLicenseNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 5 - Identification - Drivers license card number',
          key: 'person.information.driversLicenseCardNumber',
          type: 'string',
          required: false,
          weight: 50
        },
        {
          name: 'Person 5 - Identification - Drivers license version number',
          key: 'person.information.driversLicenseVersionNumber',
          type: 'string',
          required: false,
          weight: 51
        },
        {
          name: 'Person 5 - Identification - Drivers license name on document',
          key: 'person.information.driversLicenseNameOnDocument',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 5 - Identification - Drivers license state of issue',
          key: 'person.information.driversLicenseStateOfIssue',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 5 - Identification - Drivers license expiry date',
          key: 'person.information.driversLicenseExpiryDate',
          type: 'date',
          required: false,
          weight: 8
        },
        {
          name: 'Person 5 - Identification - Passport number',
          key: 'person.information.passportNumber',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 5 - Identification - Passport name on document',
          key: 'person.information.passportNameOnDocument',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 5 - Identification - Passport issue country',
          key: 'person.information.passportIssueCountry',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 5 - Identification - Passport issue date',
          key: 'person.information.passportIssueDate',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 5 - Identification - Passport expiry date',
          key: 'person.information.passportExpiryDate',
          type: 'date',
          required: false,
          weight: 12
        },
        {
          name: 'Person 5 - Family relations - Marital status',
          key: 'person.information.maritalStatus',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: "Person 5 - Family relations - Mother's maiden name",
          key: 'person.information.mothersMaidenName',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 5 - Family relations - Number of dependents',
          key: 'person.information.numberOfDependents',
          type: 'number',
          required: false,
          weight: 5
        },
        {
          name: 'Person 5 - Family relations - Name of dependent 1',
          key: 'person.information.dependents1.name',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 5 - Family relations - Date of birth of dependent 1',
          key: 'person.information.dependents1.dateOfBirth',
          type: 'date',
          required: false,
          weight: 7
        },
        {
          name: 'Person 5 - Family relations - Name of dependent 2',
          key: 'person.information.dependents2.name',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 5 - Family relations - Date of birth of dependent 2',
          key: 'person.information.dependents2.dateOfBirth',
          type: 'date',
          required: false,
          weight: 9
        },
        {
          name: 'Person 5 - Family relations - Name of dependent 3',
          key: 'person.information.dependents3.name',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 5 - Family relations - Date of birth of dependent 3',
          key: 'person.information.dependents3.dateOfBirth',
          type: 'date',
          required: false,
          weight: 11
        },
        {
          name: 'Person 5 - Family relations - Name of dependent 4',
          key: 'person.information.dependents4.name',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 5 - Family relations - Date of birth of dependent 4',
          key: 'person.information.dependents4.dateOfBirth',
          type: 'date',
          required: false,
          weight: 13
        },
        {
          name: 'Person 5 - Family relations - Name of dependent 5',
          key: 'person.information.dependents5.name',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 5 - Family relations - Date of birth of dependent 5',
          key: 'person.information.dependents5.dateOfBirth',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Person 5 - Family relations - Next of kin full name',
          key: 'person.information.nextOfKinFullName',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 5 - Family relations - Next of kin address',
          key: 'person.information.nextOfKinAddress.formatted',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 5 - Family relations - Next of kin address unit number',
          key: 'person.information.nextOfKinAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 5 - Family relations - Next of kin address street number',
          key: 'person.information.nextOfKinAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Person 5 - Family relations - Next of kin address street name',
          key: 'person.information.nextOfKinAddress.street',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 5 - Family relations - Next of kin address city',
          key: 'person.information.nextOfKinAddress.city',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 5 - Family relations - Next of kin address state',
          key: 'person.information.nextOfKinAddress.state',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 5 - Family relations - Next of kin address postal code',
          key: 'person.information.nextOfKinAddress.postCode',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Person 5 - Family relations - Next of kin relationship',
          key: 'person.information.nextOfKinRelationship',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Person 5 - Family relations - Next of kin phone',
          key: 'person.information.nextOfKinPhone',
          type: 'phone',
          required: false,
          weight: 25
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employment type',
          key: 'person.employments.current.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employment status',
          key: 'person.employments.current.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employment basis',
          key: 'person.employments.current.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employment on benefits',
          key: 'person.employments.current.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employment student',
          key: 'person.employments.current.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employment home duties',
          key: 'person.employments.current.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 5 - Employments details (current employer) - Role',
          key: 'person.employments.current.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer name',
          key: 'person.employments.current.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer address',
          key: 'person.employments.current.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer address unit number',
          key: 'person.employments.current.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer address street number',
          key: 'person.employments.current.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer address street name',
          key: 'person.employments.current.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer address city',
          key: 'person.employments.current.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer address state',
          key: 'person.employments.current.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer address postal code',
          key: 'person.employments.current.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer contact title',
          key: 'person.employments.current.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer contact first name',
          key: 'person.employments.current.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer contact surname',
          key: 'person.employments.current.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer phone',
          key: 'person.employments.current.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer type',
          key: 'person.employments.current.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer ABN',
          key: 'person.employments.current.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 5 - Employments details (current employer) - Employer ACN',
          key: 'person.employments.current.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 5 - Employments details (current employer) - Start date',
          key: 'person.employments.current.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employment type',
          key: 'person.employments.previous.type',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employment status',
          key: 'person.employments.previous.status',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employment basis',
          key: 'person.employments.previous.basis',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employment on benefits',
          key: 'person.employments.previous.subTypes.onBenefits',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employment student',
          key: 'person.employments.previous.subTypes.student',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employment home duties',
          key: 'person.employments.previous.subTypes.homeDuties',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Role',
          key: 'person.employments.previous.role',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer name',
          key: 'person.employments.previous.employerName',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer address',
          key: 'person.employments.previous.employerAddress.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer address unit number',
          key: 'person.employments.previous.employerAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer address street number',
          key: 'person.employments.previous.employerAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer address street name',
          key: 'person.employments.previous.employerAddress.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer address city',
          key: 'person.employments.previous.employerAddress.city',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer address state',
          key: 'person.employments.previous.employerAddress.state',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer address postal code',
          key: 'person.employments.previous.employerAddress.postCode',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer contact title',
          key: 'person.employments.previous.employerContactTitle',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer contact first name',
          key: 'person.employments.previous.employerContactFirstName',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer contact surname',
          key: 'person.employments.previous.employerContactSurname',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer phone',
          key: 'person.employments.previous.employerPhone',
          type: 'phone',
          required: false,
          weight: 19
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer type',
          key: 'person.employments.previous.employerType',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer ABN',
          key: 'person.employments.previous.employerAbn',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Employer ACN',
          key: 'person.employments.previous.employerAcn',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Person 5 - Employments details (previous employer) - Start date',
          key: 'person.employments.previous.startDate',
          type: 'date',
          required: false,
          weight: 23
        },
        {
          name: 'Person 5 - Employments details (previous employer) - End Date',
          key: 'person.employments.previous.endDate',
          type: 'date',
          required: false,
          weight: 24
        }
      ],
      CONTACT_COMPANY: [
        {
          name: 'Company - Company details - Entity name',
          key: 'company.information.name',
          type: 'string',
          required: true,
          weight: 1
        },
        {
          name: 'Company - Company details - Type of business entity',
          key: 'company.information.typeOfBusinessEntity',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Company - Company details - Entity/Business number',
          key: 'company.information.refNumber',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Company - Company details - Incorporated date',
          key: 'company.information.incorporated',
          type: 'date',
          required: false,
          weight: 4
        },
        {
          name: 'Company - Company details - Date of registration',
          key: 'company.information.dateOfRegistration',
          type: 'date',
          required: false,
          weight: 5
        },
        {
          name: 'Company - Company details - Trading name',
          key: 'company.information.tradingName',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Company - Company details - State of registration',
          key: 'company.information.stateOfRegistration',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Company - Company details - Industry code',
          key: 'company.information.industryCode',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Company - Company details - Business type',
          key: 'company.information.businessType',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Company - Company details - Number of employees',
          key: 'company.information.numberOfEmployees',
          type: 'number',
          required: false,
          weight: 10
        },
        {
          name: 'Company - Company details - GST/VAT registered',
          key: 'company.information.isVatRegistered',
          type: 'boolean',
          required: false,
          weight: 8
        },
        {
          name: 'Company - Company details - GST/VAT registered date',
          key: 'company.information.vatRegisteredDate',
          type: 'date',
          required: false,
          weight: 5
        },
        {
          name: 'Company - Company details - Acting on behalf trust',
          key: 'company.information.isActingOnBehalfTrust',
          type: 'boolean',
          required: false,
          weight: 9
        },
        {
          name: 'Company - Company details - Trust name',
          key: 'company.information.trustName',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Company - Company details - Trust business number',
          key: 'company.information.trustRefNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Company - Company details - Trust structure',
          key: 'company.information.trustStructure',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Company - Company details - Settlor',
          key: 'company.information.settlor',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Company - Company details - Contact owner',
          key: 'company.idOwner',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Company - Company details - Contact date created',
          key: 'company.timeStamp',
          type: 'date',
          required: false,
          weight: 15
        },
        {
          name: 'Company - Company details - Notes',
          key: 'description',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Company - Contact details - Mobile phone',
          key: 'company.contact.phone',
          type: 'phone',
          required: false,
          weight: 1
        },
        {
          name: 'Company - Contact details - E-Mail',
          key: 'company.contact.email',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Company - Contact details - Website',
          key: 'company.contact.website',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Company - Contact details - Current address',
          key: 'company.contact.address.formatted',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Company - Contact details - Current address unit number',
          key: 'company.contact.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Company - Contact details - Current address street number',
          key: 'company.contact.address.streetNumber',
          type: 'string',
          required: false,
          weight: 6
        },
        {
          name: 'Company - Contact details - Current address street name',
          key: 'company.contact.address.street',
          type: 'string',
          required: false,
          weight: 7
        },
        {
          name: 'Company - Contact details - Current address city',
          key: 'company.contact.address.city',
          type: 'string',
          required: false,
          weight: 8
        },
        {
          name: 'Company - Contact details - Current address state',
          key: 'company.contact.address.state',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Company - Contact details - Current address postal code',
          key: 'company.contact.address.postCode',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Company - Contact details - Mailing address',
          key: 'company.contact.mailingAddress.formatted',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Company - Contact details - Mailing address unit number',
          key: 'company.contact.mailingAddress.suiteNumber',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Company - Contact details - Mailing address street number',
          key: 'company.contact.mailingAddress.streetNumber',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Company - Contact details - Mailing address street name',
          key: 'company.contact.mailingAddress.street',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Company - Contact details - Mailing address city',
          key: 'company.contact.mailingAddress.city',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Company - Contact details - Mailing address state',
          key: 'company.contact.mailingAddress.state',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Company - Contact details - Mailing address postal code',
          key: 'company.contact.mailingAddress.postCode',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Company - Contact details - Fax number',
          key: 'company.contact.fax',
          type: 'phone',
          required: false,
          weight: 18
        },
        {
          name: 'Company - Contact details - Contact first name',
          key: 'company.contact.contactFirstName',
          type: 'string',
          required: false,
          weight: 19
        },
        {
          name: 'Company - Contact details - Contact surname',
          key: 'company.contact.contactSurname',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Company - Contact details - Contact mobile phone',
          key: 'company.contact.contactMobilePhone',
          type: 'phone',
          required: false,
          weight: 21
        },
        {
          name: 'Company - Contact details - Contact Email',
          key: 'company.contact.contactEmail',
          type: 'string',
          required: false,
          weight: 22
        }
      ],
      NOTE: [
        {
          name: 'Note - Basic information - Deal title',
          key: 'dealTitle',
          type: 'string',
          required: true,
          weight: 1
        },
        {
          name: 'Note - Basic information - Owner',
          key: 'idOwner',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Note - Basic information - Content',
          key: 'content',
          type: 'string',
          required: true,
          weight: 3
        },
        {
          name: 'Note - Basic information - Date created',
          key: 'timeStamp',
          type: 'date',
          required: false,
          weight: 4
        }
      ],
      JOB: [
        {
          name: 'Task - Basic information - Title',
          key: 'name',
          type: 'string',
          required: true,
          weight: 1
        },
        {
          name: 'Task - Basic information - Assigned to',
          key: 'idAssignedTo',
          type: 'string',
          required: true,
          weight: 2
        },
        {
          name: 'Task - Basic information - Due date',
          key: 'absoluteDueDate',
          type: 'date',
          required: true,
          weight: 2
        },
        {
          name: 'Task - Basic information - Description',
          key: 'description',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Task - Basic information - Deal title',
          key: 'dealTitle',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Task - Basic information - Owner',
          key: 'idOwner',
          type: 'string',
          required: false,
          weight: 5
        },
        {
          name: 'Task - Basic information - Date created',
          key: 'timeStamp',
          type: 'date',
          required: false,
          weight: 6
        }
      ],
      ACCOUNT: [
        {
          name: 'Account - Basic information - Title',
          key: 'user.title',
          type: 'string',
          required: false,
          weight: 1
        },
        {
          name: 'Account - Basic information - First name',
          key: 'user.firstName',
          type: 'string',
          required: false,
          weight: 2
        },
        {
          name: 'Account - Basic information - Surname',
          key: 'user.lastName',
          type: 'string',
          required: false,
          weight: 3
        },
        {
          name: 'Account - Basic information - Email',
          key: 'user.eMail',
          type: 'string',
          required: false,
          weight: 4
        },
        {
          name: 'Account - Basic information - Mobile phone prefix',
          key: 'user.prefix',
          type: 'phone',
          required: false,
          weight: 5
        },
        {
          name: 'Account - Basic information - Mobile phone',
          key: 'user.phone',
          type: 'phone',
          required: false,
          weight: 6
        },
        {
          name: 'Account - Basic information - Fixed phone prefix',
          key: 'user.fixedPrefix',
          type: 'phone',
          required: false,
          weight: 7
        },
        {
          name: 'Account - Basic information - Fixed phone',
          key: 'user.fixedPhone',
          type: 'phone',
          required: false,
          weight: 8
        },
        {
          name: 'Account - Basic information - Full address',
          key: 'user.address.formatted',
          type: 'string',
          required: false,
          weight: 9
        },
        {
          name: 'Account - Basic information - Address unit number',
          key: 'user.address.suiteNumber',
          type: 'string',
          required: false,
          weight: 10
        },
        {
          name: 'Account - Basic information - Address street number',
          key: 'user.address.streetNumber',
          type: 'string',
          required: false,
          weight: 11
        },
        {
          name: 'Account - Basic information - Address street name',
          key: 'user.address.street',
          type: 'string',
          required: false,
          weight: 12
        },
        {
          name: 'Account - Basic information - Address street type',
          key: 'user.address.streetType',
          type: 'string',
          required: false,
          weight: 13
        },
        {
          name: 'Account - Basic information - Address city',
          key: 'user.address.city',
          type: 'string',
          required: false,
          weight: 14
        },
        {
          name: 'Account - Basic information - Address suburb',
          key: 'user.address.suburb',
          type: 'string',
          required: false,
          weight: 15
        },
        {
          name: 'Account - Basic information - Address state',
          key: 'user.address.state',
          type: 'string',
          required: false,
          weight: 16
        },
        {
          name: 'Account - Basic information - Address postal code',
          key: 'user.address.postCode',
          type: 'string',
          required: false,
          weight: 17
        },
        {
          name: 'Account - Basic information - Address country',
          key: 'user.address.country',
          type: 'string',
          required: false,
          weight: 18
        },
        {
          name: 'Account - Basic information - Professional license Institution #1',
          key: 'user.licenses.in1',
          type: 'string',
          required: false,
          weight: 20
        },
        {
          name: 'Account - Basic information - Professional license Institution #2',
          key: 'user.licenses.in2',
          type: 'string',
          required: false,
          weight: 21
        },
        {
          name: 'Account - Basic information - Professional license Institution #3',
          key: 'user.licenses.in3',
          type: 'string',
          required: false,
          weight: 22
        },
        {
          name: 'Account - Basic information - Professional license Institution #4',
          key: 'user.licenses.in4',
          type: 'string',
          required: false,
          weight: 23
        },
        {
          name: 'Account - Basic information - Professional license Institution #5',
          key: 'user.licenses.in5',
          type: 'string',
          required: false,
          weight: 24
        },
        {
          name: 'Account - Basic information - Professional license Institution #6',
          key: 'user.licenses.in6',
          type: 'string',
          required: false,
          weight: 25
        },
        {
          name: 'Account - Basic information - Professional license ID #1',
          key: 'user.licenses.id1',
          type: 'string',
          required: false,
          weight: 26
        },
        {
          name: 'Account - Basic information - Professional license ID #2',
          key: 'user.licenses.id2',
          type: 'string',
          required: false,
          weight: 27
        },
        {
          name: 'Account - Basic information - Professional license ID #3',
          key: 'user.licenses.id3',
          type: 'string',
          required: false,
          weight: 28
        },
        {
          name: 'Account - Basic information - Professional license ID #4',
          key: 'user.licenses.id4',
          type: 'string',
          required: false,
          weight: 29
        },
        {
          name: 'Account - Basic information - Professional license ID #5',
          key: 'user.licenses.id5',
          type: 'string',
          required: false,
          weight: 30
        },
        {
          name: 'Account - Basic information - Professional license ID #6',
          key: 'user.licenses.id6',
          type: 'string',
          required: false,
          weight: 31
        }
      ]
    },
    CACHE: {
      NAME: 'importCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
